/*! Hammer.JS - v2.0.8 - 2016-04-23
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
!(function(a, b, c, d) {
  'use strict';
  function e(a, b, c) {
    return setTimeout(j(a, c), b);
  }
  function f(a, b, c) {
    return Array.isArray(a) ? (g(a, c[b], c), !0) : !1;
  }
  function g(a, b, c) {
    var e;
    if (a)
      if (a.forEach) a.forEach(b, c);
      else if (a.length !== d) for (e = 0; e < a.length; ) b.call(c, a[e], e, a), e++;
      else for (e in a) a.hasOwnProperty(e) && b.call(c, a[e], e, a);
  }
  function h(b, c, d) {
    var e = 'DEPRECATED METHOD: ' + c + '\n' + d + ' AT \n';
    return function() {
      var c = new Error('get-stack-trace'),
        d =
          c && c.stack
            ? c.stack
                .replace(/^[^\(]+?[\n$]/gm, '')
                .replace(/^\s+at\s+/gm, '')
                .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@')
            : 'Unknown Stack Trace',
        f = a.console && (a.console.warn || a.console.log);
      return f && f.call(a.console, e, d), b.apply(this, arguments);
    };
  }
  function i(a, b, c) {
    var d,
      e = b.prototype;
    (d = a.prototype = Object.create(e)), (d.constructor = a), (d._super = e), c && la(d, c);
  }
  function j(a, b) {
    return function() {
      return a.apply(b, arguments);
    };
  }
  function k(a, b) {
    return typeof a == oa ? a.apply(b ? b[0] || d : d, b) : a;
  }
  function l(a, b) {
    return a === d ? b : a;
  }
  function m(a, b, c) {
    g(q(b), function(b) {
      a.addEventListener(b, c, !1);
    });
  }
  function n(a, b, c) {
    g(q(b), function(b) {
      a.removeEventListener(b, c, !1);
    });
  }
  function o(a, b) {
    for (; a; ) {
      if (a == b) return !0;
      a = a.parentNode;
    }
    return !1;
  }
  function p(a, b) {
    return a.indexOf(b) > -1;
  }
  function q(a) {
    return a.trim().split(/\s+/g);
  }
  function r(a, b, c) {
    if (a.indexOf && !c) return a.indexOf(b);
    for (var d = 0; d < a.length; ) {
      if ((c && a[d][c] == b) || (!c && a[d] === b)) return d;
      d++;
    }
    return -1;
  }
  function s(a) {
    return Array.prototype.slice.call(a, 0);
  }
  function t(a, b, c) {
    for (var d = [], e = [], f = 0; f < a.length; ) {
      var g = b ? a[f][b] : a[f];
      r(e, g) < 0 && d.push(a[f]), (e[f] = g), f++;
    }
    return (
      c &&
        (d = b
          ? d.sort(function(a, c) {
              return a[b] > c[b];
            })
          : d.sort()),
      d
    );
  }
  function u(a, b) {
    for (var c, e, f = b[0].toUpperCase() + b.slice(1), g = 0; g < ma.length; ) {
      if (((c = ma[g]), (e = c ? c + f : b), e in a)) return e;
      g++;
    }
    return d;
  }
  function v() {
    return ua++;
  }
  function w(b) {
    var c = b.ownerDocument || b;
    return c.defaultView || c.parentWindow || a;
  }
  function x(a, b) {
    var c = this;
    (this.manager = a),
      (this.callback = b),
      (this.element = a.element),
      (this.target = a.options.inputTarget),
      (this.domHandler = function(b) {
        k(a.options.enable, [a]) && c.handler(b);
      }),
      this.init();
  }
  function y(a) {
    var b,
      c = a.options.inputClass;
    return new (b = c ? c : xa ? M : ya ? P : wa ? R : L)(a, z);
  }
  function z(a, b, c) {
    var d = c.pointers.length,
      e = c.changedPointers.length,
      f = b & Ea && d - e === 0,
      g = b & (Ga | Ha) && d - e === 0;
    (c.isFirst = !!f),
      (c.isFinal = !!g),
      f && (a.session = {}),
      (c.eventType = b),
      A(a, c),
      a.emit('hammer.input', c),
      a.recognize(c),
      (a.session.prevInput = c);
  }
  function A(a, b) {
    var c = a.session,
      d = b.pointers,
      e = d.length;
    c.firstInput || (c.firstInput = D(b)), e > 1 && !c.firstMultiple ? (c.firstMultiple = D(b)) : 1 === e && (c.firstMultiple = !1);
    var f = c.firstInput,
      g = c.firstMultiple,
      h = g ? g.center : f.center,
      i = (b.center = E(d));
    (b.timeStamp = ra()),
      (b.deltaTime = b.timeStamp - f.timeStamp),
      (b.angle = I(h, i)),
      (b.distance = H(h, i)),
      B(c, b),
      (b.offsetDirection = G(b.deltaX, b.deltaY));
    var j = F(b.deltaTime, b.deltaX, b.deltaY);
    (b.overallVelocityX = j.x),
      (b.overallVelocityY = j.y),
      (b.overallVelocity = qa(j.x) > qa(j.y) ? j.x : j.y),
      (b.scale = g ? K(g.pointers, d) : 1),
      (b.rotation = g ? J(g.pointers, d) : 0),
      (b.maxPointers = c.prevInput
        ? b.pointers.length > c.prevInput.maxPointers
          ? b.pointers.length
          : c.prevInput.maxPointers
        : b.pointers.length),
      C(c, b);
    var k = a.element;
    o(b.srcEvent.target, k) && (k = b.srcEvent.target), (b.target = k);
  }
  function B(a, b) {
    var c = b.center,
      d = a.offsetDelta || {},
      e = a.prevDelta || {},
      f = a.prevInput || {};
    (b.eventType !== Ea && f.eventType !== Ga) ||
      ((e = a.prevDelta = { x: f.deltaX || 0, y: f.deltaY || 0 }), (d = a.offsetDelta = { x: c.x, y: c.y })),
      (b.deltaX = e.x + (c.x - d.x)),
      (b.deltaY = e.y + (c.y - d.y));
  }
  function C(a, b) {
    var c,
      e,
      f,
      g,
      h = a.lastInterval || b,
      i = b.timeStamp - h.timeStamp;
    if (b.eventType != Ha && (i > Da || h.velocity === d)) {
      var j = b.deltaX - h.deltaX,
        k = b.deltaY - h.deltaY,
        l = F(i, j, k);
      (e = l.x), (f = l.y), (c = qa(l.x) > qa(l.y) ? l.x : l.y), (g = G(j, k)), (a.lastInterval = b);
    } else (c = h.velocity), (e = h.velocityX), (f = h.velocityY), (g = h.direction);
    (b.velocity = c), (b.velocityX = e), (b.velocityY = f), (b.direction = g);
  }
  function D(a) {
    for (var b = [], c = 0; c < a.pointers.length; )
      (b[c] = { clientX: pa(a.pointers[c].clientX), clientY: pa(a.pointers[c].clientY) }), c++;
    return { timeStamp: ra(), pointers: b, center: E(b), deltaX: a.deltaX, deltaY: a.deltaY };
  }
  function E(a) {
    var b = a.length;
    if (1 === b) return { x: pa(a[0].clientX), y: pa(a[0].clientY) };
    for (var c = 0, d = 0, e = 0; b > e; ) (c += a[e].clientX), (d += a[e].clientY), e++;
    return { x: pa(c / b), y: pa(d / b) };
  }
  function F(a, b, c) {
    return { x: b / a || 0, y: c / a || 0 };
  }
  function G(a, b) {
    return a === b ? Ia : qa(a) >= qa(b) ? (0 > a ? Ja : Ka) : 0 > b ? La : Ma;
  }
  function H(a, b, c) {
    c || (c = Qa);
    var d = b[c[0]] - a[c[0]],
      e = b[c[1]] - a[c[1]];
    return Math.sqrt(d * d + e * e);
  }
  function I(a, b, c) {
    c || (c = Qa);
    var d = b[c[0]] - a[c[0]],
      e = b[c[1]] - a[c[1]];
    return (180 * Math.atan2(e, d)) / Math.PI;
  }
  function J(a, b) {
    return I(b[1], b[0], Ra) + I(a[1], a[0], Ra);
  }
  function K(a, b) {
    return H(b[0], b[1], Ra) / H(a[0], a[1], Ra);
  }
  function L() {
    (this.evEl = Ta), (this.evWin = Ua), (this.pressed = !1), x.apply(this, arguments);
  }
  function M() {
    (this.evEl = Xa), (this.evWin = Ya), x.apply(this, arguments), (this.store = this.manager.session.pointerEvents = []);
  }
  function N() {
    (this.evTarget = $a), (this.evWin = _a), (this.started = !1), x.apply(this, arguments);
  }
  function O(a, b) {
    var c = s(a.touches),
      d = s(a.changedTouches);
    return b & (Ga | Ha) && (c = t(c.concat(d), 'identifier', !0)), [c, d];
  }
  function P() {
    (this.evTarget = bb), (this.targetIds = {}), x.apply(this, arguments);
  }
  function Q(a, b) {
    var c = s(a.touches),
      d = this.targetIds;
    if (b & (Ea | Fa) && 1 === c.length) return (d[c[0].identifier] = !0), [c, c];
    var e,
      f,
      g = s(a.changedTouches),
      h = [],
      i = this.target;
    if (
      ((f = c.filter(function(a) {
        return o(a.target, i);
      })),
      b === Ea)
    )
      for (e = 0; e < f.length; ) (d[f[e].identifier] = !0), e++;
    for (e = 0; e < g.length; ) d[g[e].identifier] && h.push(g[e]), b & (Ga | Ha) && delete d[g[e].identifier], e++;
    return h.length ? [t(f.concat(h), 'identifier', !0), h] : void 0;
  }
  function R() {
    x.apply(this, arguments);
    var a = j(this.handler, this);
    (this.touch = new P(this.manager, a)), (this.mouse = new L(this.manager, a)), (this.primaryTouch = null), (this.lastTouches = []);
  }
  function S(a, b) {
    a & Ea ? ((this.primaryTouch = b.changedPointers[0].identifier), T.call(this, b)) : a & (Ga | Ha) && T.call(this, b);
  }
  function T(a) {
    var b = a.changedPointers[0];
    if (b.identifier === this.primaryTouch) {
      var c = { x: b.clientX, y: b.clientY };
      this.lastTouches.push(c);
      var d = this.lastTouches,
        e = function() {
          var a = d.indexOf(c);
          a > -1 && d.splice(a, 1);
        };
      setTimeout(e, cb);
    }
  }
  function U(a) {
    for (var b = a.srcEvent.clientX, c = a.srcEvent.clientY, d = 0; d < this.lastTouches.length; d++) {
      var e = this.lastTouches[d],
        f = Math.abs(b - e.x),
        g = Math.abs(c - e.y);
      if (db >= f && db >= g) return !0;
    }
    return !1;
  }
  function V(a, b) {
    (this.manager = a), this.set(b);
  }
  function W(a) {
    if (p(a, jb)) return jb;
    var b = p(a, kb),
      c = p(a, lb);
    return b && c ? jb : b || c ? (b ? kb : lb) : p(a, ib) ? ib : hb;
  }
  function X() {
    if (!fb) return !1;
    var b = {},
      c = a.CSS && a.CSS.supports;
    return (
      ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(d) {
        b[d] = c ? a.CSS.supports('touch-action', d) : !0;
      }),
      b
    );
  }
  function Y(a) {
    (this.options = la({}, this.defaults, a || {})),
      (this.id = v()),
      (this.manager = null),
      (this.options.enable = l(this.options.enable, !0)),
      (this.state = nb),
      (this.simultaneous = {}),
      (this.requireFail = []);
  }
  function Z(a) {
    return a & sb ? 'cancel' : a & qb ? 'end' : a & pb ? 'move' : a & ob ? 'start' : '';
  }
  function $(a) {
    return a == Ma ? 'down' : a == La ? 'up' : a == Ja ? 'left' : a == Ka ? 'right' : '';
  }
  function _(a, b) {
    var c = b.manager;
    return c ? c.get(a) : a;
  }
  function aa() {
    Y.apply(this, arguments);
  }
  function ba() {
    aa.apply(this, arguments), (this.pX = null), (this.pY = null);
  }
  function ca() {
    aa.apply(this, arguments);
  }
  function da() {
    Y.apply(this, arguments), (this._timer = null), (this._input = null);
  }
  function ea() {
    aa.apply(this, arguments);
  }
  function fa() {
    aa.apply(this, arguments);
  }
  function ga() {
    Y.apply(this, arguments), (this.pTime = !1), (this.pCenter = !1), (this._timer = null), (this._input = null), (this.count = 0);
  }
  function ha(a, b) {
    return (b = b || {}), (b.recognizers = l(b.recognizers, ha.defaults.preset)), new ia(a, b);
  }
  function ia(a, b) {
    (this.options = la({}, ha.defaults, b || {})),
      (this.options.inputTarget = this.options.inputTarget || a),
      (this.handlers = {}),
      (this.session = {}),
      (this.recognizers = []),
      (this.oldCssProps = {}),
      (this.element = a),
      (this.input = y(this)),
      (this.touchAction = new V(this, this.options.touchAction)),
      ja(this, !0),
      g(
        this.options.recognizers,
        function(a) {
          var b = this.add(new a[0](a[1]));
          a[2] && b.recognizeWith(a[2]), a[3] && b.requireFailure(a[3]);
        },
        this
      );
  }
  function ja(a, b) {
    var c = a.element;
    if (c.style) {
      var d;
      g(a.options.cssProps, function(e, f) {
        (d = u(c.style, f)), b ? ((a.oldCssProps[d] = c.style[d]), (c.style[d] = e)) : (c.style[d] = a.oldCssProps[d] || '');
      }),
        b || (a.oldCssProps = {});
    }
  }
  function ka(a, c) {
    var d = b.createEvent('Event');
    d.initEvent(a, !0, !0), (d.gesture = c), c.target.dispatchEvent(d);
  }
  var la,
    ma = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'],
    na = b.createElement('div'),
    oa = 'function',
    pa = Math.round,
    qa = Math.abs,
    ra = Date.now;
  la =
    'function' != typeof Object.assign
      ? function(a) {
          if (a === d || null === a) throw new TypeError('Cannot convert undefined or null to object');
          for (var b = Object(a), c = 1; c < arguments.length; c++) {
            var e = arguments[c];
            if (e !== d && null !== e) for (var f in e) e.hasOwnProperty(f) && (b[f] = e[f]);
          }
          return b;
        }
      : Object.assign;
  var sa = h(
      function(a, b, c) {
        for (var e = Object.keys(b), f = 0; f < e.length; ) (!c || (c && a[e[f]] === d)) && (a[e[f]] = b[e[f]]), f++;
        return a;
      },
      'extend',
      'Use `assign`.'
    ),
    ta = h(
      function(a, b) {
        return sa(a, b, !0);
      },
      'merge',
      'Use `assign`.'
    ),
    ua = 1,
    va = /mobile|tablet|ip(ad|hone|od)|android/i,
    wa = 'ontouchstart' in a,
    xa = u(a, 'PointerEvent') !== d,
    ya = wa && va.test(navigator.userAgent),
    za = 'touch',
    Aa = 'pen',
    Ba = 'mouse',
    Ca = 'kinect',
    Da = 25,
    Ea = 1,
    Fa = 2,
    Ga = 4,
    Ha = 8,
    Ia = 1,
    Ja = 2,
    Ka = 4,
    La = 8,
    Ma = 16,
    Na = Ja | Ka,
    Oa = La | Ma,
    Pa = Na | Oa,
    Qa = ['x', 'y'],
    Ra = ['clientX', 'clientY'];
  x.prototype = {
    handler: function() {},
    init: function() {
      this.evEl && m(this.element, this.evEl, this.domHandler),
        this.evTarget && m(this.target, this.evTarget, this.domHandler),
        this.evWin && m(w(this.element), this.evWin, this.domHandler);
    },
    destroy: function() {
      this.evEl && n(this.element, this.evEl, this.domHandler),
        this.evTarget && n(this.target, this.evTarget, this.domHandler),
        this.evWin && n(w(this.element), this.evWin, this.domHandler);
    }
  };
  var Sa = { mousedown: Ea, mousemove: Fa, mouseup: Ga },
    Ta = 'mousedown',
    Ua = 'mousemove mouseup';
  i(L, x, {
    handler: function(a) {
      var b = Sa[a.type];
      b & Ea && 0 === a.button && (this.pressed = !0),
        b & Fa && 1 !== a.which && (b = Ga),
        this.pressed &&
          (b & Ga && (this.pressed = !1),
          this.callback(this.manager, b, { pointers: [a], changedPointers: [a], pointerType: Ba, srcEvent: a }));
    }
  });
  var Va = { pointerdown: Ea, pointermove: Fa, pointerup: Ga, pointercancel: Ha, pointerout: Ha },
    Wa = { 2: za, 3: Aa, 4: Ba, 5: Ca },
    Xa = 'pointerdown',
    Ya = 'pointermove pointerup pointercancel';
  a.MSPointerEvent && !a.PointerEvent && ((Xa = 'MSPointerDown'), (Ya = 'MSPointerMove MSPointerUp MSPointerCancel')),
    i(M, x, {
      handler: function(a) {
        var b = this.store,
          c = !1,
          d = a.type.toLowerCase().replace('ms', ''),
          e = Va[d],
          f = Wa[a.pointerType] || a.pointerType,
          g = f == za,
          h = r(b, a.pointerId, 'pointerId');
        e & Ea && (0 === a.button || g) ? 0 > h && (b.push(a), (h = b.length - 1)) : e & (Ga | Ha) && (c = !0),
          0 > h ||
            ((b[h] = a),
            this.callback(this.manager, e, { pointers: b, changedPointers: [a], pointerType: f, srcEvent: a }),
            c && b.splice(h, 1));
      }
    });
  var Za = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
    $a = 'touchstart',
    _a = 'touchstart touchmove touchend touchcancel';
  i(N, x, {
    handler: function(a) {
      var b = Za[a.type];
      if ((b === Ea && (this.started = !0), this.started)) {
        var c = O.call(this, a, b);
        b & (Ga | Ha) && c[0].length - c[1].length === 0 && (this.started = !1),
          this.callback(this.manager, b, { pointers: c[0], changedPointers: c[1], pointerType: za, srcEvent: a });
      }
    }
  });
  var ab = { touchstart: Ea, touchmove: Fa, touchend: Ga, touchcancel: Ha },
    bb = 'touchstart touchmove touchend touchcancel';
  i(P, x, {
    handler: function(a) {
      var b = ab[a.type],
        c = Q.call(this, a, b);
      c && this.callback(this.manager, b, { pointers: c[0], changedPointers: c[1], pointerType: za, srcEvent: a });
    }
  });
  var cb = 2500,
    db = 25;
  i(R, x, {
    handler: function(a, b, c) {
      var d = c.pointerType == za,
        e = c.pointerType == Ba;
      if (!(e && c.sourceCapabilities && c.sourceCapabilities.firesTouchEvents)) {
        if (d) S.call(this, b, c);
        else if (e && U.call(this, c)) return;
        this.callback(a, b, c);
      }
    },
    destroy: function() {
      this.touch.destroy(), this.mouse.destroy();
    }
  });
  var eb = u(na.style, 'touchAction'),
    fb = eb !== d,
    gb = 'compute',
    hb = 'auto',
    ib = 'manipulation',
    jb = 'none',
    kb = 'pan-x',
    lb = 'pan-y',
    mb = X();
  V.prototype = {
    set: function(a) {
      a == gb && (a = this.compute()),
        fb && this.manager.element.style && mb[a] && (this.manager.element.style[eb] = a),
        (this.actions = a.toLowerCase().trim());
    },
    update: function() {
      this.set(this.manager.options.touchAction);
    },
    compute: function() {
      var a = [];
      return (
        g(this.manager.recognizers, function(b) {
          k(b.options.enable, [b]) && (a = a.concat(b.getTouchAction()));
        }),
        W(a.join(' '))
      );
    },
    preventDefaults: function(a) {
      var b = a.srcEvent,
        c = a.offsetDirection;
      if (this.manager.session.prevented) return void b.preventDefault();
      var d = this.actions,
        e = p(d, jb) && !mb[jb],
        f = p(d, lb) && !mb[lb],
        g = p(d, kb) && !mb[kb];
      if (e) {
        var h = 1 === a.pointers.length,
          i = a.distance < 2,
          j = a.deltaTime < 250;
        if (h && i && j) return;
      }
      return g && f ? void 0 : e || (f && c & Na) || (g && c & Oa) ? this.preventSrc(b) : void 0;
    },
    preventSrc: function(a) {
      (this.manager.session.prevented = !0), a.preventDefault();
    }
  };
  var nb = 1,
    ob = 2,
    pb = 4,
    qb = 8,
    rb = qb,
    sb = 16,
    tb = 32;
  (Y.prototype = {
    defaults: {},
    set: function(a) {
      return la(this.options, a), this.manager && this.manager.touchAction.update(), this;
    },
    recognizeWith: function(a) {
      if (f(a, 'recognizeWith', this)) return this;
      var b = this.simultaneous;
      return (a = _(a, this)), b[a.id] || ((b[a.id] = a), a.recognizeWith(this)), this;
    },
    dropRecognizeWith: function(a) {
      return f(a, 'dropRecognizeWith', this) ? this : ((a = _(a, this)), delete this.simultaneous[a.id], this);
    },
    requireFailure: function(a) {
      if (f(a, 'requireFailure', this)) return this;
      var b = this.requireFail;
      return (a = _(a, this)), -1 === r(b, a) && (b.push(a), a.requireFailure(this)), this;
    },
    dropRequireFailure: function(a) {
      if (f(a, 'dropRequireFailure', this)) return this;
      a = _(a, this);
      var b = r(this.requireFail, a);
      return b > -1 && this.requireFail.splice(b, 1), this;
    },
    hasRequireFailures: function() {
      return this.requireFail.length > 0;
    },
    canRecognizeWith: function(a) {
      return !!this.simultaneous[a.id];
    },
    emit: function(a) {
      function b(b) {
        c.manager.emit(b, a);
      }
      var c = this,
        d = this.state;
      qb > d && b(c.options.event + Z(d)),
        b(c.options.event),
        a.additionalEvent && b(a.additionalEvent),
        d >= qb && b(c.options.event + Z(d));
    },
    tryEmit: function(a) {
      return this.canEmit() ? this.emit(a) : void (this.state = tb);
    },
    canEmit: function() {
      for (var a = 0; a < this.requireFail.length; ) {
        if (!(this.requireFail[a].state & (tb | nb))) return !1;
        a++;
      }
      return !0;
    },
    recognize: function(a) {
      var b = la({}, a);
      return k(this.options.enable, [this, b])
        ? (this.state & (rb | sb | tb) && (this.state = nb),
          (this.state = this.process(b)),
          void (this.state & (ob | pb | qb | sb) && this.tryEmit(b)))
        : (this.reset(), void (this.state = tb));
    },
    process: function(a) {},
    getTouchAction: function() {},
    reset: function() {}
  }),
    i(aa, Y, {
      defaults: { pointers: 1 },
      attrTest: function(a) {
        var b = this.options.pointers;
        return 0 === b || a.pointers.length === b;
      },
      process: function(a) {
        var b = this.state,
          c = a.eventType,
          d = b & (ob | pb),
          e = this.attrTest(a);
        return d && (c & Ha || !e) ? b | sb : d || e ? (c & Ga ? b | qb : b & ob ? b | pb : ob) : tb;
      }
    }),
    i(ba, aa, {
      defaults: { event: 'pan', threshold: 10, pointers: 1, direction: Pa },
      getTouchAction: function() {
        var a = this.options.direction,
          b = [];
        return a & Na && b.push(lb), a & Oa && b.push(kb), b;
      },
      directionTest: function(a) {
        var b = this.options,
          c = !0,
          d = a.distance,
          e = a.direction,
          f = a.deltaX,
          g = a.deltaY;
        return (
          e & b.direction ||
            (b.direction & Na
              ? ((e = 0 === f ? Ia : 0 > f ? Ja : Ka), (c = f != this.pX), (d = Math.abs(a.deltaX)))
              : ((e = 0 === g ? Ia : 0 > g ? La : Ma), (c = g != this.pY), (d = Math.abs(a.deltaY)))),
          (a.direction = e),
          c && d > b.threshold && e & b.direction
        );
      },
      attrTest: function(a) {
        return aa.prototype.attrTest.call(this, a) && (this.state & ob || (!(this.state & ob) && this.directionTest(a)));
      },
      emit: function(a) {
        (this.pX = a.deltaX), (this.pY = a.deltaY);
        var b = $(a.direction);
        b && (a.additionalEvent = this.options.event + b), this._super.emit.call(this, a);
      }
    }),
    i(ca, aa, {
      defaults: { event: 'pinch', threshold: 0, pointers: 2 },
      getTouchAction: function() {
        return [jb];
      },
      attrTest: function(a) {
        return this._super.attrTest.call(this, a) && (Math.abs(a.scale - 1) > this.options.threshold || this.state & ob);
      },
      emit: function(a) {
        if (1 !== a.scale) {
          var b = a.scale < 1 ? 'in' : 'out';
          a.additionalEvent = this.options.event + b;
        }
        this._super.emit.call(this, a);
      }
    }),
    i(da, Y, {
      defaults: { event: 'press', pointers: 1, time: 251, threshold: 9 },
      getTouchAction: function() {
        return [hb];
      },
      process: function(a) {
        var b = this.options,
          c = a.pointers.length === b.pointers,
          d = a.distance < b.threshold,
          f = a.deltaTime > b.time;
        if (((this._input = a), !d || !c || (a.eventType & (Ga | Ha) && !f))) this.reset();
        else if (a.eventType & Ea)
          this.reset(),
            (this._timer = e(
              function() {
                (this.state = rb), this.tryEmit();
              },
              b.time,
              this
            ));
        else if (a.eventType & Ga) return rb;
        return tb;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(a) {
        this.state === rb &&
          (a && a.eventType & Ga
            ? this.manager.emit(this.options.event + 'up', a)
            : ((this._input.timeStamp = ra()), this.manager.emit(this.options.event, this._input)));
      }
    }),
    i(ea, aa, {
      defaults: { event: 'rotate', threshold: 0, pointers: 2 },
      getTouchAction: function() {
        return [jb];
      },
      attrTest: function(a) {
        return this._super.attrTest.call(this, a) && (Math.abs(a.rotation) > this.options.threshold || this.state & ob);
      }
    }),
    i(fa, aa, {
      defaults: { event: 'swipe', threshold: 10, velocity: 0.3, direction: Na | Oa, pointers: 1 },
      getTouchAction: function() {
        return ba.prototype.getTouchAction.call(this);
      },
      attrTest: function(a) {
        var b,
          c = this.options.direction;
        return (
          c & (Na | Oa) ? (b = a.overallVelocity) : c & Na ? (b = a.overallVelocityX) : c & Oa && (b = a.overallVelocityY),
          this._super.attrTest.call(this, a) &&
            c & a.offsetDirection &&
            a.distance > this.options.threshold &&
            a.maxPointers == this.options.pointers &&
            qa(b) > this.options.velocity &&
            a.eventType & Ga
        );
      },
      emit: function(a) {
        var b = $(a.offsetDirection);
        b && this.manager.emit(this.options.event + b, a), this.manager.emit(this.options.event, a);
      }
    }),
    i(ga, Y, {
      defaults: { event: 'tap', pointers: 1, taps: 1, interval: 300, time: 250, threshold: 9, posThreshold: 10 },
      getTouchAction: function() {
        return [ib];
      },
      process: function(a) {
        var b = this.options,
          c = a.pointers.length === b.pointers,
          d = a.distance < b.threshold,
          f = a.deltaTime < b.time;
        if ((this.reset(), a.eventType & Ea && 0 === this.count)) return this.failTimeout();
        if (d && f && c) {
          if (a.eventType != Ga) return this.failTimeout();
          var g = this.pTime ? a.timeStamp - this.pTime < b.interval : !0,
            h = !this.pCenter || H(this.pCenter, a.center) < b.posThreshold;
          (this.pTime = a.timeStamp), (this.pCenter = a.center), h && g ? (this.count += 1) : (this.count = 1), (this._input = a);
          var i = this.count % b.taps;
          if (0 === i)
            return this.hasRequireFailures()
              ? ((this._timer = e(
                  function() {
                    (this.state = rb), this.tryEmit();
                  },
                  b.interval,
                  this
                )),
                ob)
              : rb;
        }
        return tb;
      },
      failTimeout: function() {
        return (
          (this._timer = e(
            function() {
              this.state = tb;
            },
            this.options.interval,
            this
          )),
          tb
        );
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == rb && ((this._input.tapCount = this.count), this.manager.emit(this.options.event, this._input));
      }
    }),
    (ha.VERSION = '2.0.8'),
    (ha.defaults = {
      domEvents: !1,
      touchAction: gb,
      enable: !0,
      inputTarget: null,
      inputClass: null,
      preset: [
        [ea, { enable: !1 }],
        [ca, { enable: !1 }, ['rotate']],
        [fa, { direction: Na }],
        [ba, { direction: Na }, ['swipe']],
        [ga],
        [ga, { event: 'doubletap', taps: 2 }, ['tap']],
        [da]
      ],
      cssProps: {
        userSelect: 'none',
        touchSelect: 'none',
        touchCallout: 'none',
        contentZooming: 'none',
        userDrag: 'none',
        tapHighlightColor: 'rgba(0,0,0,0)'
      }
    });
  var ub = 1,
    vb = 2;
  (ia.prototype = {
    set: function(a) {
      return (
        la(this.options, a),
        a.touchAction && this.touchAction.update(),
        a.inputTarget && (this.input.destroy(), (this.input.target = a.inputTarget), this.input.init()),
        this
      );
    },
    stop: function(a) {
      this.session.stopped = a ? vb : ub;
    },
    recognize: function(a) {
      var b = this.session;
      if (!b.stopped) {
        this.touchAction.preventDefaults(a);
        var c,
          d = this.recognizers,
          e = b.curRecognizer;
        (!e || (e && e.state & rb)) && (e = b.curRecognizer = null);
        for (var f = 0; f < d.length; )
          (c = d[f]),
            b.stopped === vb || (e && c != e && !c.canRecognizeWith(e)) ? c.reset() : c.recognize(a),
            !e && c.state & (ob | pb | qb) && (e = b.curRecognizer = c),
            f++;
      }
    },
    get: function(a) {
      if (a instanceof Y) return a;
      for (var b = this.recognizers, c = 0; c < b.length; c++) if (b[c].options.event == a) return b[c];
      return null;
    },
    add: function(a) {
      if (f(a, 'add', this)) return this;
      var b = this.get(a.options.event);
      return b && this.remove(b), this.recognizers.push(a), (a.manager = this), this.touchAction.update(), a;
    },
    remove: function(a) {
      if (f(a, 'remove', this)) return this;
      if ((a = this.get(a))) {
        var b = this.recognizers,
          c = r(b, a);
        -1 !== c && (b.splice(c, 1), this.touchAction.update());
      }
      return this;
    },
    on: function(a, b) {
      if (a !== d && b !== d) {
        var c = this.handlers;
        return (
          g(q(a), function(a) {
            (c[a] = c[a] || []), c[a].push(b);
          }),
          this
        );
      }
    },
    off: function(a, b) {
      if (a !== d) {
        var c = this.handlers;
        return (
          g(q(a), function(a) {
            b ? c[a] && c[a].splice(r(c[a], b), 1) : delete c[a];
          }),
          this
        );
      }
    },
    emit: function(a, b) {
      this.options.domEvents && ka(a, b);
      var c = this.handlers[a] && this.handlers[a].slice();
      if (c && c.length) {
        (b.type = a),
          (b.preventDefault = function() {
            b.srcEvent.preventDefault();
          });
        for (var d = 0; d < c.length; ) c[d](b), d++;
      }
    },
    destroy: function() {
      this.element && ja(this, !1), (this.handlers = {}), (this.session = {}), this.input.destroy(), (this.element = null);
    }
  }),
    la(ha, {
      INPUT_START: Ea,
      INPUT_MOVE: Fa,
      INPUT_END: Ga,
      INPUT_CANCEL: Ha,
      STATE_POSSIBLE: nb,
      STATE_BEGAN: ob,
      STATE_CHANGED: pb,
      STATE_ENDED: qb,
      STATE_RECOGNIZED: rb,
      STATE_CANCELLED: sb,
      STATE_FAILED: tb,
      DIRECTION_NONE: Ia,
      DIRECTION_LEFT: Ja,
      DIRECTION_RIGHT: Ka,
      DIRECTION_UP: La,
      DIRECTION_DOWN: Ma,
      DIRECTION_HORIZONTAL: Na,
      DIRECTION_VERTICAL: Oa,
      DIRECTION_ALL: Pa,
      Manager: ia,
      Input: x,
      TouchAction: V,
      TouchInput: P,
      MouseInput: L,
      PointerEventInput: M,
      TouchMouseInput: R,
      SingleTouchInput: N,
      Recognizer: Y,
      AttrRecognizer: aa,
      Tap: ga,
      Pan: ba,
      Swipe: fa,
      Pinch: ca,
      Rotate: ea,
      Press: da,
      on: m,
      off: n,
      each: g,
      merge: ta,
      extend: sa,
      assign: la,
      inherit: i,
      bindFn: j,
      prefixed: u
    });
  var wb = 'undefined' != typeof a ? a : 'undefined' != typeof self ? self : {};
  (wb.Hammer = ha),
    'function' == typeof define && define.amd
      ? define(function() {
          return ha;
        })
      : 'undefined' != typeof module && module.exports
      ? (module.exports = ha)
      : (a[c] = ha);
})(window, document, 'Hammer');
//# sourceMappingURL=hammer.min.js.map

!function(e){function t(){}function r(e,t){return function(){e.apply(t,arguments)}}function i(e){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],u(e,this)}function n(e,t){for(;3===e._state;)e=e._value;return 0===e._state?void e._deferreds.push(t):(e._handled=!0,void i._immediateFn(function(){var r=1===e._state?t.onFulfilled:t.onRejected;if(null===r)return void(1===e._state?a:o)(t.promise,e._value);var i;try{i=r(e._value)}catch(e){return void o(t.promise,e)}a(t.promise,i)}))}function a(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof i)return e._state=3,e._value=t,void s(e);if("function"==typeof n)return void u(r(n,t),e)}e._state=1,e._value=t,s(e)}catch(t){o(e,t)}}function o(e,t){e._state=2,e._value=t,s(e)}function s(e){2===e._state&&0===e._deferreds.length&&i._immediateFn(function(){e._handled||i._unhandledRejectionFn(e._value)});for(var t=0,r=e._deferreds.length;t<r;t++)n(e,e._deferreds[t]);e._deferreds=null}function c(e,t,r){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=r}function u(e,t){var r=!1;try{e(function(e){r||(r=!0,a(t,e))},function(e){r||(r=!0,o(t,e))})}catch(e){if(r)return;r=!0,o(t,e)}}var h=setTimeout;i.prototype.catch=function(e){return this.then(null,e)},i.prototype.then=function(e,r){var i=new this.constructor(t);return n(this,new c(e,r,i)),i},i.all=function(e){var t=Array.prototype.slice.call(e);return new i(function(e,r){function i(a,o){try{if(o&&("object"==typeof o||"function"==typeof o)){var s=o.then;if("function"==typeof s)return void s.call(o,function(e){i(a,e)},r)}t[a]=o,0===--n&&e(t)}catch(e){r(e)}}if(0===t.length)return e([]);for(var n=t.length,a=0;a<t.length;a++)i(a,t[a])})},i.resolve=function(e){return e&&"object"==typeof e&&e.constructor===i?e:new i(function(t){t(e)})},i.reject=function(e){return new i(function(t,r){r(e)})},i.race=function(e){return new i(function(t,r){for(var i=0,n=e.length;i<n;i++)e[i].then(t,r)})},i._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){h(e,0)},i._unhandledRejectionFn=function(e){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)},i._setImmediateFn=function(e){i._immediateFn=e},i._setUnhandledRejectionFn=function(e){i._unhandledRejectionFn=e},"undefined"!=typeof module&&module.exports?module.exports=i:e.Promise||(e.Promise=i)}(this),function(e,t){function r(e,t){return(65535&e)*t+(((e>>>16)*t&65535)<<16)}function i(e,t){return e<<t|e>>>32-t}function n(e){return e=r(e^e>>>16,2246822507),e^=e>>>13,e=r(e,3266489909),e^=e>>>16}function a(e,t){e=[e[0]>>>16,65535&e[0],e[1]>>>16,65535&e[1]],t=[t[0]>>>16,65535&t[0],t[1]>>>16,65535&t[1]];var r=[0,0,0,0];return r[3]+=e[3]+t[3],r[2]+=r[3]>>>16,r[3]&=65535,r[2]+=e[2]+t[2],r[1]+=r[2]>>>16,r[2]&=65535,r[1]+=e[1]+t[1],r[0]+=r[1]>>>16,r[1]&=65535,r[0]+=e[0]+t[0],r[0]&=65535,[r[0]<<16|r[1],r[2]<<16|r[3]]}function o(e,t){e=[e[0]>>>16,65535&e[0],e[1]>>>16,65535&e[1]],t=[t[0]>>>16,65535&t[0],t[1]>>>16,65535&t[1]];var r=[0,0,0,0];return r[3]+=e[3]*t[3],r[2]+=r[3]>>>16,r[3]&=65535,r[2]+=e[2]*t[3],r[1]+=r[2]>>>16,r[2]&=65535,r[2]+=e[3]*t[2],r[1]+=r[2]>>>16,r[2]&=65535,r[1]+=e[1]*t[3],r[0]+=r[1]>>>16,r[1]&=65535,r[1]+=e[2]*t[2],r[0]+=r[1]>>>16,r[1]&=65535,r[1]+=e[3]*t[1],r[0]+=r[1]>>>16,r[1]&=65535,r[0]+=e[0]*t[3]+e[1]*t[2]+e[2]*t[1]+e[3]*t[0],r[0]&=65535,[r[0]<<16|r[1],r[2]<<16|r[3]]}function s(e,t){return t%=64,32===t?[e[1],e[0]]:32>t?[e[0]<<t|e[1]>>>32-t,e[1]<<t|e[0]>>>32-t]:(t-=32,[e[1]<<t|e[0]>>>32-t,e[0]<<t|e[1]>>>32-t])}function c(e,t){return t%=64,0===t?e:32>t?[e[0]<<t|e[1]>>>32-t,e[1]<<t]:[e[1]<<t-32,0]}function u(e,t){return[e[0]^t[0],e[1]^t[1]]}function h(e){return e=u(e,[0,e[0]>>>1]),e=o(e,[4283543511,3981806797]),e=u(e,[0,e[0]>>>1]),e=o(e,[3301882366,444984403]),e=u(e,[0,e[0]>>>1])}var d={version:"2.1.2",x86:{},x64:{}};d.x86.hash32=function(e,t){e=e||"";for(var a=e.length%4,o=e.length-a,s=t||0,c=0,u=0;u<o;u+=4)c=255&e.charCodeAt(u)|(255&e.charCodeAt(u+1))<<8|(255&e.charCodeAt(u+2))<<16|(255&e.charCodeAt(u+3))<<24,c=r(c,3432918353),c=i(c,15),c=r(c,461845907),s^=c,s=i(s,13),s=r(s,5)+3864292196;switch(c=0,a){case 3:c^=(255&e.charCodeAt(u+2))<<16;case 2:c^=(255&e.charCodeAt(u+1))<<8;case 1:c^=255&e.charCodeAt(u),c=r(c,3432918353),c=i(c,15),c=r(c,461845907),s^=c}return s^=e.length,s=n(s),s>>>0},d.x86.hash128=function(e,t){e=e||"",t=t||0;for(var a=e.length%16,o=e.length-a,s=t,c=t,u=t,h=t,d=0,l=0,g=0,m=0,f=0;f<o;f+=16)d=255&e.charCodeAt(f)|(255&e.charCodeAt(f+1))<<8|(255&e.charCodeAt(f+2))<<16|(255&e.charCodeAt(f+3))<<24,l=255&e.charCodeAt(f+4)|(255&e.charCodeAt(f+5))<<8|(255&e.charCodeAt(f+6))<<16|(255&e.charCodeAt(f+7))<<24,g=255&e.charCodeAt(f+8)|(255&e.charCodeAt(f+9))<<8|(255&e.charCodeAt(f+10))<<16|(255&e.charCodeAt(f+11))<<24,m=255&e.charCodeAt(f+12)|(255&e.charCodeAt(f+13))<<8|(255&e.charCodeAt(f+14))<<16|(255&e.charCodeAt(f+15))<<24,d=r(d,597399067),d=i(d,15),d=r(d,2869860233),s^=d,s=i(s,19),s+=c,s=r(s,5)+1444728091,l=r(l,2869860233),l=i(l,16),l=r(l,951274213),c^=l,c=i(c,17),c+=u,c=r(c,5)+197830471,g=r(g,951274213),g=i(g,17),g=r(g,2716044179),u^=g,u=i(u,15),u+=h,u=r(u,5)+2530024501,m=r(m,2716044179),m=i(m,18),m=r(m,597399067),h^=m,h=i(h,13),h+=s,h=r(h,5)+850148119;switch(m=g=l=d=0,a){case 15:m^=e.charCodeAt(f+14)<<16;case 14:m^=e.charCodeAt(f+13)<<8;case 13:m^=e.charCodeAt(f+12),m=r(m,2716044179),m=i(m,18),m=r(m,597399067),h^=m;case 12:g^=e.charCodeAt(f+11)<<24;case 11:g^=e.charCodeAt(f+10)<<16;case 10:g^=e.charCodeAt(f+9)<<8;case 9:g^=e.charCodeAt(f+8),g=r(g,951274213),g=i(g,17),g=r(g,2716044179),u^=g;case 8:l^=e.charCodeAt(f+7)<<24;case 7:l^=e.charCodeAt(f+6)<<16;case 6:l^=e.charCodeAt(f+5)<<8;case 5:l^=e.charCodeAt(f+4),l=r(l,2869860233),l=i(l,16),l=r(l,951274213),c^=l;case 4:d^=e.charCodeAt(f+3)<<24;case 3:d^=e.charCodeAt(f+2)<<16;case 2:d^=e.charCodeAt(f+1)<<8;case 1:d^=e.charCodeAt(f),d=r(d,597399067),d=i(d,15),d=r(d,2869860233),s^=d}return s^=e.length,c^=e.length,u^=e.length,h^=e.length,s=s+c+u,s+=h,c+=s,u+=s,h+=s,s=n(s),c=n(c),u=n(u),h=n(h),s+=c,s+=u,s+=h,c+=s,u+=s,h+=s,("00000000"+(s>>>0).toString(16)).slice(-8)+("00000000"+(c>>>0).toString(16)).slice(-8)+("00000000"+(u>>>0).toString(16)).slice(-8)+("00000000"+(h>>>0).toString(16)).slice(-8)},d.x64.hash128=function(e,t){e=e||"",t=t||0;for(var r=e.length%16,i=e.length-r,n=[0,t],d=[0,t],l=[0,0],g=[0,0],m=[2277735313,289559509],f=[1291169091,658871167],p=0;p<i;p+=16)l=[255&e.charCodeAt(p+4)|(255&e.charCodeAt(p+5))<<8|(255&e.charCodeAt(p+6))<<16|(255&e.charCodeAt(p+7))<<24,255&e.charCodeAt(p)|(255&e.charCodeAt(p+1))<<8|(255&e.charCodeAt(p+2))<<16|(255&e.charCodeAt(p+3))<<24],g=[255&e.charCodeAt(p+12)|(255&e.charCodeAt(p+13))<<8|(255&e.charCodeAt(p+14))<<16|(255&e.charCodeAt(p+15))<<24,255&e.charCodeAt(p+8)|(255&e.charCodeAt(p+9))<<8|(255&e.charCodeAt(p+10))<<16|(255&e.charCodeAt(p+11))<<24],l=o(l,m),l=s(l,31),l=o(l,f),n=u(n,l),n=s(n,27),n=a(n,d),n=a(o(n,[0,5]),[0,1390208809]),g=o(g,f),g=s(g,33),g=o(g,m),d=u(d,g),d=s(d,31),d=a(d,n),d=a(o(d,[0,5]),[0,944331445]);switch(l=[0,0],g=[0,0],r){case 15:g=u(g,c([0,e.charCodeAt(p+14)],48));case 14:g=u(g,c([0,e.charCodeAt(p+13)],40));case 13:g=u(g,c([0,e.charCodeAt(p+12)],32));case 12:g=u(g,c([0,e.charCodeAt(p+11)],24));case 11:g=u(g,c([0,e.charCodeAt(p+10)],16));case 10:g=u(g,c([0,e.charCodeAt(p+9)],8));case 9:g=u(g,[0,e.charCodeAt(p+8)]),g=o(g,f),g=s(g,33),g=o(g,m),d=u(d,g);case 8:l=u(l,c([0,e.charCodeAt(p+7)],56));case 7:l=u(l,c([0,e.charCodeAt(p+6)],48));case 6:l=u(l,c([0,e.charCodeAt(p+5)],40));case 5:l=u(l,c([0,e.charCodeAt(p+4)],32));case 4:l=u(l,c([0,e.charCodeAt(p+3)],24));case 3:l=u(l,c([0,e.charCodeAt(p+2)],16));case 2:l=u(l,c([0,e.charCodeAt(p+1)],8));case 1:l=u(l,[0,e.charCodeAt(p)]),l=o(l,m),l=s(l,31),l=o(l,f),n=u(n,l)}return n=u(n,[0,e.length]),d=u(d,[0,e.length]),n=a(n,d),d=a(d,n),n=h(n),d=h(d),n=a(n,d),d=a(d,n),("00000000"+(n[0]>>>0).toString(16)).slice(-8)+("00000000"+(n[1]>>>0).toString(16)).slice(-8)+("00000000"+(d[0]>>>0).toString(16)).slice(-8)+("00000000"+(d[1]>>>0).toString(16)).slice(-8)},"undefined"!=typeof exports?("undefined"!=typeof module&&module.exports&&(exports=module.exports=d),exports.murmurHash3=d):"function"==typeof define&&define.amd?define([],function(){return d}):(d._murmurHash3=e.murmurHash3,d.noConflict=function(){return e.murmurHash3=d._murmurHash3,d._murmurHash3=t,d.noConflict=t,d},e.murmurHash3=d)}(this),function(e){"use strict";var t={},r=e.imprint||{test:function(e){return Promise.all(e.map(function(e){if(!t.hasOwnProperty(e))throw"No test registered with the alias "+e;return t[e]()})).then(function(e){return murmurHash3.x86.hash128(e.join("~"))})},registerTest:function(e,r){t[e]=r}};"object"==typeof module&&"undefined"!=typeof exports&&(module.exports=imprint),e.imprint=r}(window),function(e){"use strict";imprint.registerTest("adBlocker",function(){return new Promise(function(e){var t=document.createElement("div");t.innerHTML="&nbsp;",t.className="adsbox",t.style.display="block",t.style.position="absolute",t.style.top="0px",t.style.left="-9999px";try{document.body.appendChild(t),window.setTimeout(function(){var r=0===t.offsetHeight;return document.body.removeChild(t),e(r)},10)}catch(t){return e(!1)}})})}(window),function(e){"use strict";imprint.registerTest("audio",function(){return new Promise(function(e){try{var t=new(window.AudioContext||window.webkitAudioContext),r=(t.createOscillator(),t.createAnalyser(),t.createGain(),t.createScriptProcessor(4096,1,1),t.destination),i=t.sampleRate.toString()+"_"+r.maxChannelCount+"_"+r.numberOfInputs+"_"+r.numberOfOutputs+"_"+r.channelCount+"_"+r.channelCountMode+"_"+r.channelInterpretation;return e(i)}catch(t){return e("")}})})}(window),function(e){"use strict";imprint.registerTest("availableScreenResolution",function(){return new Promise(function(e){var t=screen.availHeight>screen.availWidth?[screen.availHeight,screen.availWidth]:[screen.availWidth,screen.availHeight];return e(t.join("x"))})})}(window),function(e){"use strict";imprint.registerTest("canvas",function(){return new Promise(function(e){var t=[],r=document.createElement("canvas");r.width=2e3,r.height=200,r.style.display="inline";var i=r.getContext("2d");return i.rect(0,0,10,10),i.rect(2,2,6,6),t.push("canvas winding:"+(i.isPointInPath(5,5,"evenodd")===!1?"yes":"no")),i.textBaseline="alphabetic",i.fillStyle="#f60",i.fillRect(125,1,62,20),i.fillStyle="#069",i.font="11pt no-real-font-123",i.fillText("Cwm fjordbank glyphs vext quiz, 😃",2,15),i.fillStyle="rgba(102, 204, 0, 0.2)",i.font="18pt Arial",i.fillText("Cwm fjordbank glyphs vext quiz, 😃",4,45),i.globalCompositeOperation="multiply",i.fillStyle="rgb(255,0,255)",i.beginPath(),i.arc(50,50,50,0,2*Math.PI,!0),i.closePath(),i.fill(),i.fillStyle="rgb(0,255,255)",i.beginPath(),i.arc(100,50,50,0,2*Math.PI,!0),i.closePath(),i.fill(),i.fillStyle="rgb(255,255,0)",i.beginPath(),i.arc(75,100,50,0,2*Math.PI,!0),i.closePath(),i.fill(),i.fillStyle="rgb(255,0,255)",i.arc(75,75,75,0,2*Math.PI,!0),i.arc(75,75,25,0,2*Math.PI,!0),i.fill("evenodd"),t.push("canvas fp:"+r.toDataURL()),e(t.join("~"))})})}(window),function(e){"use strict";imprint.registerTest("colorDepth",function(){return new Promise(function(e){var t=screen.colorDepth;return 32===t&&(t=24),e(t||"")})})}(window),function(e){"use strict";imprint.registerTest("cookies",function(){return new Promise(function(e){return e(navigator.cookieEnabled)})})}(window),function(e){"use strict";imprint.registerTest("cpuClass",function(){return new Promise(function(e){return e(navigator.cpuClass||"")})})}(window),function(e){"use strict";imprint.registerTest("deviceDpi",function(){return new Promise(function(e){return e((screen.deviceXDPI||0)+"x"+(screen.deviceYDPI||0))})})}(window),function(e){"use strict";imprint.registerTest("doNotTrack",function(){return new Promise(function(e){return e(navigator.doNotTrack||navigator.msDoNotTrack||window.doNotTrack||"")})})}(window),function(e){"use strict";imprint.registerTest("indexedDb",function(){return new Promise(function(e){try{return e(!!window.indexedDB)}catch(t){return e(!0)}})})}(window);var FontDetector=function(){function e(e){var r=!0;for(var i in t){a.style.fontFamily=e+","+t[i],n.appendChild(a);var c=a.offsetWidth!=o[t[i]]||a.offsetHeight!=s[t[i]];n.removeChild(a),r=r&&c}return r}var t=["monospace","sans-serif","serif"],r="mmmmmmmmmmlli",i="201px",n=document.getElementsByTagName("body")[0],a=document.createElement("span");a.style.fontSize=i,a.innerHTML=r;var o={},s={};for(var c in t)a.style.fontFamily=t[c],n.appendChild(a),o[t[c]]=a.offsetWidth,s[t[c]]=a.offsetHeight,n.removeChild(a);this.detect=e};!function(e){"use strict";imprint.registerTest("installedFonts",function(){return new Promise(function(e){for(var t=new FontDetector,r=["ADOBE CASLON PRO","ADOBE GARAMOND PRO","AVENIR","Adobe Fangsong Std","Adobe Ming Std","Agency FB","Aharoni","Amazone BT","AngsanaUPC","Antique Olive","Apple Chancery","Apple Color Emoji","Apple SD Gothic Neo","Arab","Arial Baltic","Arial CE","Arial CYR","Arial Greek","Arial MT","Arial Unicode MS","Arrus BT","AvantGarde Bk BT","AvantGarde Md BT","Ayuthaya","Baskerville Old Face","Bell MT","Benguiat Bk BT","Berlin Sans FB","BernhardFashion BT","BernhardMod BT","Big Caslon","Bitstream Vera Sans Mono","Bitstream Vera Serif","BlairMdITC TT","Bodoni 72 Smallcaps","Bodoni MT Poster Compressed","Boulder","Bradley Hand","Broadway","Browallia New","BrowalliaUPC","Calisto MT","Cambria Math","Centaur","Chalkboard","Chalkboard SE","Chalkduster","Charter BT","ChelthmITC Bk BT","Chiller","Comic Sans MS","Constantia","Copperplate","Corbel","Cordia New","CordiaUPC","Coronet","Courier New Baltic","Courier New CE","Courier New CYR","Courier New TUR","Cuckoo","DFKai-SB","DaunPenh","Dauphin","David","DejaVu LGC Sans Mono","Denmark","Desdemona","DokChampa","Dotum","Ebrima","Edwardian Script ITC","Eras Bold ITC","EucrosiaUPC","Euphemia","Eurostile","FRUTIGER","FangSong","Felix Titling","Forte","Fransiscan","FreesiaUPC","French Script MT","FrnkGothITC Bk BT","Fruitger","Futura Bk BT","Futura Md BT","Futura ZBlk BT","FuturaBlack BT","Galliard BT","Garamond","Gautami","Geeza Pro","Geneva","GeoSlab 703 Lt BT","Geometr231 BT","Geometr231 Hv BT","Gigi","Gill Sans","GoudyOLSt BT","GulimChe","GungSeo","Gurmukhi MN","Harlow Solid Italic","Heather","HeiT","High Tower Text","Hiragino Kaku Gothic ProN","Hiragino Mincho ProN","Hiragino Sans GB","Hoefler Text","Humanst521 BT","Humanst521 Lt BT","Impact","Imprint MT Shadow","Incised901 BT","Incised901 Lt BT","Informal Roman","Informal011 BT","IrisUPC","Kabel Bk BT","KacstOne","KaiTi","Khmer UI","Kokila","LUCIDA GRANDE","Latha","Leelawadee","Lohit Gujarati","Long Island","Lucida Calligraphy","Lucida Console","Lucida Sans","Lucida Sans Typewriter","Lydian BT","MS Gothic","MS Mincho","MS PGothic","MS Reference Sans Serif","MS Reference Specialty","MS Serif","MUSEO","MYRIAD","Malgun Gothic","Mangal","Marigold","Market","Marlett","Meiryo","Meiryo UI","Menlo","Microsoft PhagsPa","Microsoft Uighur","MingLiU","MingLiU_HKSCS","Minion","Miriam Fixed","Mona Lisa Solid ITC TT","Monaco","Monotype Corsiva","NEVIS","News Gothic","News GothicMT","NewsGoth BT","Nyala","Old Century","Old English Text MT","Onyx","Oriya Sangam MN","PMingLiU","Palatino","Parchment","Pegasus","Perpetua","Perpetua Titling MT","Pickwick","Poster","Pristina","Raavi","Rage Italic","Rockwell","Roman","Sakkal Majalla","Savoye LET","Sawasdee","Segoe UI Symbol","Serifa BT","Serifa Th BT","Showcard Gothic","Shruti","Signboard","SimHei","SimSun","SimSun-ExtB","Simplified Arabic","Simplified Arabic Fixed","Sinhala Sangam MN","Sketch Rockwell","Socket","Stencil","Styllo","Swis721 BlkEx BT","Swiss911 XCm BT","Symbol","Synchro LET","System","TRAJAN PRO","Technical","Teletype","Tempus Sans ITC","Thonburi","Times","Times New Roman Baltic","Times New Roman CYR","Times New Roman PS","Trebuchet MS","Tubular","Tunga","Tw Cen MT","TypoUpright BT","Ubuntu","Unicorn","Utopia","Viner Hand ITC","Vivaldi","Vrinda","Westminster","Wide Latin","Zurich BlkEx BT"],i=[],n=0;n<r.length;n++)t.detect(r[n])&&i.push(r[n]);return e(i.join("~"))})})}(window),function(e){"use strict";var t,r;r=function(e){try{return JSON.parse(e)}catch(e){return!1}},t=function(){function e(){this.names=r('[ "Latin", "Chinese", "Arabic", "Devanagari", "Cyrillic", "Bengali/Assamese", "Kana", "Gurmukhi", "Javanese", "Hangul", "Telugu", "Tamil", "Malayalam", "Burmese", "Thai", "Sundanese", "Kannada", "Gujarati", "Lao", "Odia", "Ge-ez", "Sinhala", "Armenian", "Khmer", "Greek", "Lontara", "Hebrew", "Tibetan", "Georgian", "Modern Yi", "Mongolian", "Tifinagh", "Syriac", "Thaana", "Inuktitut", "Cherokee" ]'),this.codes=r("[[76,97,116,105,110], [27721,23383], [1575,1604,1593,1585,1576,1610,1577], [2342,2375,2357,2344,2366,2327,2352,2368], [1050,1080,1088,1080,1083,1080,1094,1072], [2476,2494,2434,2482,2494,32,47,32,2437,2488,2478,2496,2479,2492,2494], [20206,21517], [2583,2625,2608,2606,2625,2582,2624], [43415,43438], [54620,44544], [3108,3142,3122,3137,3095,3137], [2980,2990,3007,2996,3021], [3374,3378,3375,3390,3379,3330], [4121,4156,4116,4154,4121,4140], [3652,3607,3618], [7070,7077,7060,7082,7059], [3221,3240,3277,3240,3233], [2711,2753,2716,2736,2750,2724,2752], [3749,3762,3751], [2825,2852,2893,2837,2867], [4877,4821,4829], [3523,3538,3458,3524,3517], [1344,1377,1397,1400,1409], [6017,6098,6040,6082,6042], [917,955,955,951,957,953,954,972], [6674,6682,6664,6673], [1488,1500,1508,1489,1497,1514], [3926,3964,3921,3851], [4325,4304,4320,4311,4323,4314,4312], [41352,41760], [6190,6179,6185,6189,6179,6191], [11612,11593,11580,11593,11599,11568,11606], [1808,1834,1825,1821,1808], [1931,1960,1928,1964,1920,1960], [5123,5316,5251,5198,5200,5222], [5091,5043,5033], [55295, 7077]]"),this.fontSize=401,this.fontFace="Verdana",this.extraHeigth=15,this.res=[]}return e.prototype.begin=function(){var e,t,r,i,n,a,o,s,c,u,h,d,l,g,m,f,p,w,T,A,S,E,v,_,M,C,P,R;for(M=0,this.widths=[],this.heights=[],this.support=[],this.test_div=document.createElement("div"),document.body.appendChild(this.test_div),this.test_div.id="WritingTest",S=this.codes,n=0,c=S.length;n<c;n++){for(t=S[n],this.height=[],this.width=[],this.div=document.createElement("div"),this.test_div.appendChild(this.div),M+=1,this.div.id=M,this.div.style.display="inline-block",a=0,u=t.length;a<u;a++)e=t[a],this.div.innerHTML="<span style = 'font-family:"+this.fontFace+"; font-size:"+this.fontSize+"px;'>&#"+e+"</span>",this.height.push(document.getElementById(M).clientHeight),this.width.push(document.getElementById(M).clientWidth);for(this.div.innerHTML="",o=0,h=t.length;o<h;o++)e=t[o],this.div.innerHTML+="<span style = 'font-family:"+this.fontFace+"; font-size:"+this.fontSize+"px;'>&#"+e+"</span>";this.test_div.innerHTML+=this.height+";"+this.width+"<br>",this.heights.push(this.height),this.widths.push(this.width)}for(this.tw=this.widths.pop(),this.sw1=this.tw[0],this.sw2=this.tw[1],this.sh=this.heights.pop()[0],E=this.heights,s=0,d=E.length;s<d;s++){for(i=E[s],this.passed=0,p=0,l=i.length;p<l;p++)if(r=i[p],r!==this.sh){this.support.push(!0),this.passed=1;break}0===this.passed&&this.support.push(!1)}for(this.writing_scripts_index=0,v=this.widths,w=0,g=v.length;w<g;w++){for(R=v[w],T=0,m=R.length;T<m;T++)P=R[T],this.support[this.writing_scripts_index]===!1&&P!==this.sw1&&P!==this.sw2&&(this.support[this.writing_scripts_index]=!0);this.writing_scripts_index+=1}for(this.res=[],this.writing_scripts_index=0,_=this.support,A=0,f=_.length;A<f;A++)C=_[A],this.test_div.innerHTML+=this.names[this.writing_scripts_index]+": "+C+" <br>",C===!0&&this.res.push(this.names[this.writing_scripts_index]),this.writing_scripts_index+=1;return this.test_div.remove(),this.res},e}(),imprint.registerTest("installedLanguages",function(){return new Promise(function(e){try{var r=new t;return e(r.begin().join("~"))}catch(t){return e("")}})})}(window),function(e){"use strict";imprint.registerTest("language",function(){return new Promise(function(e){return e(navigator.language||navigator.userLanguage||navigator.browserLanguage||navigator.systemLanguage||"")})})}(window),function(e){"use strict";imprint.registerTest("localIp",function(){return new Promise(function(e){try{var t=window.RTCPeerConnection||window.mozRTCPeerConnection||window.webkitRTCPeerConnection,r=new t({iceServers:[]}),i=function(){};r.createDataChannel(""),r.createOffer(r.setLocalDescription.bind(r),i),r.onicecandidate=function(t){if(r.onicecandidate=i,!t||!t.candidate||!t.candidate.candidate)return e("");var n=/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(t.candidate.candidate)[1];return e(n)}}catch(t){return e("")}})})}(window),function(e){"use strict";imprint.registerTest("localStorage",function(){return new Promise(function(e){try{return e(!!window.localStorage)}catch(t){return e(!0)}})})}(window),function(e){"use strict";imprint.registerTest("mediaDevices",function(){return new Promise(function(e){return navigator.mediaDevices&&navigator.mediaDevices.enumerateDevices?void navigator.mediaDevices.enumerateDevices().then(function(t){var r=t.map(function(e){return e.kind+":"+e.label+" id = "+e.deviceId});return e(r.join(","))}).catch(function(t){return e("")}):e(cd||"")})})}(window),function(e){"use strict";imprint.registerTest("pixelRatio",function(){return new Promise(function(e){return e(window.devicePixelRatio||"")})})}(window),function(e){"use strict";imprint.registerTest("platform",function(){return new Promise(function(e){return e(navigator.platform||"")})})}(window),function(e){"use strict";imprint.registerTest("plugins",function(){return new Promise(function(e){var t=[];if(Object.getOwnPropertyDescriptor&&Object.getOwnPropertyDescriptor(window,"ActiveXObject")||"ActiveXObject"in window){var r=["AcroPDF.PDF","Adodb.Stream","AgControl.AgControl","DevalVRXCtrl.DevalVRXCtrl.1","MacromediaFlashPaper.MacromediaFlashPaper","Msxml2.DOMDocument","Msxml2.XMLHTTP","PDF.PdfCtrl","QuickTime.QuickTime","QuickTimeCheckObject.QuickTimeCheck.1","RealPlayer","RealPlayer.RealPlayer(tm) ActiveX Control (32-bit)","RealVideo.RealVideo(tm) ActiveX Control (32-bit)","Scripting.Dictionary","SWCtl.SWCtl","Shell.UIHelper","ShockwaveFlash.ShockwaveFlash","Skype.Detection","TDCCtl.TDCCtl","WMPlayer.OCX","rmocx.RealPlayer G2 Control","rmocx.RealPlayer G2 Control.1"];t=r.map(function(e){try{return new ActiveXObject(e),e}catch(e){return null}})}if(navigator.plugins){for(var i=[],n=0,a=navigator.plugins.length;n<a;n++)i.push(navigator.plugins[n]);navigator.userAgent.match(/palemoon/i)&&(i=i.sort(function(e,t){return e.name>t.name?1:e.name<t.name?-1:0}));i.map(function(e){for(var r=[],i=0;i<e.length;i++){var n=e[i];r.push([n.type,n.suffixes].join("~"))}t.push([e.name,e.description,r.join(",")].join("::"))})}return e(t.join("~"))})})}(window),function(e){"use strict";imprint.registerTest("processorCores",function(){return new Promise(function(e){return e(navigator.hardwareConcurrency)})})}(window),function(e){"use strict";imprint.registerTest("publicIp",function(){return new Promise(function(e){var t=new XMLHttpRequest;t.onreadystatechange=function(){4==t.readyState&&200==t.status&&e(t.responseText)},t.open("GET","https://api.ipify.org",!0),t.send(null)})})}(window),function(e){"use strict";imprint.registerTest("screenResolution",function(){return new Promise(function(e){var t=screen.height>screen.width?[screen.height,screen.width]:[screen.width,screen.height];return e(t.join("x"))})})}(window),function(e){"use strict";imprint.registerTest("sessionStorage",function(){return new Promise(function(e){try{return e(!!window.sessionStorage)}catch(t){return e(!0)}})})}(window),function(e){"use strict";imprint.registerTest("timezoneOffset",function(){return new Promise(function(e){return e((new Date).getTimezoneOffset())})})}(window),function(e){"use strict";imprint.registerTest("touchSupport",function(){return new Promise(function(e){var t=0,r=!1;"undefined"!=typeof navigator.maxTouchPoints?t=navigator.maxTouchPoints:"undefined"!=typeof navigator.msMaxTouchPoints&&(t=navigator.msMaxTouchPoints);try{document.createEvent("TouchEvent"),r=!0}catch(e){}var i="ontouchstart"in window;return e([t,r,i].join("~"))})})}(window),function(e){"use strict";imprint.registerTest("userAgent",function(){return new Promise(function(e){return e(navigator.userAgent)})})}(window),function(e){"use strict";imprint.registerTest("webGl",function(){return new Promise(function(e){try{var t=function(e){return n.clearColor(0,0,0,1),n.enable(n.DEPTH_TEST),n.depthFunc(n.LEQUAL),n.clear(n.COLOR_BUFFER_BIT|n.DEPTH_BUFFER_BIT),"["+e[0]+", "+e[1]+"]"},r=function(e){var t,r=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic");return r?(t=e.getParameter(r.MAX_TEXTURE_MAX_ANISOTROPY_EXT),0===t&&(t=2),t):null},i=document.createElement("canvas"),n=null;try{n=i.getContext("webgl")||i.getContext("experimental-webgl")}catch(e){}if(!n)return e("");var a=[],o="attribute vec2 attrVertex;varying vec2 varyinTexCoordinate;uniform vec2 uniformOffset;void main(){varyinTexCoordinate=attrVertex+uniformOffset;gl_Position=vec4(attrVertex,0,1);}",s="precision mediump float;varying vec2 varyinTexCoordinate;void main() {gl_FragColor=vec4(varyinTexCoordinate,0,1);}",c=n.createBuffer();n.bindBuffer(n.ARRAY_BUFFER,c);var u=new Float32Array([-.2,-.9,0,.4,-.26,0,0,.732134444,0]);n.bufferData(n.ARRAY_BUFFER,u,n.STATIC_DRAW),c.itemSize=3,c.numItems=3;var h=n.createProgram(),d=n.createShader(n.VERTEX_SHADER);n.shaderSource(d,o),n.compileShader(d);var l=n.createShader(n.FRAGMENT_SHADER);n.shaderSource(l,s),n.compileShader(l),n.attachShader(h,d),n.attachShader(h,l),n.linkProgram(h),n.useProgram(h),h.vertexPosAttrib=n.getAttribLocation(h,"attrVertex"),h.offsetUniform=n.getUniformLocation(h,"uniformOffset"),n.enableVertexAttribArray(h.vertexPosArray),n.vertexAttribPointer(h.vertexPosAttrib,c.itemSize,n.FLOAT,!1,0,0),n.uniform2f(h.offsetUniform,1,1),n.drawArrays(n.TRIANGLE_STRIP,0,c.numItems),null!=n.canvas&&a.push(n.canvas.toDataURL()),a.push("extensions:"+n.getSupportedExtensions().join(";")),a.push("webgl aliased line width range:"+t(n.getParameter(n.ALIASED_LINE_WIDTH_RANGE))),a.push("webgl aliased point size range:"+t(n.getParameter(n.ALIASED_POINT_SIZE_RANGE))),a.push("webgl alpha bits:"+n.getParameter(n.ALPHA_BITS)),a.push("webgl antialiasing:"+(n.getContextAttributes().antialias?"yes":"no")),a.push("webgl blue bits:"+n.getParameter(n.BLUE_BITS)),a.push("webgl depth bits:"+n.getParameter(n.DEPTH_BITS)),a.push("webgl green bits:"+n.getParameter(n.GREEN_BITS)),a.push("webgl max anisotropy:"+r(n)),a.push("webgl max combined texture image units:"+n.getParameter(n.MAX_COMBINED_TEXTURE_IMAGE_UNITS)),a.push("webgl max cube map texture size:"+n.getParameter(n.MAX_CUBE_MAP_TEXTURE_SIZE)),a.push("webgl max fragment uniform vectors:"+n.getParameter(n.MAX_FRAGMENT_UNIFORM_VECTORS)),a.push("webgl max render buffer size:"+n.getParameter(n.MAX_RENDERBUFFER_SIZE)),a.push("webgl max texture image units:"+n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS)),a.push("webgl max texture size:"+n.getParameter(n.MAX_TEXTURE_SIZE)),a.push("webgl max varying vectors:"+n.getParameter(n.MAX_VARYING_VECTORS)),a.push("webgl max vertex attribs:"+n.getParameter(n.MAX_VERTEX_ATTRIBS)),a.push("webgl max vertex texture image units:"+n.getParameter(n.MAX_VERTEX_TEXTURE_IMAGE_UNITS)),a.push("webgl max vertex uniform vectors:"+n.getParameter(n.MAX_VERTEX_UNIFORM_VECTORS)),a.push("webgl max viewport dims:"+t(n.getParameter(n.MAX_VIEWPORT_DIMS))),a.push("webgl red bits:"+n.getParameter(n.RED_BITS)),a.push("webgl renderer:"+n.getParameter(n.RENDERER)),a.push("webgl shading language version:"+n.getParameter(n.SHADING_LANGUAGE_VERSION)),a.push("webgl stencil bits:"+n.getParameter(n.STENCIL_BITS)),a.push("webgl vendor:"+n.getParameter(n.VENDOR)),a.push("webgl version:"+n.getParameter(n.VERSION));try{var g=n.getExtension("WEBGL_debug_renderer_info");g&&(a.push("webgl unmasked vendor:"+n.getParameter(g.UNMASKED_VENDOR_WEBGL)),a.push("webgl unmasked renderer:"+n.getParameter(g.UNMASKED_RENDERER_WEBGL)))}catch(e){}return n.getShaderPrecisionFormat?(a.push("webgl vertex shader high float precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_FLOAT).precision),a.push("webgl vertex shader high float precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_FLOAT).rangeMin),a.push("webgl vertex shader high float precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_FLOAT).rangeMax),a.push("webgl vertex shader medium float precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_FLOAT).precision),a.push("webgl vertex shader medium float precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_FLOAT).rangeMin),a.push("webgl vertex shader medium float precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_FLOAT).rangeMax),a.push("webgl vertex shader low float precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_FLOAT).precision),a.push("webgl vertex shader low float precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_FLOAT).rangeMin),a.push("webgl vertex shader low float precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_FLOAT).rangeMax),a.push("webgl fragment shader high float precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_FLOAT).precision),a.push("webgl fragment shader high float precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_FLOAT).rangeMin),a.push("webgl fragment shader high float precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_FLOAT).rangeMax),a.push("webgl fragment shader medium float precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_FLOAT).precision),a.push("webgl fragment shader medium float precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_FLOAT).rangeMin),a.push("webgl fragment shader medium float precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_FLOAT).rangeMax),a.push("webgl fragment shader low float precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_FLOAT).precision),a.push("webgl fragment shader low float precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_FLOAT).rangeMin),a.push("webgl fragment shader low float precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_FLOAT).rangeMax),a.push("webgl vertex shader high int precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_INT).precision),a.push("webgl vertex shader high int precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_INT).rangeMin),a.push("webgl vertex shader high int precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.HIGH_INT).rangeMax),a.push("webgl vertex shader medium int precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_INT).precision),a.push("webgl vertex shader medium int precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_INT).rangeMin),a.push("webgl vertex shader medium int precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.MEDIUM_INT).rangeMax),a.push("webgl vertex shader low int precision:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_INT).precision),a.push("webgl vertex shader low int precision rangeMin:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_INT).rangeMin),a.push("webgl vertex shader low int precision rangeMax:"+n.getShaderPrecisionFormat(n.VERTEX_SHADER,n.LOW_INT).rangeMax),a.push("webgl fragment shader high int precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_INT).precision),a.push("webgl fragment shader high int precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_INT).rangeMin),a.push("webgl fragment shader high int precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.HIGH_INT).rangeMax),
a.push("webgl fragment shader medium int precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_INT).precision),a.push("webgl fragment shader medium int precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_INT).rangeMin),a.push("webgl fragment shader medium int precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.MEDIUM_INT).rangeMax),a.push("webgl fragment shader low int precision:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_INT).precision),a.push("webgl fragment shader low int precision rangeMin:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_INT).rangeMin),a.push("webgl fragment shader low int precision rangeMax:"+n.getShaderPrecisionFormat(n.FRAGMENT_SHADER,n.LOW_INT).rangeMax),e(a.join("~"))):e(a.join("~"))}catch(t){return e("")}})})}(window);

!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.moment=t()}(this,function(){"use strict";var H;function _(){return H.apply(null,arguments)}function y(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function F(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function c(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function L(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;for(var t in e)if(c(e,t))return;return 1}function g(e){return void 0===e}function w(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function V(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function G(e,t){for(var n=[],s=e.length,i=0;i<s;++i)n.push(t(e[i],i));return n}function E(e,t){for(var n in t)c(t,n)&&(e[n]=t[n]);return c(t,"toString")&&(e.toString=t.toString),c(t,"valueOf")&&(e.valueOf=t.valueOf),e}function l(e,t,n,s){return Wt(e,t,n,s,!0).utc()}function p(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function A(e){var t,n,s=e._d&&!isNaN(e._d.getTime());return s&&(t=p(e),n=j.call(t.parsedDateParts,function(e){return null!=e}),s=t.overflow<0&&!t.empty&&!t.invalidEra&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n),e._strict)&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e)?s:(e._isValid=s,e._isValid)}function I(e){var t=l(NaN);return null!=e?E(p(t),e):p(t).userInvalidated=!0,t}var j=Array.prototype.some||function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1},Z=_.momentProperties=[],z=!1;function q(e,t){var n,s,i,r=Z.length;if(g(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),g(t._i)||(e._i=t._i),g(t._f)||(e._f=t._f),g(t._l)||(e._l=t._l),g(t._strict)||(e._strict=t._strict),g(t._tzm)||(e._tzm=t._tzm),g(t._isUTC)||(e._isUTC=t._isUTC),g(t._offset)||(e._offset=t._offset),g(t._pf)||(e._pf=p(t)),g(t._locale)||(e._locale=t._locale),0<r)for(n=0;n<r;n++)g(i=t[s=Z[n]])||(e[s]=i);return e}function $(e){q(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===z&&(z=!0,_.updateOffset(this),z=!1)}function k(e){return e instanceof $||null!=e&&null!=e._isAMomentObject}function B(e){!1===_.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function e(r,a){var o=!0;return E(function(){if(null!=_.deprecationHandler&&_.deprecationHandler(null,r),o){for(var e,t,n=[],s=arguments.length,i=0;i<s;i++){if(e="","object"==typeof arguments[i]){for(t in e+="\n["+i+"] ",arguments[0])c(arguments[0],t)&&(e+=t+": "+arguments[0][t]+", ");e=e.slice(0,-2)}else e=arguments[i];n.push(e)}B(r+"\nArguments: "+Array.prototype.slice.call(n).join("")+"\n"+(new Error).stack),o=!1}return a.apply(this,arguments)},a)}var J={};function Q(e,t){null!=_.deprecationHandler&&_.deprecationHandler(e,t),J[e]||(B(t),J[e]=!0)}function a(e){return"undefined"!=typeof Function&&e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function X(e,t){var n,s=E({},e);for(n in t)c(t,n)&&(F(e[n])&&F(t[n])?(s[n]={},E(s[n],e[n]),E(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)c(e,n)&&!c(t,n)&&F(e[n])&&(s[n]=E({},s[n]));return s}function K(e){null!=e&&this.set(e)}_.suppressDeprecationWarnings=!1,_.deprecationHandler=null;var ee=Object.keys||function(e){var t,n=[];for(t in e)c(e,t)&&n.push(t);return n};function r(e,t,n){var s=""+Math.abs(e);return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,t-s.length)).toString().substr(1)+s}var te=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,ne=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,se={},ie={};function s(e,t,n,s){var i="string"==typeof s?function(){return this[s]()}:s;e&&(ie[e]=i),t&&(ie[t[0]]=function(){return r(i.apply(this,arguments),t[1],t[2])}),n&&(ie[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function re(e,t){return e.isValid()?(t=ae(t,e.localeData()),se[t]=se[t]||function(s){for(var e,i=s.match(te),t=0,r=i.length;t<r;t++)ie[i[t]]?i[t]=ie[i[t]]:i[t]=(e=i[t]).match(/\[[\s\S]/)?e.replace(/^\[|\]$/g,""):e.replace(/\\/g,"");return function(e){for(var t="",n=0;n<r;n++)t+=a(i[n])?i[n].call(e,s):i[n];return t}}(t),se[t](e)):e.localeData().invalidDate()}function ae(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(ne.lastIndex=0;0<=n&&ne.test(e);)e=e.replace(ne,s),ne.lastIndex=0,--n;return e}var oe={D:"date",dates:"date",date:"date",d:"day",days:"day",day:"day",e:"weekday",weekdays:"weekday",weekday:"weekday",E:"isoWeekday",isoweekdays:"isoWeekday",isoweekday:"isoWeekday",DDD:"dayOfYear",dayofyears:"dayOfYear",dayofyear:"dayOfYear",h:"hour",hours:"hour",hour:"hour",ms:"millisecond",milliseconds:"millisecond",millisecond:"millisecond",m:"minute",minutes:"minute",minute:"minute",M:"month",months:"month",month:"month",Q:"quarter",quarters:"quarter",quarter:"quarter",s:"second",seconds:"second",second:"second",gg:"weekYear",weekyears:"weekYear",weekyear:"weekYear",GG:"isoWeekYear",isoweekyears:"isoWeekYear",isoweekyear:"isoWeekYear",w:"week",weeks:"week",week:"week",W:"isoWeek",isoweeks:"isoWeek",isoweek:"isoWeek",y:"year",years:"year",year:"year"};function o(e){return"string"==typeof e?oe[e]||oe[e.toLowerCase()]:void 0}function ue(e){var t,n,s={};for(n in e)c(e,n)&&(t=o(n))&&(s[t]=e[n]);return s}var le={date:9,day:11,weekday:11,isoWeekday:11,dayOfYear:4,hour:13,millisecond:16,minute:14,month:8,quarter:7,second:15,weekYear:1,isoWeekYear:1,week:5,isoWeek:5,year:1};var de=/\d/,t=/\d\d/,he=/\d{3}/,ce=/\d{4}/,fe=/[+-]?\d{6}/,n=/\d\d?/,me=/\d\d\d\d?/,_e=/\d\d\d\d\d\d?/,ye=/\d{1,3}/,ge=/\d{1,4}/,we=/[+-]?\d{1,6}/,pe=/\d+/,ke=/[+-]?\d+/,Me=/Z|[+-]\d\d:?\d\d/gi,ve=/Z|[+-]\d\d(?::?\d\d)?/gi,i=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,u=/^[1-9]\d?/,d=/^([1-9]\d|\d)/;function h(e,n,s){Ye[e]=a(n)?n:function(e,t){return e&&s?s:n}}function De(e,t){return c(Ye,e)?Ye[e](t._strict,t._locale):new RegExp(f(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function f(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function m(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function M(e){var e=+e,t=0;return t=0!=e&&isFinite(e)?m(e):t}var Ye={},Se={};function v(e,n){var t,s,i=n;for("string"==typeof e&&(e=[e]),w(n)&&(i=function(e,t){t[n]=M(e)}),s=e.length,t=0;t<s;t++)Se[e[t]]=i}function Oe(e,i){v(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}function be(e){return e%4==0&&e%100!=0||e%400==0}var D=0,Y=1,S=2,O=3,b=4,T=5,Te=6,xe=7,Ne=8;function We(e){return be(e)?366:365}s("Y",0,0,function(){var e=this.year();return e<=9999?r(e,4):"+"+e}),s(0,["YY",2],0,function(){return this.year()%100}),s(0,["YYYY",4],0,"year"),s(0,["YYYYY",5],0,"year"),s(0,["YYYYYY",6,!0],0,"year"),h("Y",ke),h("YY",n,t),h("YYYY",ge,ce),h("YYYYY",we,fe),h("YYYYYY",we,fe),v(["YYYYY","YYYYYY"],D),v("YYYY",function(e,t){t[D]=2===e.length?_.parseTwoDigitYear(e):M(e)}),v("YY",function(e,t){t[D]=_.parseTwoDigitYear(e)}),v("Y",function(e,t){t[D]=parseInt(e,10)}),_.parseTwoDigitYear=function(e){return M(e)+(68<M(e)?1900:2e3)};var x,Pe=Re("FullYear",!0);function Re(t,n){return function(e){return null!=e?(Ue(this,t,e),_.updateOffset(this,n),this):Ce(this,t)}}function Ce(e,t){if(!e.isValid())return NaN;var n=e._d,s=e._isUTC;switch(t){case"Milliseconds":return s?n.getUTCMilliseconds():n.getMilliseconds();case"Seconds":return s?n.getUTCSeconds():n.getSeconds();case"Minutes":return s?n.getUTCMinutes():n.getMinutes();case"Hours":return s?n.getUTCHours():n.getHours();case"Date":return s?n.getUTCDate():n.getDate();case"Day":return s?n.getUTCDay():n.getDay();case"Month":return s?n.getUTCMonth():n.getMonth();case"FullYear":return s?n.getUTCFullYear():n.getFullYear();default:return NaN}}function Ue(e,t,n){var s,i,r;if(e.isValid()&&!isNaN(n)){switch(s=e._d,i=e._isUTC,t){case"Milliseconds":return i?s.setUTCMilliseconds(n):s.setMilliseconds(n);case"Seconds":return i?s.setUTCSeconds(n):s.setSeconds(n);case"Minutes":return i?s.setUTCMinutes(n):s.setMinutes(n);case"Hours":return i?s.setUTCHours(n):s.setHours(n);case"Date":return i?s.setUTCDate(n):s.setDate(n);case"FullYear":break;default:return}t=n,r=e.month(),e=29!==(e=e.date())||1!==r||be(t)?e:28,i?s.setUTCFullYear(t,r,e):s.setFullYear(t,r,e)}}function He(e,t){var n;return isNaN(e)||isNaN(t)?NaN:(n=(t%(n=12)+n)%n,e+=(t-n)/12,1==n?be(e)?29:28:31-n%7%2)}x=Array.prototype.indexOf||function(e){for(var t=0;t<this.length;++t)if(this[t]===e)return t;return-1},s("M",["MM",2],"Mo",function(){return this.month()+1}),s("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),s("MMMM",0,0,function(e){return this.localeData().months(this,e)}),h("M",n,u),h("MM",n,t),h("MMM",function(e,t){return t.monthsShortRegex(e)}),h("MMMM",function(e,t){return t.monthsRegex(e)}),v(["M","MM"],function(e,t){t[Y]=M(e)-1}),v(["MMM","MMMM"],function(e,t,n,s){s=n._locale.monthsParse(e,s,n._strict);null!=s?t[Y]=s:p(n).invalidMonth=e});var Fe="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Le="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Ve=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,Ge=i,Ee=i;function Ae(e,t){if(e.isValid()){if("string"==typeof t)if(/^\d+$/.test(t))t=M(t);else if(!w(t=e.localeData().monthsParse(t)))return;var n=(n=e.date())<29?n:Math.min(n,He(e.year(),t));e._isUTC?e._d.setUTCMonth(t,n):e._d.setMonth(t,n)}}function Ie(e){return null!=e?(Ae(this,e),_.updateOffset(this,!0),this):Ce(this,"Month")}function je(){function e(e,t){return t.length-e.length}for(var t,n,s=[],i=[],r=[],a=0;a<12;a++)n=l([2e3,a]),t=f(this.monthsShort(n,"")),n=f(this.months(n,"")),s.push(t),i.push(n),r.push(n),r.push(t);s.sort(e),i.sort(e),r.sort(e),this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ze(e,t,n,s,i,r,a){var o;return e<100&&0<=e?(o=new Date(e+400,t,n,s,i,r,a),isFinite(o.getFullYear())&&o.setFullYear(e)):o=new Date(e,t,n,s,i,r,a),o}function ze(e){var t;return e<100&&0<=e?((t=Array.prototype.slice.call(arguments))[0]=e+400,t=new Date(Date.UTC.apply(null,t)),isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e)):t=new Date(Date.UTC.apply(null,arguments)),t}function qe(e,t,n){n=7+t-n;return n-(7+ze(e,0,n).getUTCDay()-t)%7-1}function $e(e,t,n,s,i){var r,t=1+7*(t-1)+(7+n-s)%7+qe(e,s,i),n=t<=0?We(r=e-1)+t:t>We(e)?(r=e+1,t-We(e)):(r=e,t);return{year:r,dayOfYear:n}}function Be(e,t,n){var s,i,r=qe(e.year(),t,n),r=Math.floor((e.dayOfYear()-r-1)/7)+1;return r<1?s=r+N(i=e.year()-1,t,n):r>N(e.year(),t,n)?(s=r-N(e.year(),t,n),i=e.year()+1):(i=e.year(),s=r),{week:s,year:i}}function N(e,t,n){var s=qe(e,t,n),t=qe(e+1,t,n);return(We(e)-s+t)/7}s("w",["ww",2],"wo","week"),s("W",["WW",2],"Wo","isoWeek"),h("w",n,u),h("ww",n,t),h("W",n,u),h("WW",n,t),Oe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=M(e)});function Je(e,t){return e.slice(t,7).concat(e.slice(0,t))}s("d",0,"do","day"),s("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),s("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),s("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),s("e",0,0,"weekday"),s("E",0,0,"isoWeekday"),h("d",n),h("e",n),h("E",n),h("dd",function(e,t){return t.weekdaysMinRegex(e)}),h("ddd",function(e,t){return t.weekdaysShortRegex(e)}),h("dddd",function(e,t){return t.weekdaysRegex(e)}),Oe(["dd","ddd","dddd"],function(e,t,n,s){s=n._locale.weekdaysParse(e,s,n._strict);null!=s?t.d=s:p(n).invalidWeekday=e}),Oe(["d","e","E"],function(e,t,n,s){t[s]=M(e)});var Qe="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Xe="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Ke="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),et=i,tt=i,nt=i;function st(){function e(e,t){return t.length-e.length}for(var t,n,s,i=[],r=[],a=[],o=[],u=0;u<7;u++)s=l([2e3,1]).day(u),t=f(this.weekdaysMin(s,"")),n=f(this.weekdaysShort(s,"")),s=f(this.weekdays(s,"")),i.push(t),r.push(n),a.push(s),o.push(t),o.push(n),o.push(s);i.sort(e),r.sort(e),a.sort(e),o.sort(e),this._weekdaysRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+r.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+i.join("|")+")","i")}function it(){return this.hours()%12||12}function rt(e,t){s(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function at(e,t){return t._meridiemParse}s("H",["HH",2],0,"hour"),s("h",["hh",2],0,it),s("k",["kk",2],0,function(){return this.hours()||24}),s("hmm",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)}),s("hmmss",0,0,function(){return""+it.apply(this)+r(this.minutes(),2)+r(this.seconds(),2)}),s("Hmm",0,0,function(){return""+this.hours()+r(this.minutes(),2)}),s("Hmmss",0,0,function(){return""+this.hours()+r(this.minutes(),2)+r(this.seconds(),2)}),rt("a",!0),rt("A",!1),h("a",at),h("A",at),h("H",n,d),h("h",n,u),h("k",n,u),h("HH",n,t),h("hh",n,t),h("kk",n,t),h("hmm",me),h("hmmss",_e),h("Hmm",me),h("Hmmss",_e),v(["H","HH"],O),v(["k","kk"],function(e,t,n){e=M(e);t[O]=24===e?0:e}),v(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),v(["h","hh"],function(e,t,n){t[O]=M(e),p(n).bigHour=!0}),v("hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s)),p(n).bigHour=!0}),v("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i)),p(n).bigHour=!0}),v("Hmm",function(e,t,n){var s=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s))}),v("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[O]=M(e.substr(0,s)),t[b]=M(e.substr(s,2)),t[T]=M(e.substr(i))});i=Re("Hours",!0);var ot,ut={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Fe,monthsShort:Le,week:{dow:0,doy:6},weekdays:Qe,weekdaysMin:Ke,weekdaysShort:Xe,meridiemParse:/[ap]\.?m?\.?/i},W={},lt={};function dt(e){return e&&e.toLowerCase().replace("_","-")}function ht(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=dt(e[r]).split("-")).length,n=(n=dt(e[r+1]))?n.split("-"):null;0<t;){if(s=ct(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&function(e,t){for(var n=Math.min(e.length,t.length),s=0;s<n;s+=1)if(e[s]!==t[s])return s;return n}(i,n)>=t-1)break;t--}r++}return ot}function ct(t){var e,n;if(void 0===W[t]&&"undefined"!=typeof module&&module&&module.exports&&(n=t)&&n.match("^[^/\\\\]*$"))try{e=ot._abbr,require("./locale/"+t),ft(e)}catch(e){W[t]=null}return W[t]}function ft(e,t){return e&&((t=g(t)?P(e):mt(e,t))?ot=t:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),ot._abbr}function mt(e,t){if(null===t)return delete W[e],null;var n,s=ut;if(t.abbr=e,null!=W[e])Q("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=W[e]._config;else if(null!=t.parentLocale)if(null!=W[t.parentLocale])s=W[t.parentLocale]._config;else{if(null==(n=ct(t.parentLocale)))return lt[t.parentLocale]||(lt[t.parentLocale]=[]),lt[t.parentLocale].push({name:e,config:t}),null;s=n._config}return W[e]=new K(X(s,t)),lt[e]&&lt[e].forEach(function(e){mt(e.name,e.config)}),ft(e),W[e]}function P(e){var t;if(!(e=e&&e._locale&&e._locale._abbr?e._locale._abbr:e))return ot;if(!y(e)){if(t=ct(e))return t;e=[e]}return ht(e)}function _t(e){var t=e._a;return t&&-2===p(e).overflow&&(t=t[Y]<0||11<t[Y]?Y:t[S]<1||t[S]>He(t[D],t[Y])?S:t[O]<0||24<t[O]||24===t[O]&&(0!==t[b]||0!==t[T]||0!==t[Te])?O:t[b]<0||59<t[b]?b:t[T]<0||59<t[T]?T:t[Te]<0||999<t[Te]?Te:-1,p(e)._overflowDayOfYear&&(t<D||S<t)&&(t=S),p(e)._overflowWeeks&&-1===t&&(t=xe),p(e)._overflowWeekday&&-1===t&&(t=Ne),p(e).overflow=t),e}var yt=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,gt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,wt=/Z|[+-]\d\d(?::?\d\d)?/,pt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],kt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Mt=/^\/?Date\((-?\d+)/i,vt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,Dt={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Yt(e){var t,n,s,i,r,a,o=e._i,u=yt.exec(o)||gt.exec(o),o=pt.length,l=kt.length;if(u){for(p(e).iso=!0,t=0,n=o;t<n;t++)if(pt[t][1].exec(u[1])){i=pt[t][0],s=!1!==pt[t][2];break}if(null==i)e._isValid=!1;else{if(u[3]){for(t=0,n=l;t<n;t++)if(kt[t][1].exec(u[3])){r=(u[2]||" ")+kt[t][0];break}if(null==r)return void(e._isValid=!1)}if(s||null==r){if(u[4]){if(!wt.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),xt(e)}else e._isValid=!1}}else e._isValid=!1}function St(e,t,n,s,i,r){e=[function(e){e=parseInt(e,10);{if(e<=49)return 2e3+e;if(e<=999)return 1900+e}return e}(e),Le.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&e.push(parseInt(r,10)),e}function Ot(e){var t,n,s=vt.exec(e._i.replace(/\([^()]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));s?(t=St(s[4],s[3],s[2],s[5],s[6],s[7]),function(e,t,n){if(!e||Xe.indexOf(e)===new Date(t[0],t[1],t[2]).getDay())return 1;p(n).weekdayMismatch=!0,n._isValid=!1}(s[1],t,e)&&(e._a=t,e._tzm=(t=s[8],n=s[9],s=s[10],t?Dt[t]:n?0:60*(((t=parseInt(s,10))-(n=t%100))/100)+n),e._d=ze.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),p(e).rfc2822=!0)):e._isValid=!1}function bt(e,t,n){return null!=e?e:null!=t?t:n}function Tt(e){var t,n,s,i,r,a,o,u,l,d,h,c=[];if(!e._d){for(s=e,i=new Date(_.now()),n=s._useUTC?[i.getUTCFullYear(),i.getUTCMonth(),i.getUTCDate()]:[i.getFullYear(),i.getMonth(),i.getDate()],e._w&&null==e._a[S]&&null==e._a[Y]&&(null!=(i=(s=e)._w).GG||null!=i.W||null!=i.E?(u=1,l=4,r=bt(i.GG,s._a[D],Be(R(),1,4).year),a=bt(i.W,1),((o=bt(i.E,1))<1||7<o)&&(d=!0)):(u=s._locale._week.dow,l=s._locale._week.doy,h=Be(R(),u,l),r=bt(i.gg,s._a[D],h.year),a=bt(i.w,h.week),null!=i.d?((o=i.d)<0||6<o)&&(d=!0):null!=i.e?(o=i.e+u,(i.e<0||6<i.e)&&(d=!0)):o=u),a<1||a>N(r,u,l)?p(s)._overflowWeeks=!0:null!=d?p(s)._overflowWeekday=!0:(h=$e(r,a,o,u,l),s._a[D]=h.year,s._dayOfYear=h.dayOfYear)),null!=e._dayOfYear&&(i=bt(e._a[D],n[D]),(e._dayOfYear>We(i)||0===e._dayOfYear)&&(p(e)._overflowDayOfYear=!0),d=ze(i,0,e._dayOfYear),e._a[Y]=d.getUTCMonth(),e._a[S]=d.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=c[t]=n[t];for(;t<7;t++)e._a[t]=c[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[O]&&0===e._a[b]&&0===e._a[T]&&0===e._a[Te]&&(e._nextDay=!0,e._a[O]=0),e._d=(e._useUTC?ze:Ze).apply(null,c),r=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[O]=24),e._w&&void 0!==e._w.d&&e._w.d!==r&&(p(e).weekdayMismatch=!0)}}function xt(e){if(e._f===_.ISO_8601)Yt(e);else if(e._f===_.RFC_2822)Ot(e);else{e._a=[],p(e).empty=!0;for(var t,n,s,i,r,a=""+e._i,o=a.length,u=0,l=ae(e._f,e._locale).match(te)||[],d=l.length,h=0;h<d;h++)n=l[h],(t=(a.match(De(n,e))||[])[0])&&(0<(s=a.substr(0,a.indexOf(t))).length&&p(e).unusedInput.push(s),a=a.slice(a.indexOf(t)+t.length),u+=t.length),ie[n]?(t?p(e).empty=!1:p(e).unusedTokens.push(n),s=n,r=e,null!=(i=t)&&c(Se,s)&&Se[s](i,r._a,r,s)):e._strict&&!t&&p(e).unusedTokens.push(n);p(e).charsLeftOver=o-u,0<a.length&&p(e).unusedInput.push(a),e._a[O]<=12&&!0===p(e).bigHour&&0<e._a[O]&&(p(e).bigHour=void 0),p(e).parsedDateParts=e._a.slice(0),p(e).meridiem=e._meridiem,e._a[O]=function(e,t,n){if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):null!=e.isPM?((e=e.isPM(n))&&t<12&&(t+=12),t=e||12!==t?t:0):t}(e._locale,e._a[O],e._meridiem),null!==(o=p(e).era)&&(e._a[D]=e._locale.erasConvertYear(o,e._a[D])),Tt(e),_t(e)}}function Nt(e){var t,n,s,i=e._i,r=e._f;if(e._locale=e._locale||P(e._l),null===i||void 0===r&&""===i)return I({nullInput:!0});if("string"==typeof i&&(e._i=i=e._locale.preparse(i)),k(i))return new $(_t(i));if(V(i))e._d=i;else if(y(r)){var a,o,u,l,d,h,c=e,f=!1,m=c._f.length;if(0===m)p(c).invalidFormat=!0,c._d=new Date(NaN);else{for(l=0;l<m;l++)d=0,h=!1,a=q({},c),null!=c._useUTC&&(a._useUTC=c._useUTC),a._f=c._f[l],xt(a),A(a)&&(h=!0),d=(d+=p(a).charsLeftOver)+10*p(a).unusedTokens.length,p(a).score=d,f?d<u&&(u=d,o=a):(null==u||d<u||h)&&(u=d,o=a,h)&&(f=!0);E(c,o||a)}}else if(r)xt(e);else if(g(r=(i=e)._i))i._d=new Date(_.now());else V(r)?i._d=new Date(r.valueOf()):"string"==typeof r?(n=i,null!==(t=Mt.exec(n._i))?n._d=new Date(+t[1]):(Yt(n),!1===n._isValid&&(delete n._isValid,Ot(n),!1===n._isValid)&&(delete n._isValid,n._strict?n._isValid=!1:_.createFromInputFallback(n)))):y(r)?(i._a=G(r.slice(0),function(e){return parseInt(e,10)}),Tt(i)):F(r)?(t=i)._d||(s=void 0===(n=ue(t._i)).day?n.date:n.day,t._a=G([n.year,n.month,s,n.hour,n.minute,n.second,n.millisecond],function(e){return e&&parseInt(e,10)}),Tt(t)):w(r)?i._d=new Date(r):_.createFromInputFallback(i);return A(e)||(e._d=null),e}function Wt(e,t,n,s,i){var r={};return!0!==t&&!1!==t||(s=t,t=void 0),!0!==n&&!1!==n||(s=n,n=void 0),(F(e)&&L(e)||y(e)&&0===e.length)&&(e=void 0),r._isAMomentObject=!0,r._useUTC=r._isUTC=i,r._l=n,r._i=e,r._f=t,r._strict=s,(i=new $(_t(Nt(i=r))))._nextDay&&(i.add(1,"d"),i._nextDay=void 0),i}function R(e,t,n,s){return Wt(e,t,n,s,!1)}_.createFromInputFallback=e("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),_.ISO_8601=function(){},_.RFC_2822=function(){};me=e("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:I()}),_e=e("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=R.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:I()});function Pt(e,t){var n,s;if(!(t=1===t.length&&y(t[0])?t[0]:t).length)return R();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Rt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ct(e){var e=ue(e),t=e.year||0,n=e.quarter||0,s=e.month||0,i=e.week||e.isoWeek||0,r=e.day||0,a=e.hour||0,o=e.minute||0,u=e.second||0,l=e.millisecond||0;this._isValid=function(e){var t,n,s=!1,i=Rt.length;for(t in e)if(c(e,t)&&(-1===x.call(Rt,t)||null!=e[t]&&isNaN(e[t])))return!1;for(n=0;n<i;++n)if(e[Rt[n]]){if(s)return!1;parseFloat(e[Rt[n]])!==M(e[Rt[n]])&&(s=!0)}return!0}(e),this._milliseconds=+l+1e3*u+6e4*o+1e3*a*60*60,this._days=+r+7*i,this._months=+s+3*n+12*t,this._data={},this._locale=P(),this._bubble()}function Ut(e){return e instanceof Ct}function Ht(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){s(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+r(~~(e/60),2)+n+r(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),h("Z",ve),h("ZZ",ve),v(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Vt(ve,e)});var Lt=/([\+\-]|\d\d)/gi;function Vt(e,t){var t=(t||"").match(e);return null===t?null:0===(t=60*(e=((t[t.length-1]||[])+"").match(Lt)||["-",0,0])[1]+M(e[2]))?0:"+"===e[0]?t:-t}function Gt(e,t){var n;return t._isUTC?(t=t.clone(),n=(k(e)||V(e)?e:R(e)).valueOf()-t.valueOf(),t._d.setTime(t._d.valueOf()+n),_.updateOffset(t,!1),t):R(e).local()}function Et(e){return-Math.round(e._d.getTimezoneOffset())}function At(){return!!this.isValid()&&this._isUTC&&0===this._offset}_.updateOffset=function(){};var It=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,jt=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function C(e,t){var n,s=e;return Ut(e)?s={ms:e._milliseconds,d:e._days,M:e._months}:w(e)||!isNaN(+e)?(s={},t?s[t]=+e:s.milliseconds=+e):(t=It.exec(e))?(n="-"===t[1]?-1:1,s={y:0,d:M(t[S])*n,h:M(t[O])*n,m:M(t[b])*n,s:M(t[T])*n,ms:M(Ht(1e3*t[Te]))*n}):(t=jt.exec(e))?(n="-"===t[1]?-1:1,s={y:Zt(t[2],n),M:Zt(t[3],n),w:Zt(t[4],n),d:Zt(t[5],n),h:Zt(t[6],n),m:Zt(t[7],n),s:Zt(t[8],n)}):null==s?s={}:"object"==typeof s&&("from"in s||"to"in s)&&(t=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Gt(t,e),e.isBefore(t)?n=zt(e,t):((n=zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(R(s.from),R(s.to)),(s={}).ms=t.milliseconds,s.M=t.months),n=new Ct(s),Ut(e)&&c(e,"_locale")&&(n._locale=e._locale),Ut(e)&&c(e,"_isValid")&&(n._isValid=e._isValid),n}function Zt(e,t){e=e&&parseFloat(e.replace(",","."));return(isNaN(e)?0:e)*t}function zt(e,t){var n={};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function qt(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(Q(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),$t(this,C(e,t),s),this}}function $t(e,t,n,s){var i=t._milliseconds,r=Ht(t._days),t=Ht(t._months);e.isValid()&&(s=null==s||s,t&&Ae(e,Ce(e,"Month")+t*n),r&&Ue(e,"Date",Ce(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s)&&_.updateOffset(e,r||t)}C.fn=Ct.prototype,C.invalid=function(){return C(NaN)};Fe=qt(1,"add"),Qe=qt(-1,"subtract");function Bt(e){return"string"==typeof e||e instanceof String}function Jt(e){return k(e)||V(e)||Bt(e)||w(e)||function(t){var e=y(t),n=!1;e&&(n=0===t.filter(function(e){return!w(e)&&Bt(t)}).length);return e&&n}(e)||function(e){var t,n,s=F(e)&&!L(e),i=!1,r=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"],a=r.length;for(t=0;t<a;t+=1)n=r[t],i=i||c(e,n);return s&&i}(e)||null==e}function Qt(e,t){var n,s;return e.date()<t.date()?-Qt(t,e):-((n=12*(t.year()-e.year())+(t.month()-e.month()))+(t-(s=e.clone().add(n,"months"))<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(1+n,"months")-s)))||0}function Xt(e){return void 0===e?this._locale._abbr:(null!=(e=P(e))&&(this._locale=e),this)}_.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",_.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";Ke=e("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function Kt(){return this._locale}var en=126227808e5;function tn(e,t){return(e%t+t)%t}function nn(e,t,n){return e<100&&0<=e?new Date(e+400,t,n)-en:new Date(e,t,n).valueOf()}function sn(e,t,n){return e<100&&0<=e?Date.UTC(e+400,t,n)-en:Date.UTC(e,t,n)}function rn(e,t){return t.erasAbbrRegex(e)}function an(){for(var e,t,n,s=[],i=[],r=[],a=[],o=this.eras(),u=0,l=o.length;u<l;++u)e=f(o[u].name),t=f(o[u].abbr),n=f(o[u].narrow),i.push(e),s.push(t),r.push(n),a.push(e),a.push(t),a.push(n);this._erasRegex=new RegExp("^("+a.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+s.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+r.join("|")+")","i")}function on(e,t){s(0,[e,e.length],0,t)}function un(e,t,n,s,i){var r;return null==e?Be(this,s,i).year:(r=N(e,s,i),function(e,t,n,s,i){e=$e(e,t,n,s,i),t=ze(e.year,0,e.dayOfYear);return this.year(t.getUTCFullYear()),this.month(t.getUTCMonth()),this.date(t.getUTCDate()),this}.call(this,e,t=r<t?r:t,n,s,i))}s("N",0,0,"eraAbbr"),s("NN",0,0,"eraAbbr"),s("NNN",0,0,"eraAbbr"),s("NNNN",0,0,"eraName"),s("NNNNN",0,0,"eraNarrow"),s("y",["y",1],"yo","eraYear"),s("y",["yy",2],0,"eraYear"),s("y",["yyy",3],0,"eraYear"),s("y",["yyyy",4],0,"eraYear"),h("N",rn),h("NN",rn),h("NNN",rn),h("NNNN",function(e,t){return t.erasNameRegex(e)}),h("NNNNN",function(e,t){return t.erasNarrowRegex(e)}),v(["N","NN","NNN","NNNN","NNNNN"],function(e,t,n,s){s=n._locale.erasParse(e,s,n._strict);s?p(n).era=s:p(n).invalidEra=e}),h("y",pe),h("yy",pe),h("yyy",pe),h("yyyy",pe),h("yo",function(e,t){return t._eraYearOrdinalRegex||pe}),v(["y","yy","yyy","yyyy"],D),v(["yo"],function(e,t,n,s){var i;n._locale._eraYearOrdinalRegex&&(i=e.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?t[D]=n._locale.eraYearOrdinalParse(e,i):t[D]=parseInt(e,10)}),s(0,["gg",2],0,function(){return this.weekYear()%100}),s(0,["GG",2],0,function(){return this.isoWeekYear()%100}),on("gggg","weekYear"),on("ggggg","weekYear"),on("GGGG","isoWeekYear"),on("GGGGG","isoWeekYear"),h("G",ke),h("g",ke),h("GG",n,t),h("gg",n,t),h("GGGG",ge,ce),h("gggg",ge,ce),h("GGGGG",we,fe),h("ggggg",we,fe),Oe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=M(e)}),Oe(["gg","GG"],function(e,t,n,s){t[s]=_.parseTwoDigitYear(e)}),s("Q",0,"Qo","quarter"),h("Q",de),v("Q",function(e,t){t[Y]=3*(M(e)-1)}),s("D",["DD",2],"Do","date"),h("D",n,u),h("DD",n,t),h("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),v(["D","DD"],S),v("Do",function(e,t){t[S]=M(e.match(n)[0])});ge=Re("Date",!0);s("DDD",["DDDD",3],"DDDo","dayOfYear"),h("DDD",ye),h("DDDD",he),v(["DDD","DDDD"],function(e,t,n){n._dayOfYear=M(e)}),s("m",["mm",2],0,"minute"),h("m",n,d),h("mm",n,t),v(["m","mm"],b);var ln,ce=Re("Minutes",!1),we=(s("s",["ss",2],0,"second"),h("s",n,d),h("ss",n,t),v(["s","ss"],T),Re("Seconds",!1));for(s("S",0,0,function(){return~~(this.millisecond()/100)}),s(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),s(0,["SSS",3],0,"millisecond"),s(0,["SSSS",4],0,function(){return 10*this.millisecond()}),s(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),s(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),s(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),s(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),s(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),h("S",ye,de),h("SS",ye,t),h("SSS",ye,he),ln="SSSS";ln.length<=9;ln+="S")h(ln,pe);function dn(e,t){t[Te]=M(1e3*("0."+e))}for(ln="S";ln.length<=9;ln+="S")v(ln,dn);fe=Re("Milliseconds",!1),s("z",0,0,"zoneAbbr"),s("zz",0,0,"zoneName");u=$.prototype;function hn(e){return e}u.add=Fe,u.calendar=function(e,t){1===arguments.length&&(arguments[0]?Jt(arguments[0])?(e=arguments[0],t=void 0):function(e){for(var t=F(e)&&!L(e),n=!1,s=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"],i=0;i<s.length;i+=1)n=n||c(e,s[i]);return t&&n}(arguments[0])&&(t=arguments[0],e=void 0):t=e=void 0);var e=e||R(),n=Gt(e,this).startOf("day"),n=_.calendarFormat(this,n)||"sameElse",t=t&&(a(t[n])?t[n].call(this,e):t[n]);return this.format(t||this.localeData().calendar(n,this,R(e)))},u.clone=function(){return new $(this)},u.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Gt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=o(t)){case"year":r=Qt(this,s)/12;break;case"month":r=Qt(this,s);break;case"quarter":r=Qt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:m(r)},u.endOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year()+1,0,1)-1;break;case"quarter":t=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":t=n(this.year(),this.month()+1,1)-1;break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":t=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":t=this._d.valueOf(),t+=36e5-tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5)-1;break;case"minute":t=this._d.valueOf(),t+=6e4-tn(t,6e4)-1;break;case"second":t=this._d.valueOf(),t+=1e3-tn(t,1e3)-1;break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.format=function(e){return e=e||(this.isUtc()?_.defaultFormatUtc:_.defaultFormat),e=re(this,e),this.localeData().postformat(e)},u.from=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.fromNow=function(e){return this.from(R(),e)},u.to=function(e,t){return this.isValid()&&(k(e)&&e.isValid()||R(e).isValid())?C({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},u.toNow=function(e){return this.to(R(),e)},u.get=function(e){return a(this[e=o(e)])?this[e]():this},u.invalidAt=function(){return p(this).overflow},u.isAfter=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()>e.valueOf():e.valueOf()<this.clone().startOf(t).valueOf())},u.isBefore=function(e,t){return e=k(e)?e:R(e),!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()<e.valueOf():this.clone().endOf(t).valueOf()<e.valueOf())},u.isBetween=function(e,t,n,s){return e=k(e)?e:R(e),t=k(t)?t:R(t),!!(this.isValid()&&e.isValid()&&t.isValid())&&("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},u.isSame=function(e,t){var e=k(e)?e:R(e);return!(!this.isValid()||!e.isValid())&&("millisecond"===(t=o(t)||"millisecond")?this.valueOf()===e.valueOf():(e=e.valueOf(),this.clone().startOf(t).valueOf()<=e&&e<=this.clone().endOf(t).valueOf()))},u.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},u.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},u.isValid=function(){return A(this)},u.lang=Ke,u.locale=Xt,u.localeData=Kt,u.max=_e,u.min=me,u.parsingFlags=function(){return E({},p(this))},u.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t,n=[];for(t in e)c(e,t)&&n.push({unit:t,priority:le[t]});return n.sort(function(e,t){return e.priority-t.priority}),n}(e=ue(e)),s=n.length,i=0;i<s;i++)this[n[i].unit](e[n[i].unit]);else if(a(this[e=o(e)]))return this[e](t);return this},u.startOf=function(e){var t,n;if(void 0!==(e=o(e))&&"millisecond"!==e&&this.isValid()){switch(n=this._isUTC?sn:nn,e){case"year":t=n(this.year(),0,1);break;case"quarter":t=n(this.year(),this.month()-this.month()%3,1);break;case"month":t=n(this.year(),this.month(),1);break;case"week":t=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":t=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":t=n(this.year(),this.month(),this.date());break;case"hour":t=this._d.valueOf(),t-=tn(t+(this._isUTC?0:6e4*this.utcOffset()),36e5);break;case"minute":t=this._d.valueOf(),t-=tn(t,6e4);break;case"second":t=this._d.valueOf(),t-=tn(t,1e3);break}this._d.setTime(t),_.updateOffset(this,!0)}return this},u.subtract=Qe,u.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},u.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},u.toDate=function(){return new Date(this.valueOf())},u.toISOString=function(e){var t;return this.isValid()?(t=(e=!0!==e)?this.clone().utc():this).year()<0||9999<t.year()?re(t,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):a(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",re(t,"Z")):re(t,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ"):null},u.inspect=function(){var e,t,n;return this.isValid()?(t="moment",e="",this.isLocal()||(t=0===this.utcOffset()?"moment.utc":"moment.parseZone",e="Z"),t="["+t+'("]',n=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",this.format(t+n+"-MM-DD[T]HH:mm:ss.SSS"+(e+'[")]'))):"moment.invalid(/* "+this._i+" */)"},"undefined"!=typeof Symbol&&null!=Symbol.for&&(u[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),u.toJSON=function(){return this.isValid()?this.toISOString():null},u.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},u.unix=function(){return Math.floor(this.valueOf()/1e3)},u.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},u.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},u.eraName=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].name;if(t[n].until<=e&&e<=t[n].since)return t[n].name}return""},u.eraNarrow=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].narrow;if(t[n].until<=e&&e<=t[n].since)return t[n].narrow}return""},u.eraAbbr=function(){for(var e,t=this.localeData().eras(),n=0,s=t.length;n<s;++n){if(e=this.clone().startOf("day").valueOf(),t[n].since<=e&&e<=t[n].until)return t[n].abbr;if(t[n].until<=e&&e<=t[n].since)return t[n].abbr}return""},u.eraYear=function(){for(var e,t,n=this.localeData().eras(),s=0,i=n.length;s<i;++s)if(e=n[s].since<=n[s].until?1:-1,t=this.clone().startOf("day").valueOf(),n[s].since<=t&&t<=n[s].until||n[s].until<=t&&t<=n[s].since)return(this.year()-_(n[s].since).year())*e+n[s].offset;return this.year()},u.year=Pe,u.isLeapYear=function(){return be(this.year())},u.weekYear=function(e){return un.call(this,e,this.week(),this.weekday()+this.localeData()._week.dow,this.localeData()._week.dow,this.localeData()._week.doy)},u.isoWeekYear=function(e){return un.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},u.quarter=u.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},u.month=Ie,u.daysInMonth=function(){return He(this.year(),this.month())},u.week=u.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},u.isoWeek=u.isoWeeks=function(e){var t=Be(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},u.weeksInYear=function(){var e=this.localeData()._week;return N(this.year(),e.dow,e.doy)},u.weeksInWeekYear=function(){var e=this.localeData()._week;return N(this.weekYear(),e.dow,e.doy)},u.isoWeeksInYear=function(){return N(this.year(),1,4)},u.isoWeeksInISOWeekYear=function(){return N(this.isoWeekYear(),1,4)},u.date=ge,u.day=u.days=function(e){var t,n,s;return this.isValid()?(t=Ce(this,"Day"),null!=e?(n=e,s=this.localeData(),e="string"!=typeof n?n:isNaN(n)?"number"==typeof(n=s.weekdaysParse(n))?n:null:parseInt(n,10),this.add(e-t,"d")):t):null!=e?this:NaN},u.weekday=function(e){var t;return this.isValid()?(t=(this.day()+7-this.localeData()._week.dow)%7,null==e?t:this.add(e-t,"d")):null!=e?this:NaN},u.isoWeekday=function(e){var t,n;return this.isValid()?null!=e?(t=e,n=this.localeData(),n="string"==typeof t?n.weekdaysParse(t)%7||7:isNaN(t)?null:t,this.day(this.day()%7?n:n-7)):this.day()||7:null!=e?this:NaN},u.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},u.hour=u.hours=i,u.minute=u.minutes=ce,u.second=u.seconds=we,u.millisecond=u.milliseconds=fe,u.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null==e)return this._isUTC?i:Et(this);if("string"==typeof e){if(null===(e=Vt(ve,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Et(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?$t(this,C(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,_.updateOffset(this,!0),this._changeInProgress=null)),this},u.utc=function(e){return this.utcOffset(0,e)},u.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e)&&this.subtract(Et(this),"m"),this},u.parseZone=function(){var e;return null!=this._tzm?this.utcOffset(this._tzm,!1,!0):"string"==typeof this._i&&(null!=(e=Vt(Me,this._i))?this.utcOffset(e):this.utcOffset(0,!0)),this},u.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?R(e).utcOffset():0,(this.utcOffset()-e)%60==0)},u.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},u.isLocal=function(){return!!this.isValid()&&!this._isUTC},u.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},u.isUtc=At,u.isUTC=At,u.zoneAbbr=function(){return this._isUTC?"UTC":""},u.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},u.dates=e("dates accessor is deprecated. Use date instead.",ge),u.months=e("months accessor is deprecated. Use month instead",Ie),u.years=e("years accessor is deprecated. Use year instead",Pe),u.zone=e("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?(this.utcOffset(e="string"!=typeof e?-e:e,t),this):-this.utcOffset()}),u.isDSTShifted=e("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){var e,t;return g(this._isDSTShifted)&&(q(e={},this),(e=Nt(e))._a?(t=(e._isUTC?l:R)(e._a),this._isDSTShifted=this.isValid()&&0<function(e,t,n){for(var s=Math.min(e.length,t.length),i=Math.abs(e.length-t.length),r=0,a=0;a<s;a++)(n&&e[a]!==t[a]||!n&&M(e[a])!==M(t[a]))&&r++;return r+i}(e._a,t.toArray())):this._isDSTShifted=!1),this._isDSTShifted});d=K.prototype;function cn(e,t,n,s){var i=P(),s=l().set(s,t);return i[n](s,e)}function fn(e,t,n){if(w(e)&&(t=e,e=void 0),e=e||"",null!=t)return cn(e,t,n,"month");for(var s=[],i=0;i<12;i++)s[i]=cn(e,i,n,"month");return s}function mn(e,t,n,s){t=("boolean"==typeof e?w(t)&&(n=t,t=void 0):(t=e,e=!1,w(n=t)&&(n=t,t=void 0)),t||"");var i,r=P(),a=e?r._week.dow:0,o=[];if(null!=n)return cn(t,(n+a)%7,s,"day");for(i=0;i<7;i++)o[i]=cn(t,(i+a)%7,s,"day");return o}d.calendar=function(e,t,n){return a(e=this._calendar[e]||this._calendar.sameElse)?e.call(t,n):e},d.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.match(te).map(function(e){return"MMMM"===e||"MM"===e||"DD"===e||"dddd"===e?e.slice(1):e}).join(""),this._longDateFormat[e])},d.invalidDate=function(){return this._invalidDate},d.ordinal=function(e){return this._ordinal.replace("%d",e)},d.preparse=hn,d.postformat=hn,d.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return a(i)?i(e,t,n,s):i.replace(/%d/i,e)},d.pastFuture=function(e,t){return a(e=this._relativeTime[0<e?"future":"past"])?e(t):e.replace(/%s/i,t)},d.set=function(e){var t,n;for(n in e)c(e,n)&&(a(t=e[n])?this[n]=t:this["_"+n]=t);this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},d.eras=function(e,t){for(var n,s=this._eras||P("en")._eras,i=0,r=s.length;i<r;++i){switch(typeof s[i].since){case"string":n=_(s[i].since).startOf("day"),s[i].since=n.valueOf();break}switch(typeof s[i].until){case"undefined":s[i].until=1/0;break;case"string":n=_(s[i].until).startOf("day").valueOf(),s[i].until=n.valueOf();break}}return s},d.erasParse=function(e,t,n){var s,i,r,a,o,u=this.eras();for(e=e.toUpperCase(),s=0,i=u.length;s<i;++s)if(r=u[s].name.toUpperCase(),a=u[s].abbr.toUpperCase(),o=u[s].narrow.toUpperCase(),n)switch(t){case"N":case"NN":case"NNN":if(a===e)return u[s];break;case"NNNN":if(r===e)return u[s];break;case"NNNNN":if(o===e)return u[s];break}else if(0<=[r,a,o].indexOf(e))return u[s]},d.erasConvertYear=function(e,t){var n=e.since<=e.until?1:-1;return void 0===t?_(e.since).year():_(e.since).year()+(t-e.offset)*n},d.erasAbbrRegex=function(e){return c(this,"_erasAbbrRegex")||an.call(this),e?this._erasAbbrRegex:this._erasRegex},d.erasNameRegex=function(e){return c(this,"_erasNameRegex")||an.call(this),e?this._erasNameRegex:this._erasRegex},d.erasNarrowRegex=function(e){return c(this,"_erasNarrowRegex")||an.call(this),e?this._erasNarrowRegex:this._erasRegex},d.months=function(e,t){return e?(y(this._months)?this._months:this._months[(this._months.isFormat||Ve).test(t)?"format":"standalone"])[e.month()]:y(this._months)?this._months:this._months.standalone},d.monthsShort=function(e,t){return e?(y(this._monthsShort)?this._monthsShort:this._monthsShort[Ve.test(t)?"format":"standalone"])[e.month()]:y(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},d.monthsParse=function(e,t,n){var s,i;if(this._monthsParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=l([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))?i:null:"MMM"===t?-1!==(i=x.call(this._shortMonthsParse,e))||-1!==(i=x.call(this._longMonthsParse,e))?i:null:-1!==(i=x.call(this._longMonthsParse,e))||-1!==(i=x.call(this._shortMonthsParse,e))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=l([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(i="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(i.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},d.monthsRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsStrictRegex:this._monthsRegex):(c(this,"_monthsRegex")||(this._monthsRegex=Ee),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},d.monthsShortRegex=function(e){return this._monthsParseExact?(c(this,"_monthsRegex")||je.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(c(this,"_monthsShortRegex")||(this._monthsShortRegex=Ge),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},d.week=function(e){return Be(e,this._week.dow,this._week.doy).week},d.firstDayOfYear=function(){return this._week.doy},d.firstDayOfWeek=function(){return this._week.dow},d.weekdays=function(e,t){return t=y(this._weekdays)?this._weekdays:this._weekdays[e&&!0!==e&&this._weekdays.isFormat.test(t)?"format":"standalone"],!0===e?Je(t,this._week.dow):e?t[e.day()]:t},d.weekdaysMin=function(e){return!0===e?Je(this._weekdaysMin,this._week.dow):e?this._weekdaysMin[e.day()]:this._weekdaysMin},d.weekdaysShort=function(e){return!0===e?Je(this._weekdaysShort,this._week.dow):e?this._weekdaysShort[e.day()]:this._weekdaysShort},d.weekdaysParse=function(e,t,n){var s,i;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,e=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=l([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"dddd"===t?-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:"ddd"===t?-1!==(i=x.call(this._shortWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._minWeekdaysParse,e))?i:null:-1!==(i=x.call(this._minWeekdaysParse,e))||-1!==(i=x.call(this._weekdaysParse,e))||-1!==(i=x.call(this._shortWeekdaysParse,e))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=l([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(i="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(i.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},d.weekdaysRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(c(this,"_weekdaysRegex")||(this._weekdaysRegex=et),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},d.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(c(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=tt),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},d.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(c(this,"_weekdaysRegex")||st.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(c(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=nt),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},d.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},d.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ft("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===M(e%100/10)?"th":1==t?"st":2==t?"nd":3==t?"rd":"th")}}),_.lang=e("moment.lang is deprecated. Use moment.locale instead.",ft),_.langData=e("moment.langData is deprecated. Use moment.localeData instead.",P);var _n=Math.abs;function yn(e,t,n,s){t=C(t,n);return e._milliseconds+=s*t._milliseconds,e._days+=s*t._days,e._months+=s*t._months,e._bubble()}function gn(e){return e<0?Math.floor(e):Math.ceil(e)}function wn(e){return 4800*e/146097}function pn(e){return 146097*e/4800}function kn(e){return function(){return this.as(e)}}de=kn("ms"),t=kn("s"),ye=kn("m"),he=kn("h"),Fe=kn("d"),_e=kn("w"),me=kn("M"),Qe=kn("Q"),i=kn("y"),ce=de;function Mn(e){return function(){return this.isValid()?this._data[e]:NaN}}var we=Mn("milliseconds"),fe=Mn("seconds"),ge=Mn("minutes"),Pe=Mn("hours"),d=Mn("days"),vn=Mn("months"),Dn=Mn("years");var Yn=Math.round,Sn={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};function On(e,t,n,s){var i=C(e).abs(),r=Yn(i.as("s")),a=Yn(i.as("m")),o=Yn(i.as("h")),u=Yn(i.as("d")),l=Yn(i.as("M")),d=Yn(i.as("w")),i=Yn(i.as("y")),r=(r<=n.ss?["s",r]:r<n.s&&["ss",r])||(a<=1?["m"]:a<n.m&&["mm",a])||(o<=1?["h"]:o<n.h&&["hh",o])||(u<=1?["d"]:u<n.d&&["dd",u]);return(r=(r=null!=n.w?r||(d<=1?["w"]:d<n.w&&["ww",d]):r)||(l<=1?["M"]:l<n.M&&["MM",l])||(i<=1?["y"]:["yy",i]))[2]=t,r[3]=0<+e,r[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,r)}var bn=Math.abs;function Tn(e){return(0<e)-(e<0)||+e}function xn(){var e,t,n,s,i,r,a,o,u,l,d;return this.isValid()?(e=bn(this._milliseconds)/1e3,t=bn(this._days),n=bn(this._months),(o=this.asSeconds())?(s=m(e/60),i=m(s/60),e%=60,s%=60,r=m(n/12),n%=12,a=e?e.toFixed(3).replace(/\.?0+$/,""):"",u=Tn(this._months)!==Tn(o)?"-":"",l=Tn(this._days)!==Tn(o)?"-":"",d=Tn(this._milliseconds)!==Tn(o)?"-":"",(o<0?"-":"")+"P"+(r?u+r+"Y":"")+(n?u+n+"M":"")+(t?l+t+"D":"")+(i||s||e?"T":"")+(i?d+i+"H":"")+(s?d+s+"M":"")+(e?d+a+"S":"")):"P0D"):this.localeData().invalidDate()}var U=Ct.prototype;return U.isValid=function(){return this._isValid},U.abs=function(){var e=this._data;return this._milliseconds=_n(this._milliseconds),this._days=_n(this._days),this._months=_n(this._months),e.milliseconds=_n(e.milliseconds),e.seconds=_n(e.seconds),e.minutes=_n(e.minutes),e.hours=_n(e.hours),e.months=_n(e.months),e.years=_n(e.years),this},U.add=function(e,t){return yn(this,e,t,1)},U.subtract=function(e,t){return yn(this,e,t,-1)},U.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=o(e))||"quarter"===e||"year"===e)switch(t=this._days+s/864e5,n=this._months+wn(t),e){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(t=this._days+Math.round(pn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},U.asMilliseconds=de,U.asSeconds=t,U.asMinutes=ye,U.asHours=he,U.asDays=Fe,U.asWeeks=_e,U.asMonths=me,U.asQuarters=Qe,U.asYears=i,U.valueOf=ce,U._bubble=function(){var e=this._milliseconds,t=this._days,n=this._months,s=this._data;return 0<=e&&0<=t&&0<=n||e<=0&&t<=0&&n<=0||(e+=864e5*gn(pn(n)+t),n=t=0),s.milliseconds=e%1e3,e=m(e/1e3),s.seconds=e%60,e=m(e/60),s.minutes=e%60,e=m(e/60),s.hours=e%24,t+=m(e/24),n+=e=m(wn(t)),t-=gn(pn(e)),e=m(n/12),n%=12,s.days=t,s.months=n,s.years=e,this},U.clone=function(){return C(this)},U.get=function(e){return e=o(e),this.isValid()?this[e+"s"]():NaN},U.milliseconds=we,U.seconds=fe,U.minutes=ge,U.hours=Pe,U.days=d,U.weeks=function(){return m(this.days()/7)},U.months=vn,U.years=Dn,U.humanize=function(e,t){var n,s;return this.isValid()?(n=!1,s=Sn,"object"==typeof e&&(t=e,e=!1),"boolean"==typeof e&&(n=e),"object"==typeof t&&(s=Object.assign({},Sn,t),null!=t.s)&&null==t.ss&&(s.ss=t.s-1),e=this.localeData(),t=On(this,!n,s,e),n&&(t=e.pastFuture(+this,t)),e.postformat(t)):this.localeData().invalidDate()},U.toISOString=xn,U.toString=xn,U.toJSON=xn,U.locale=Xt,U.localeData=Kt,U.toIsoString=e("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",xn),U.lang=Ke,s("X",0,0,"unix"),s("x",0,0,"valueOf"),h("x",ke),h("X",/[+-]?\d+(\.\d{1,3})?/),v("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e))}),v("x",function(e,t,n){n._d=new Date(M(e))}),_.version="2.30.1",H=R,_.fn=u,_.min=function(){return Pt("isBefore",[].slice.call(arguments,0))},_.max=function(){return Pt("isAfter",[].slice.call(arguments,0))},_.now=function(){return Date.now?Date.now():+new Date},_.utc=l,_.unix=function(e){return R(1e3*e)},_.months=function(e,t){return fn(e,t,"months")},_.isDate=V,_.locale=ft,_.invalid=I,_.duration=C,_.isMoment=k,_.weekdays=function(e,t,n){return mn(e,t,n,"weekdays")},_.parseZone=function(){return R.apply(null,arguments).parseZone()},_.localeData=P,_.isDuration=Ut,_.monthsShort=function(e,t){return fn(e,t,"monthsShort")},_.weekdaysMin=function(e,t,n){return mn(e,t,n,"weekdaysMin")},_.defineLocale=mt,_.updateLocale=function(e,t){var n,s;return null!=t?(s=ut,null!=W[e]&&null!=W[e].parentLocale?W[e].set(X(W[e]._config,t)):(t=X(s=null!=(n=ct(e))?n._config:s,t),null==n&&(t.abbr=e),(s=new K(t)).parentLocale=W[e],W[e]=s),ft(e)):null!=W[e]&&(null!=W[e].parentLocale?(W[e]=W[e].parentLocale,e===ft()&&ft(e)):null!=W[e]&&delete W[e]),W[e]},_.locales=function(){return ee(W)},_.weekdaysShort=function(e,t,n){return mn(e,t,n,"weekdaysShort")},_.normalizeUnits=o,_.relativeTimeRounding=function(e){return void 0===e?Yn:"function"==typeof e&&(Yn=e,!0)},_.relativeTimeThreshold=function(e,t){return void 0!==Sn[e]&&(void 0===t?Sn[e]:(Sn[e]=t,"s"===e&&(Sn.ss=t-1),!0))},_.calendarFormat=function(e,t){return(e=e.diff(t,"days",!0))<-6?"sameElse":e<-1?"lastWeek":e<0?"lastDay":e<1?"sameDay":e<2?"nextDay":e<7?"nextWeek":"sameElse"},_.prototype=u,_.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},_});
//# sourceMappingURL=moment.min.js.map
/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('jquery'), require('popper.js')) :
  typeof define === 'function' && define.amd ? define(['exports', 'jquery', 'popper.js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.bootstrap = {}, global.jQuery, global.Popper));
})(this, (function (exports, $, Popper) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
  var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * Private TransitionEnd Helpers
   */

  var TRANSITION_END = 'transitionend';
  var MAX_UID = 1000000;
  var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  function toType(obj) {
    if (obj === null || typeof obj === 'undefined') {
      return "" + obj;
    }

    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  }

  function getSpecialTransitionEndEvent() {
    return {
      bindType: TRANSITION_END,
      delegateType: TRANSITION_END,
      handle: function handle(event) {
        if ($__default["default"](event.target).is(this)) {
          return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
        }

        return undefined;
      }
    };
  }

  function transitionEndEmulator(duration) {
    var _this = this;

    var called = false;
    $__default["default"](this).one(Util.TRANSITION_END, function () {
      called = true;
    });
    setTimeout(function () {
      if (!called) {
        Util.triggerTransitionEnd(_this);
      }
    }, duration);
    return this;
  }

  function setTransitionEndSupport() {
    $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
    $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
  }
  /**
   * Public Util API
   */


  var Util = {
    TRANSITION_END: 'bsTransitionEnd',
    getUID: function getUID(prefix) {
      do {
        // eslint-disable-next-line no-bitwise
        prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
      } while (document.getElementById(prefix));

      return prefix;
    },
    getSelectorFromElement: function getSelectorFromElement(element) {
      var selector = element.getAttribute('data-target');

      if (!selector || selector === '#') {
        var hrefAttr = element.getAttribute('href');
        selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
      }

      try {
        return document.querySelector(selector) ? selector : null;
      } catch (_) {
        return null;
      }
    },
    getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
      if (!element) {
        return 0;
      } // Get transition-duration of the element


      var transitionDuration = $__default["default"](element).css('transition-duration');
      var transitionDelay = $__default["default"](element).css('transition-delay');
      var floatTransitionDuration = parseFloat(transitionDuration);
      var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

      if (!floatTransitionDuration && !floatTransitionDelay) {
        return 0;
      } // If multiple durations are defined, take the first


      transitionDuration = transitionDuration.split(',')[0];
      transitionDelay = transitionDelay.split(',')[0];
      return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    },
    reflow: function reflow(element) {
      return element.offsetHeight;
    },
    triggerTransitionEnd: function triggerTransitionEnd(element) {
      $__default["default"](element).trigger(TRANSITION_END);
    },
    supportsTransitionEnd: function supportsTransitionEnd() {
      return Boolean(TRANSITION_END);
    },
    isElement: function isElement(obj) {
      return (obj[0] || obj).nodeType;
    },
    typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
      for (var property in configTypes) {
        if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
          var expectedTypes = configTypes[property];
          var value = config[property];
          var valueType = value && Util.isElement(value) ? 'element' : toType(value);

          if (!new RegExp(expectedTypes).test(valueType)) {
            throw new Error(componentName.toUpperCase() + ": " + ("Option \"" + property + "\" provided type \"" + valueType + "\" ") + ("but expected type \"" + expectedTypes + "\"."));
          }
        }
      }
    },
    findShadowRoot: function findShadowRoot(element) {
      if (!document.documentElement.attachShadow) {
        return null;
      } // Can find the shadow root otherwise it'll return the document


      if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
      }

      if (element instanceof ShadowRoot) {
        return element;
      } // when we don't find a shadow root


      if (!element.parentNode) {
        return null;
      }

      return Util.findShadowRoot(element.parentNode);
    },
    jQueryDetection: function jQueryDetection() {
      if (typeof $__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s JavaScript requires jQuery. jQuery must be included before Bootstrap\'s JavaScript.');
      }

      var version = $__default["default"].fn.jquery.split(' ')[0].split('.');
      var minMajor = 1;
      var ltMajor = 2;
      var minMinor = 9;
      var minPatch = 1;
      var maxMajor = 4;

      if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) {
        throw new Error('Bootstrap\'s JavaScript requires at least jQuery v1.9.1 but less than v4.0.0');
      }
    }
  };
  Util.jQueryDetection();
  setTransitionEndSupport();

  /**
   * Constants
   */

  var NAME$a = 'alert';
  var VERSION$a = '4.6.2';
  var DATA_KEY$a = 'bs.alert';
  var EVENT_KEY$a = "." + DATA_KEY$a;
  var DATA_API_KEY$7 = '.data-api';
  var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
  var CLASS_NAME_ALERT = 'alert';
  var CLASS_NAME_FADE$5 = 'fade';
  var CLASS_NAME_SHOW$7 = 'show';
  var EVENT_CLOSE = "close" + EVENT_KEY$a;
  var EVENT_CLOSED = "closed" + EVENT_KEY$a;
  var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
  var SELECTOR_DISMISS = '[data-dismiss="alert"]';
  /**
   * Class definition
   */

  var Alert = /*#__PURE__*/function () {
    function Alert(element) {
      this._element = element;
    } // Getters


    var _proto = Alert.prototype;

    // Public
    _proto.close = function close(element) {
      var rootElement = this._element;

      if (element) {
        rootElement = this._getRootElement(element);
      }

      var customEvent = this._triggerCloseEvent(rootElement);

      if (customEvent.isDefaultPrevented()) {
        return;
      }

      this._removeElement(rootElement);
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$a);
      this._element = null;
    } // Private
    ;

    _proto._getRootElement = function _getRootElement(element) {
      var selector = Util.getSelectorFromElement(element);
      var parent = false;

      if (selector) {
        parent = document.querySelector(selector);
      }

      if (!parent) {
        parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
      }

      return parent;
    };

    _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
      var closeEvent = $__default["default"].Event(EVENT_CLOSE);
      $__default["default"](element).trigger(closeEvent);
      return closeEvent;
    };

    _proto._removeElement = function _removeElement(element) {
      var _this = this;

      $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);

      if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
        this._destroyElement(element);

        return;
      }

      var transitionDuration = Util.getTransitionDurationFromElement(element);
      $__default["default"](element).one(Util.TRANSITION_END, function (event) {
        return _this._destroyElement(element, event);
      }).emulateTransitionEnd(transitionDuration);
    };

    _proto._destroyElement = function _destroyElement(element) {
      $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
    } // Static
    ;

    Alert._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$a);

        if (!data) {
          data = new Alert(this);
          $element.data(DATA_KEY$a, data);
        }

        if (config === 'close') {
          data[config](this);
        }
      });
    };

    Alert._handleDismiss = function _handleDismiss(alertInstance) {
      return function (event) {
        if (event) {
          event.preventDefault();
        }

        alertInstance.close(this);
      };
    };

    _createClass(Alert, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$a;
      }
    }]);

    return Alert;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
  $__default["default"].fn[NAME$a].Constructor = Alert;

  $__default["default"].fn[NAME$a].noConflict = function () {
    $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
    return Alert._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$9 = 'button';
  var VERSION$9 = '4.6.2';
  var DATA_KEY$9 = 'bs.button';
  var EVENT_KEY$9 = "." + DATA_KEY$9;
  var DATA_API_KEY$6 = '.data-api';
  var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
  var CLASS_NAME_ACTIVE$3 = 'active';
  var CLASS_NAME_BUTTON = 'btn';
  var CLASS_NAME_FOCUS = 'focus';
  var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
  var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
  var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
  var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
  var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
  var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
  var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
  var SELECTOR_INPUT = 'input:not([type="hidden"])';
  var SELECTOR_ACTIVE$2 = '.active';
  var SELECTOR_BUTTON = '.btn';
  /**
   * Class definition
   */

  var Button = /*#__PURE__*/function () {
    function Button(element) {
      this._element = element;
      this.shouldAvoidTriggerChange = false;
    } // Getters


    var _proto = Button.prototype;

    // Public
    _proto.toggle = function toggle() {
      var triggerChangeEvent = true;
      var addAriaPressed = true;
      var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];

      if (rootElement) {
        var input = this._element.querySelector(SELECTOR_INPUT);

        if (input) {
          if (input.type === 'radio') {
            if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) {
              triggerChangeEvent = false;
            } else {
              var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);

              if (activeElement) {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
              }
            }
          }

          if (triggerChangeEvent) {
            // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
            if (input.type === 'checkbox' || input.type === 'radio') {
              input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
            }

            if (!this.shouldAvoidTriggerChange) {
              $__default["default"](input).trigger('change');
            }
          }

          input.focus();
          addAriaPressed = false;
        }
      }

      if (!(this._element.hasAttribute('disabled') || this._element.classList.contains('disabled'))) {
        if (addAriaPressed) {
          this._element.setAttribute('aria-pressed', !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
        }

        if (triggerChangeEvent) {
          $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
        }
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$9);
      this._element = null;
    } // Static
    ;

    Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$9);

        if (!data) {
          data = new Button(this);
          $element.data(DATA_KEY$9, data);
        }

        data.shouldAvoidTriggerChange = avoidTriggerChange;

        if (config === 'toggle') {
          data[config]();
        }
      });
    };

    _createClass(Button, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$9;
      }
    }]);

    return Button;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = event.target;
    var initialButton = button;

    if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) {
      button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
    }

    if (!button || button.hasAttribute('disabled') || button.classList.contains('disabled')) {
      event.preventDefault(); // work around Firefox bug #1540995
    } else {
      var inputBtn = button.querySelector(SELECTOR_INPUT);

      if (inputBtn && (inputBtn.hasAttribute('disabled') || inputBtn.classList.contains('disabled'))) {
        event.preventDefault(); // work around Firefox bug #1540995

        return;
      }

      if (initialButton.tagName === 'INPUT' || button.tagName !== 'LABEL') {
        Button._jQueryInterface.call($__default["default"](button), 'toggle', initialButton.tagName === 'INPUT');
      }
    }
  }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function (event) {
    var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
    $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
  });
  $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function () {
    // ensure correct active class is set to match the controls' actual values/states
    // find all checkboxes/readio buttons inside data-toggle groups
    var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));

    for (var i = 0, len = buttons.length; i < len; i++) {
      var button = buttons[i];
      var input = button.querySelector(SELECTOR_INPUT);

      if (input.checked || input.hasAttribute('checked')) {
        button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    } // find all button toggles


    buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));

    for (var _i = 0, _len = buttons.length; _i < _len; _i++) {
      var _button = buttons[_i];

      if (_button.getAttribute('aria-pressed') === 'true') {
        _button.classList.add(CLASS_NAME_ACTIVE$3);
      } else {
        _button.classList.remove(CLASS_NAME_ACTIVE$3);
      }
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$9] = Button._jQueryInterface;
  $__default["default"].fn[NAME$9].Constructor = Button;

  $__default["default"].fn[NAME$9].noConflict = function () {
    $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
    return Button._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$8 = 'carousel';
  var VERSION$8 = '4.6.2';
  var DATA_KEY$8 = 'bs.carousel';
  var EVENT_KEY$8 = "." + DATA_KEY$8;
  var DATA_API_KEY$5 = '.data-api';
  var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
  var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key

  var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key

  var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

  var SWIPE_THRESHOLD = 40;
  var CLASS_NAME_CAROUSEL = 'carousel';
  var CLASS_NAME_ACTIVE$2 = 'active';
  var CLASS_NAME_SLIDE = 'slide';
  var CLASS_NAME_RIGHT = 'carousel-item-right';
  var CLASS_NAME_LEFT = 'carousel-item-left';
  var CLASS_NAME_NEXT = 'carousel-item-next';
  var CLASS_NAME_PREV = 'carousel-item-prev';
  var CLASS_NAME_POINTER_EVENT = 'pointer-event';
  var DIRECTION_NEXT = 'next';
  var DIRECTION_PREV = 'prev';
  var DIRECTION_LEFT = 'left';
  var DIRECTION_RIGHT = 'right';
  var EVENT_SLIDE = "slide" + EVENT_KEY$8;
  var EVENT_SLID = "slid" + EVENT_KEY$8;
  var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
  var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
  var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
  var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
  var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
  var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
  var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
  var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
  var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
  var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
  var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
  var SELECTOR_ACTIVE$1 = '.active';
  var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
  var SELECTOR_ITEM = '.carousel-item';
  var SELECTOR_ITEM_IMG = '.carousel-item img';
  var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
  var SELECTOR_INDICATORS = '.carousel-indicators';
  var SELECTOR_DATA_SLIDE = '[data-slide], [data-slide-to]';
  var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
  var Default$7 = {
    interval: 5000,
    keyboard: true,
    slide: false,
    pause: 'hover',
    wrap: true,
    touch: true
  };
  var DefaultType$7 = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    slide: '(boolean|string)',
    pause: '(string|boolean)',
    wrap: 'boolean',
    touch: 'boolean'
  };
  var PointerType = {
    TOUCH: 'touch',
    PEN: 'pen'
  };
  /**
   * Class definition
   */

  var Carousel = /*#__PURE__*/function () {
    function Carousel(element, config) {
      this._items = null;
      this._interval = null;
      this._activeElement = null;
      this._isPaused = false;
      this._isSliding = false;
      this.touchTimeout = null;
      this.touchStartX = 0;
      this.touchDeltaX = 0;
      this._config = this._getConfig(config);
      this._element = element;
      this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
      this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
      this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

      this._addEventListeners();
    } // Getters


    var _proto = Carousel.prototype;

    // Public
    _proto.next = function next() {
      if (!this._isSliding) {
        this._slide(DIRECTION_NEXT);
      }
    };

    _proto.nextWhenVisible = function nextWhenVisible() {
      var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible

      if (!document.hidden && $element.is(':visible') && $element.css('visibility') !== 'hidden') {
        this.next();
      }
    };

    _proto.prev = function prev() {
      if (!this._isSliding) {
        this._slide(DIRECTION_PREV);
      }
    };

    _proto.pause = function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
        Util.triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    };

    _proto.cycle = function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config.interval && !this._isPaused) {
        this._updateInterval();

        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    };

    _proto.to = function to(index) {
      var _this = this;

      this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        $__default["default"](this._element).one(EVENT_SLID, function () {
          return _this.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;

      this._slide(direction, this._items[index]);
    };

    _proto.dispose = function dispose() {
      $__default["default"](this._element).off(EVENT_KEY$8);
      $__default["default"].removeData(this._element, DATA_KEY$8);
      this._items = null;
      this._config = null;
      this._element = null;
      this._interval = null;
      this._isPaused = null;
      this._isSliding = null;
      this._activeElement = null;
      this._indicatorsElement = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$7, config);
      Util.typeCheckConfig(NAME$8, config, DefaultType$7);
      return config;
    };

    _proto._handleSwipe = function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX;
      this.touchDeltaX = 0; // swipe left

      if (direction > 0) {
        this.prev();
      } // swipe right


      if (direction < 0) {
        this.next();
      }
    };

    _proto._addEventListeners = function _addEventListeners() {
      var _this2 = this;

      if (this._config.keyboard) {
        $__default["default"](this._element).on(EVENT_KEYDOWN, function (event) {
          return _this2._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        $__default["default"](this._element).on(EVENT_MOUSEENTER, function (event) {
          return _this2.pause(event);
        }).on(EVENT_MOUSELEAVE, function (event) {
          return _this2.cycle(event);
        });
      }

      if (this._config.touch) {
        this._addTouchEventListeners();
      }
    };

    _proto._addTouchEventListeners = function _addTouchEventListeners() {
      var _this3 = this;

      if (!this._touchSupported) {
        return;
      }

      var start = function start(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchStartX = event.originalEvent.clientX;
        } else if (!_this3._pointerEvent) {
          _this3.touchStartX = event.originalEvent.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
      };

      var end = function end(event) {
        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
        }

        _this3._handleSwipe();

        if (_this3._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling
          _this3.pause();

          if (_this3.touchTimeout) {
            clearTimeout(_this3.touchTimeout);
          }

          _this3.touchTimeout = setTimeout(function (event) {
            return _this3.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
        }
      };

      $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function (e) {
        return e.preventDefault();
      });

      if (this._pointerEvent) {
        $__default["default"](this._element).on(EVENT_POINTERDOWN, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
      } else {
        $__default["default"](this._element).on(EVENT_TOUCHSTART, function (event) {
          return start(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHMOVE, function (event) {
          return move(event);
        });
        $__default["default"](this._element).on(EVENT_TOUCHEND, function (event) {
          return end(event);
        });
      }
    };

    _proto._keydown = function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      switch (event.which) {
        case ARROW_LEFT_KEYCODE:
          event.preventDefault();
          this.prev();
          break;

        case ARROW_RIGHT_KEYCODE:
          event.preventDefault();
          this.next();
          break;
      }
    };

    _proto._getItemIndex = function _getItemIndex(element) {
      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
      return this._items.indexOf(element);
    };

    _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
      var isNextDirection = direction === DIRECTION_NEXT;
      var isPrevDirection = direction === DIRECTION_PREV;

      var activeIndex = this._getItemIndex(activeElement);

      var lastItemIndex = this._items.length - 1;
      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

      if (isGoingToWrap && !this._config.wrap) {
        return activeElement;
      }

      var delta = direction === DIRECTION_PREV ? -1 : 1;
      var itemIndex = (activeIndex + delta) % this._items.length;
      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
    };

    _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);

      var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));

      var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });
      $__default["default"](this._element).trigger(slideEvent);
      return slideEvent;
    };

    _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
        $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);

        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

        if (nextIndicator) {
          $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
        }
      }
    };

    _proto._updateInterval = function _updateInterval() {
      var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      if (!element) {
        return;
      }

      var elementInterval = parseInt(element.getAttribute('data-interval'), 10);

      if (elementInterval) {
        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
        this._config.interval = elementInterval;
      } else {
        this._config.interval = this._config.defaultInterval || this._config.interval;
      }
    };

    _proto._slide = function _slide(direction, element) {
      var _this4 = this;

      var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);

      var activeElementIndex = this._getItemIndex(activeElement);

      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);

      var nextElementIndex = this._getItemIndex(nextElement);

      var isCycling = Boolean(this._interval);
      var directionalClassName;
      var orderClassName;
      var eventDirectionName;

      if (direction === DIRECTION_NEXT) {
        directionalClassName = CLASS_NAME_LEFT;
        orderClassName = CLASS_NAME_NEXT;
        eventDirectionName = DIRECTION_LEFT;
      } else {
        directionalClassName = CLASS_NAME_RIGHT;
        orderClassName = CLASS_NAME_PREV;
        eventDirectionName = DIRECTION_RIGHT;
      }

      if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
        this._isSliding = false;
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

      if (slideEvent.isDefaultPrevented()) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      this._activeElement = nextElement;
      var slidEvent = $__default["default"].Event(EVENT_SLID, {
        relatedTarget: nextElement,
        direction: eventDirectionName,
        from: activeElementIndex,
        to: nextElementIndex
      });

      if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
        $__default["default"](nextElement).addClass(orderClassName);
        Util.reflow(nextElement);
        $__default["default"](activeElement).addClass(directionalClassName);
        $__default["default"](nextElement).addClass(directionalClassName);
        var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
        $__default["default"](activeElement).one(Util.TRANSITION_END, function () {
          $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
          $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
          _this4._isSliding = false;
          setTimeout(function () {
            return $__default["default"](_this4._element).trigger(slidEvent);
          }, 0);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
        $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
        this._isSliding = false;
        $__default["default"](this._element).trigger(slidEvent);
      }

      if (isCycling) {
        this.cycle();
      }
    } // Static
    ;

    Carousel._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$8);

        var _config = _extends({}, Default$7, $__default["default"](this).data());

        if (typeof config === 'object') {
          _config = _extends({}, _config, config);
        }

        var action = typeof config === 'string' ? config : _config.slide;

        if (!data) {
          data = new Carousel(this, _config);
          $__default["default"](this).data(DATA_KEY$8, data);
        }

        if (typeof config === 'number') {
          data.to(config);
        } else if (typeof action === 'string') {
          if (typeof data[action] === 'undefined') {
            throw new TypeError("No method named \"" + action + "\"");
          }

          data[action]();
        } else if (_config.interval && _config.ride) {
          data.pause();
          data.cycle();
        }
      });
    };

    Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
      var selector = Util.getSelectorFromElement(this);

      if (!selector) {
        return;
      }

      var target = $__default["default"](selector)[0];

      if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) {
        return;
      }

      var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

      var slideIndex = this.getAttribute('data-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel._jQueryInterface.call($__default["default"](target), config);

      if (slideIndex) {
        $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
      }

      event.preventDefault();
    };

    _createClass(Carousel, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$8;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$7;
      }
    }]);

    return Carousel;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
  $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function () {
    var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));

    for (var i = 0, len = carousels.length; i < len; i++) {
      var $carousel = $__default["default"](carousels[i]);

      Carousel._jQueryInterface.call($carousel, $carousel.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
  $__default["default"].fn[NAME$8].Constructor = Carousel;

  $__default["default"].fn[NAME$8].noConflict = function () {
    $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
    return Carousel._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$7 = 'collapse';
  var VERSION$7 = '4.6.2';
  var DATA_KEY$7 = 'bs.collapse';
  var EVENT_KEY$7 = "." + DATA_KEY$7;
  var DATA_API_KEY$4 = '.data-api';
  var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
  var CLASS_NAME_SHOW$6 = 'show';
  var CLASS_NAME_COLLAPSE = 'collapse';
  var CLASS_NAME_COLLAPSING = 'collapsing';
  var CLASS_NAME_COLLAPSED = 'collapsed';
  var DIMENSION_WIDTH = 'width';
  var DIMENSION_HEIGHT = 'height';
  var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
  var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
  var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
  var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
  var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
  var SELECTOR_ACTIVES = '.show, .collapsing';
  var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
  var Default$6 = {
    toggle: true,
    parent: ''
  };
  var DefaultType$6 = {
    toggle: 'boolean',
    parent: '(string|element)'
  };
  /**
   * Class definition
   */

  var Collapse = /*#__PURE__*/function () {
    function Collapse(element, config) {
      this._isTransitioning = false;
      this._element = element;
      this._config = this._getConfig(config);
      this._triggerArray = [].slice.call(document.querySelectorAll("[data-toggle=\"collapse\"][href=\"#" + element.id + "\"]," + ("[data-toggle=\"collapse\"][data-target=\"#" + element.id + "\"]")));
      var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));

      for (var i = 0, len = toggleList.length; i < len; i++) {
        var elem = toggleList[i];
        var selector = Util.getSelectorFromElement(elem);
        var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
          return foundElem === element;
        });

        if (selector !== null && filterElement.length > 0) {
          this._selector = selector;

          this._triggerArray.push(elem);
        }
      }

      this._parent = this._config.parent ? this._getParent() : null;

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._element, this._triggerArray);
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // Getters


    var _proto = Collapse.prototype;

    // Public
    _proto.toggle = function toggle() {
      if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        this.hide();
      } else {
        this.show();
      }
    };

    _proto.show = function show() {
      var _this = this;

      if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var actives;
      var activesData;

      if (this._parent) {
        actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function (elem) {
          if (typeof _this._config.parent === 'string') {
            return elem.getAttribute('data-parent') === _this._config.parent;
          }

          return elem.classList.contains(CLASS_NAME_COLLAPSE);
        });

        if (actives.length === 0) {
          actives = null;
        }
      }

      if (actives) {
        activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = $__default["default"].Event(EVENT_SHOW$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      if (actives) {
        Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), 'hide');

        if (!activesData) {
          $__default["default"](actives).data(DATA_KEY$7, null);
        }
      }

      var dimension = this._getDimension();

      $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
      this._element.style[dimension] = 0;

      if (this._triggerArray.length) {
        $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', true);
      }

      this.setTransitioning(true);

      var complete = function complete() {
        $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
        _this._element.style[dimension] = '';

        _this.setTransitioning(false);

        $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
      };

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll" + capitalizedDimension;
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      this._element.style[dimension] = this._element[scrollSize] + "px";
    };

    _proto.hide = function hide() {
      var _this2 = this;

      if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) {
        return;
      }

      var startEvent = $__default["default"].Event(EVENT_HIDE$4);
      $__default["default"](this._element).trigger(startEvent);

      if (startEvent.isDefaultPrevented()) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
      Util.reflow(this._element);
      $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
      var triggerArrayLength = this._triggerArray.length;

      if (triggerArrayLength > 0) {
        for (var i = 0; i < triggerArrayLength; i++) {
          var trigger = this._triggerArray[i];
          var selector = Util.getSelectorFromElement(trigger);

          if (selector !== null) {
            var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));

            if (!$elem.hasClass(CLASS_NAME_SHOW$6)) {
              $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr('aria-expanded', false);
            }
          }
        }
      }

      this.setTransitioning(true);

      var complete = function complete() {
        _this2.setTransitioning(false);

        $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
      };

      this._element.style[dimension] = '';
      var transitionDuration = Util.getTransitionDurationFromElement(this._element);
      $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
    };

    _proto.setTransitioning = function setTransitioning(isTransitioning) {
      this._isTransitioning = isTransitioning;
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$7);
      this._config = null;
      this._parent = null;
      this._element = null;
      this._triggerArray = null;
      this._isTransitioning = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$6, config);
      config.toggle = Boolean(config.toggle); // Coerce string values

      Util.typeCheckConfig(NAME$7, config, DefaultType$6);
      return config;
    };

    _proto._getDimension = function _getDimension() {
      var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
      return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
    };

    _proto._getParent = function _getParent() {
      var _this3 = this;

      var parent;

      if (Util.isElement(this._config.parent)) {
        parent = this._config.parent; // It's a jQuery object

        if (typeof this._config.parent.jquery !== 'undefined') {
          parent = this._config.parent[0];
        }
      } else {
        parent = document.querySelector(this._config.parent);
      }

      var selector = "[data-toggle=\"collapse\"][data-parent=\"" + this._config.parent + "\"]";
      var children = [].slice.call(parent.querySelectorAll(selector));
      $__default["default"](children).each(function (i, element) {
        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
      });
      return parent;
    };

    _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
      var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);

      if (triggerArray.length) {
        $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
      }
    } // Static
    ;

    Collapse._getTargetFromElement = function _getTargetFromElement(element) {
      var selector = Util.getSelectorFromElement(element);
      return selector ? document.querySelector(selector) : null;
    };

    Collapse._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$7);

        var _config = _extends({}, Default$6, $element.data(), typeof config === 'object' && config ? config : {});

        if (!data && _config.toggle && typeof config === 'string' && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        if (!data) {
          data = new Collapse(this, _config);
          $element.data(DATA_KEY$7, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Collapse, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$7;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$6;
      }
    }]);

    return Collapse;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.currentTarget.tagName === 'A') {
      event.preventDefault();
    }

    var $trigger = $__default["default"](this);
    var selector = Util.getSelectorFromElement(this);
    var selectors = [].slice.call(document.querySelectorAll(selector));
    $__default["default"](selectors).each(function () {
      var $target = $__default["default"](this);
      var data = $target.data(DATA_KEY$7);
      var config = data ? 'toggle' : $trigger.data();

      Collapse._jQueryInterface.call($target, config);
    });
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
  $__default["default"].fn[NAME$7].Constructor = Collapse;

  $__default["default"].fn[NAME$7].noConflict = function () {
    $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
    return Collapse._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$6 = 'dropdown';
  var VERSION$6 = '4.6.2';
  var DATA_KEY$6 = 'bs.dropdown';
  var EVENT_KEY$6 = "." + DATA_KEY$6;
  var DATA_API_KEY$3 = '.data-api';
  var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
  var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key

  var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key

  var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key

  var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key

  var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key

  var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)

  var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
  var CLASS_NAME_DISABLED$1 = 'disabled';
  var CLASS_NAME_SHOW$5 = 'show';
  var CLASS_NAME_DROPUP = 'dropup';
  var CLASS_NAME_DROPRIGHT = 'dropright';
  var CLASS_NAME_DROPLEFT = 'dropleft';
  var CLASS_NAME_MENURIGHT = 'dropdown-menu-right';
  var CLASS_NAME_POSITION_STATIC = 'position-static';
  var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
  var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
  var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
  var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
  var EVENT_CLICK = "click" + EVENT_KEY$6;
  var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
  var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
  var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
  var SELECTOR_FORM_CHILD = '.dropdown form';
  var SELECTOR_MENU = '.dropdown-menu';
  var SELECTOR_NAVBAR_NAV = '.navbar-nav';
  var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
  var PLACEMENT_TOP = 'top-start';
  var PLACEMENT_TOPEND = 'top-end';
  var PLACEMENT_BOTTOM = 'bottom-start';
  var PLACEMENT_BOTTOMEND = 'bottom-end';
  var PLACEMENT_RIGHT = 'right-start';
  var PLACEMENT_LEFT = 'left-start';
  var Default$5 = {
    offset: 0,
    flip: true,
    boundary: 'scrollParent',
    reference: 'toggle',
    display: 'dynamic',
    popperConfig: null
  };
  var DefaultType$5 = {
    offset: '(number|string|function)',
    flip: 'boolean',
    boundary: '(string|element)',
    reference: '(string|element)',
    display: 'string',
    popperConfig: '(null|object)'
  };
  /**
   * Class definition
   */

  var Dropdown = /*#__PURE__*/function () {
    function Dropdown(element, config) {
      this._element = element;
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();

      this._addEventListeners();
    } // Getters


    var _proto = Dropdown.prototype;

    // Public
    _proto.toggle = function toggle() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);

      Dropdown._clearMenus();

      if (isActive) {
        return;
      }

      this.show(true);
    };

    _proto.show = function show(usePopper) {
      if (usePopper === void 0) {
        usePopper = false;
      }

      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      } // Totally disable Popper for Dropdowns in Navbar


      if (!this._inNavbar && usePopper) {
        // Check for Popper dependency
        if (typeof Popper__default["default"] === 'undefined') {
          throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
        }

        var referenceElement = this._element;

        if (this._config.reference === 'parent') {
          referenceElement = parent;
        } else if (Util.isElement(this._config.reference)) {
          referenceElement = this._config.reference; // Check if it's jQuery element

          if (typeof this._config.reference.jquery !== 'undefined') {
            referenceElement = this._config.reference[0];
          }
        } // If boundary is not `scrollParent`, then set position to `static`
        // to allow the menu to "escape" the scroll parent's boundaries
        // https://github.com/twbs/bootstrap/issues/24251


        if (this._config.boundary !== 'scrollParent') {
          $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
        }

        this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) {
        $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
    };

    _proto.hide = function hide() {
      if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);

      var parent = Dropdown._getParentFromElement(this._element);

      $__default["default"](parent).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      if (this._popper) {
        this._popper.destroy();
      }

      $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
      $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$6);
      $__default["default"](this._element).off(EVENT_KEY$6);
      this._element = null;
      this._menu = null;

      if (this._popper !== null) {
        this._popper.destroy();

        this._popper = null;
      }
    };

    _proto.update = function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Private
    ;

    _proto._addEventListeners = function _addEventListeners() {
      var _this = this;

      $__default["default"](this._element).on(EVENT_CLICK, function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this.toggle();
      });
    };

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
      Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
      return config;
    };

    _proto._getMenuElement = function _getMenuElement() {
      if (!this._menu) {
        var parent = Dropdown._getParentFromElement(this._element);

        if (parent) {
          this._menu = parent.querySelector(SELECTOR_MENU);
        }
      }

      return this._menu;
    };

    _proto._getPlacement = function _getPlacement() {
      var $parentDropdown = $__default["default"](this._element.parentNode);
      var placement = PLACEMENT_BOTTOM; // Handle dropup

      if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) {
        placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) {
        placement = PLACEMENT_RIGHT;
      } else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) {
        placement = PLACEMENT_LEFT;
      } else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) {
        placement = PLACEMENT_BOTTOMEND;
      }

      return placement;
    };

    _proto._detectNavbar = function _detectNavbar() {
      return $__default["default"](this._element).closest('.navbar').length > 0;
    };

    _proto._getOffset = function _getOffset() {
      var _this2 = this;

      var offset = {};

      if (typeof this._config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
          return data;
        };
      } else {
        offset.offset = this._config.offset;
      }

      return offset;
    };

    _proto._getPopperConfig = function _getPopperConfig() {
      var popperConfig = {
        placement: this._getPlacement(),
        modifiers: {
          offset: this._getOffset(),
          flip: {
            enabled: this._config.flip
          },
          preventOverflow: {
            boundariesElement: this._config.boundary
          }
        }
      }; // Disable Popper if we have a static display

      if (this._config.display === 'static') {
        popperConfig.modifiers.applyStyle = {
          enabled: false
        };
      }

      return _extends({}, popperConfig, this._config.popperConfig);
    } // Static
    ;

    Dropdown._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$6);

        var _config = typeof config === 'object' ? config : null;

        if (!data) {
          data = new Dropdown(this, _config);
          $__default["default"](this).data(DATA_KEY$6, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    Dropdown._clearMenus = function _clearMenus(event) {
      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
        return;
      }

      var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));

      for (var i = 0, len = toggles.length; i < len; i++) {
        var parent = Dropdown._getParentFromElement(toggles[i]);

        var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
        var relatedTarget = {
          relatedTarget: toggles[i]
        };

        if (event && event.type === 'click') {
          relatedTarget.clickEvent = event;
        }

        if (!context) {
          continue;
        }

        var dropdownMenu = context._menu;

        if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) {
          continue;
        }

        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) {
          continue;
        }

        var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
        $__default["default"](parent).trigger(hideEvent);

        if (hideEvent.isDefaultPrevented()) {
          continue;
        } // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support


        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
        }

        toggles[i].setAttribute('aria-expanded', 'false');

        if (context._popper) {
          context._popper.destroy();
        }

        $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
        $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
      }
    };

    Dropdown._getParentFromElement = function _getParentFromElement(element) {
      var parent;
      var selector = Util.getSelectorFromElement(element);

      if (selector) {
        parent = document.querySelector(selector);
      }

      return parent || element.parentNode;
    } // eslint-disable-next-line complexity
    ;

    Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
        return;
      }

      if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) {
        return;
      }

      var parent = Dropdown._getParentFromElement(this);

      var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);

      if (!isActive && event.which === ESCAPE_KEYCODE$1) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
        if (event.which === ESCAPE_KEYCODE$1) {
          $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger('focus');
        }

        $__default["default"](this).trigger('click');
        return;
      }

      var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function (item) {
        return $__default["default"](item).is(':visible');
      });

      if (items.length === 0) {
        return;
      }

      var index = items.indexOf(event.target);

      if (event.which === ARROW_UP_KEYCODE && index > 0) {
        // Up
        index--;
      }

      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
        // Down
        index++;
      }

      if (index < 0) {
        index = 0;
      }

      items[index].focus();
    };

    _createClass(Dropdown, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$6;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$5;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$5;
      }
    }]);

    return Dropdown;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
    event.preventDefault();
    event.stopPropagation();

    Dropdown._jQueryInterface.call($__default["default"](this), 'toggle');
  }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function (e) {
    e.stopPropagation();
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
  $__default["default"].fn[NAME$6].Constructor = Dropdown;

  $__default["default"].fn[NAME$6].noConflict = function () {
    $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
    return Dropdown._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$5 = 'modal';
  var VERSION$5 = '4.6.2';
  var DATA_KEY$5 = 'bs.modal';
  var EVENT_KEY$5 = "." + DATA_KEY$5;
  var DATA_API_KEY$2 = '.data-api';
  var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
  var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

  var CLASS_NAME_SCROLLABLE = 'modal-dialog-scrollable';
  var CLASS_NAME_SCROLLBAR_MEASURER = 'modal-scrollbar-measure';
  var CLASS_NAME_BACKDROP = 'modal-backdrop';
  var CLASS_NAME_OPEN = 'modal-open';
  var CLASS_NAME_FADE$4 = 'fade';
  var CLASS_NAME_SHOW$4 = 'show';
  var CLASS_NAME_STATIC = 'modal-static';
  var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
  var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
  var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
  var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
  var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
  var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
  var EVENT_RESIZE = "resize" + EVENT_KEY$5;
  var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
  var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
  var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
  var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
  var SELECTOR_DIALOG = '.modal-dialog';
  var SELECTOR_MODAL_BODY = '.modal-body';
  var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
  var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
  var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
  var SELECTOR_STICKY_CONTENT = '.sticky-top';
  var Default$4 = {
    backdrop: true,
    keyboard: true,
    focus: true,
    show: true
  };
  var DefaultType$4 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean',
    show: 'boolean'
  };
  /**
   * Class definition
   */

  var Modal = /*#__PURE__*/function () {
    function Modal(element, config) {
      this._config = this._getConfig(config);
      this._element = element;
      this._dialog = element.querySelector(SELECTOR_DIALOG);
      this._backdrop = null;
      this._isShown = false;
      this._isBodyOverflowing = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._scrollbarWidth = 0;
    } // Getters


    var _proto = Modal.prototype;

    // Public
    _proto.toggle = function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    };

    _proto.show = function show(relatedTarget) {
      var _this = this;

      if (this._isShown || this._isTransitioning) {
        return;
      }

      var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
        relatedTarget: relatedTarget
      });
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = true;

      if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
        this._isTransitioning = true;
      }

      this._checkScrollbar();

      this._setScrollbar();

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function (event) {
        return _this.hide(event);
      });
      $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function () {
        $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function (event) {
          if ($__default["default"](event.target).is(_this._element)) {
            _this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this._showElement(relatedTarget);
      });
    };

    _proto.hide = function hide(event) {
      var _this2 = this;

      if (event) {
        event.preventDefault();
      }

      if (!this._isShown || this._isTransitioning) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
      $__default["default"](this._element).trigger(hideEvent);

      if (!this._isShown || hideEvent.isDefaultPrevented()) {
        return;
      }

      this._isShown = false;
      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);

      if (transition) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
      $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
      $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, function (event) {
          return _this2._hideModal(event);
        }).emulateTransitionEnd(transitionDuration);
      } else {
        this._hideModal();
      }
    };

    _proto.dispose = function dispose() {
      [window, this._element, this._dialog].forEach(function (htmlElement) {
        return $__default["default"](htmlElement).off(EVENT_KEY$5);
      });
      /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */

      $__default["default"](document).off(EVENT_FOCUSIN);
      $__default["default"].removeData(this._element, DATA_KEY$5);
      this._config = null;
      this._element = null;
      this._dialog = null;
      this._backdrop = null;
      this._isShown = null;
      this._isBodyOverflowing = null;
      this._ignoreBackdropClick = null;
      this._isTransitioning = null;
      this._scrollbarWidth = null;
    };

    _proto.handleUpdate = function handleUpdate() {
      this._adjustDialog();
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$4, config);
      Util.typeCheckConfig(NAME$5, config, DefaultType$4);
      return config;
    };

    _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
      var _this3 = this;

      var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
      $__default["default"](this._element).trigger(hideEventPrevented);

      if (hideEventPrevented.isDefaultPrevented()) {
        return;
      }

      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!isModalOverflowing) {
        this._element.style.overflowY = 'hidden';
      }

      this._element.classList.add(CLASS_NAME_STATIC);

      var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
      $__default["default"](this._element).off(Util.TRANSITION_END);
      $__default["default"](this._element).one(Util.TRANSITION_END, function () {
        _this3._element.classList.remove(CLASS_NAME_STATIC);

        if (!isModalOverflowing) {
          $__default["default"](_this3._element).one(Util.TRANSITION_END, function () {
            _this3._element.style.overflowY = '';
          }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
        }
      }).emulateTransitionEnd(modalTransitionDuration);

      this._element.focus();
    };

    _proto._showElement = function _showElement(relatedTarget) {
      var _this4 = this;

      var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
      var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.appendChild(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) {
        modalBody.scrollTop = 0;
      } else {
        this._element.scrollTop = 0;
      }

      if (transition) {
        Util.reflow(this._element);
      }

      $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);

      if (this._config.focus) {
        this._enforceFocus();
      }

      var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
        relatedTarget: relatedTarget
      });

      var transitionComplete = function transitionComplete() {
        if (_this4._config.focus) {
          _this4._element.focus();
        }

        _this4._isTransitioning = false;
        $__default["default"](_this4._element).trigger(shownEvent);
      };

      if (transition) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
        $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
      } else {
        transitionComplete();
      }
    };

    _proto._enforceFocus = function _enforceFocus() {
      var _this5 = this;

      $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
      .on(EVENT_FOCUSIN, function (event) {
        if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) {
          _this5._element.focus();
        }
      });
    };

    _proto._setEscapeEvent = function _setEscapeEvent() {
      var _this6 = this;

      if (this._isShown) {
        $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function (event) {
          if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            event.preventDefault();

            _this6.hide();
          } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
            _this6._triggerBackdropTransition();
          }
        });
      } else if (!this._isShown) {
        $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
      }
    };

    _proto._setResizeEvent = function _setResizeEvent() {
      var _this7 = this;

      if (this._isShown) {
        $__default["default"](window).on(EVENT_RESIZE, function (event) {
          return _this7.handleUpdate(event);
        });
      } else {
        $__default["default"](window).off(EVENT_RESIZE);
      }
    };

    _proto._hideModal = function _hideModal() {
      var _this8 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._isTransitioning = false;

      this._showBackdrop(function () {
        $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);

        _this8._resetAdjustments();

        _this8._resetScrollbar();

        $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
      });
    };

    _proto._removeBackdrop = function _removeBackdrop() {
      if (this._backdrop) {
        $__default["default"](this._backdrop).remove();
        this._backdrop = null;
      }
    };

    _proto._showBackdrop = function _showBackdrop(callback) {
      var _this9 = this;

      var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : '';

      if (this._isShown && this._config.backdrop) {
        this._backdrop = document.createElement('div');
        this._backdrop.className = CLASS_NAME_BACKDROP;

        if (animate) {
          this._backdrop.classList.add(animate);
        }

        $__default["default"](this._backdrop).appendTo(document.body);
        $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function (event) {
          if (_this9._ignoreBackdropClick) {
            _this9._ignoreBackdropClick = false;
            return;
          }

          if (event.target !== event.currentTarget) {
            return;
          }

          if (_this9._config.backdrop === 'static') {
            _this9._triggerBackdropTransition();
          } else {
            _this9.hide();
          }
        });

        if (animate) {
          Util.reflow(this._backdrop);
        }

        $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);

        if (!callback) {
          return;
        }

        if (!animate) {
          callback();
          return;
        }

        var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
        $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
      } else if (!this._isShown && this._backdrop) {
        $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);

        var callbackRemove = function callbackRemove() {
          _this9._removeBackdrop();

          if (callback) {
            callback();
          }
        };

        if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
          var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);

          $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
        } else {
          callbackRemove();
        }
      } else if (callback) {
        callback();
      }
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // todo (fat): these should probably be refactored out of modal.js
    // ----------------------------------------------------------------------
    ;

    _proto._adjustDialog = function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      if (!this._isBodyOverflowing && isModalOverflowing) {
        this._element.style.paddingLeft = this._scrollbarWidth + "px";
      }

      if (this._isBodyOverflowing && !isModalOverflowing) {
        this._element.style.paddingRight = this._scrollbarWidth + "px";
      }
    };

    _proto._resetAdjustments = function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    };

    _proto._checkScrollbar = function _checkScrollbar() {
      var rect = document.body.getBoundingClientRect();
      this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
      this._scrollbarWidth = this._getScrollbarWidth();
    };

    _proto._setScrollbar = function _setScrollbar() {
      var _this10 = this;

      if (this._isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
        var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding

        $__default["default"](fixedContent).each(function (index, element) {
          var actualPadding = element.style.paddingRight;
          var calculatedPadding = $__default["default"](element).css('padding-right');
          $__default["default"](element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
        }); // Adjust sticky content margin

        $__default["default"](stickyContent).each(function (index, element) {
          var actualMargin = element.style.marginRight;
          var calculatedMargin = $__default["default"](element).css('margin-right');
          $__default["default"](element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
        }); // Adjust body padding

        var actualPadding = document.body.style.paddingRight;
        var calculatedPadding = $__default["default"](document.body).css('padding-right');
        $__default["default"](document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
      }

      $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
    };

    _proto._resetScrollbar = function _resetScrollbar() {
      // Restore fixed content padding
      var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
      $__default["default"](fixedContent).each(function (index, element) {
        var padding = $__default["default"](element).data('padding-right');
        $__default["default"](element).removeData('padding-right');
        element.style.paddingRight = padding ? padding : '';
      }); // Restore sticky content

      var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
      $__default["default"](elements).each(function (index, element) {
        var margin = $__default["default"](element).data('margin-right');

        if (typeof margin !== 'undefined') {
          $__default["default"](element).css('margin-right', margin).removeData('margin-right');
        }
      }); // Restore body padding

      var padding = $__default["default"](document.body).data('padding-right');
      $__default["default"](document.body).removeData('padding-right');
      document.body.style.paddingRight = padding ? padding : '';
    };

    _proto._getScrollbarWidth = function _getScrollbarWidth() {
      // thx d.walsh
      var scrollDiv = document.createElement('div');
      scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
      document.body.appendChild(scrollDiv);
      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
      return scrollbarWidth;
    } // Static
    ;

    Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$5);

        var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === 'object' && config ? config : {});

        if (!data) {
          data = new Modal(this, _config);
          $__default["default"](this).data(DATA_KEY$5, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](relatedTarget);
        } else if (_config.show) {
          data.show(relatedTarget);
        }
      });
    };

    _createClass(Modal, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$5;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$4;
      }
    }]);

    return Modal;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
    var _this11 = this;

    var target;
    var selector = Util.getSelectorFromElement(this);

    if (selector) {
      target = document.querySelector(selector);
    }

    var config = $__default["default"](target).data(DATA_KEY$5) ? 'toggle' : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());

    if (this.tagName === 'A' || this.tagName === 'AREA') {
      event.preventDefault();
    }

    var $target = $__default["default"](target).one(EVENT_SHOW$2, function (showEvent) {
      if (showEvent.isDefaultPrevented()) {
        // Only register focus restorer if modal will actually get shown
        return;
      }

      $target.one(EVENT_HIDDEN$2, function () {
        if ($__default["default"](_this11).is(':visible')) {
          _this11.focus();
        }
      });
    });

    Modal._jQueryInterface.call($__default["default"](target), config, this);
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
  $__default["default"].fn[NAME$5].Constructor = Modal;

  $__default["default"].fn[NAME$5].noConflict = function () {
    $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
    return Modal._jQueryInterface;
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];
  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  };
  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */

  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase();

    if (allowedAttributeList.indexOf(attrName) !== -1) {
      if (uriAttrs.indexOf(attrName) !== -1) {
        return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
      }

      return true;
    }

    var regExp = allowedAttributeList.filter(function (attrRegex) {
      return attrRegex instanceof RegExp;
    }); // Check if a regular expression validates the attribute.

    for (var i = 0, len = regExp.length; i < len; i++) {
      if (regExp[i].test(attrName)) {
        return true;
      }
    }

    return false;
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml;
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml);
    }

    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var whitelistKeys = Object.keys(whiteList);
    var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));

    var _loop = function _loop(i, len) {
      var el = elements[i];
      var elName = el.nodeName.toLowerCase();

      if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
        el.parentNode.removeChild(el);
        return "continue";
      }

      var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread

      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);
      attributeList.forEach(function (attr) {
        if (!allowedAttribute(attr, whitelistedAttributes)) {
          el.removeAttribute(attr.nodeName);
        }
      });
    };

    for (var i = 0, len = elements.length; i < len; i++) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }

    return createdDocument.body.innerHTML;
  }

  /**
   * Constants
   */

  var NAME$4 = 'tooltip';
  var VERSION$4 = '4.6.2';
  var DATA_KEY$4 = 'bs.tooltip';
  var EVENT_KEY$4 = "." + DATA_KEY$4;
  var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
  var CLASS_PREFIX$1 = 'bs-tooltip';
  var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", 'g');
  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];
  var CLASS_NAME_FADE$3 = 'fade';
  var CLASS_NAME_SHOW$3 = 'show';
  var HOVER_STATE_SHOW = 'show';
  var HOVER_STATE_OUT = 'out';
  var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
  var SELECTOR_ARROW = '.arrow';
  var TRIGGER_HOVER = 'hover';
  var TRIGGER_FOCUS = 'focus';
  var TRIGGER_CLICK = 'click';
  var TRIGGER_MANUAL = 'manual';
  var AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left'
  };
  var Default$3 = {
    animation: true,
    template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    selector: false,
    placement: 'top',
    offset: 0,
    container: false,
    fallbackPlacement: 'flip',
    boundary: 'scrollParent',
    customClass: '',
    sanitize: true,
    sanitizeFn: null,
    whiteList: DefaultWhitelist,
    popperConfig: null
  };
  var DefaultType$3 = {
    animation: 'boolean',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string',
    delay: '(number|object)',
    html: 'boolean',
    selector: '(string|boolean)',
    placement: '(string|function)',
    offset: '(number|string|function)',
    container: '(string|element|boolean)',
    fallbackPlacement: '(string|array)',
    boundary: '(string|element)',
    customClass: '(string|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    whiteList: 'object',
    popperConfig: '(null|object)'
  };
  var Event$1 = {
    HIDE: "hide" + EVENT_KEY$4,
    HIDDEN: "hidden" + EVENT_KEY$4,
    SHOW: "show" + EVENT_KEY$4,
    SHOWN: "shown" + EVENT_KEY$4,
    INSERTED: "inserted" + EVENT_KEY$4,
    CLICK: "click" + EVENT_KEY$4,
    FOCUSIN: "focusin" + EVENT_KEY$4,
    FOCUSOUT: "focusout" + EVENT_KEY$4,
    MOUSEENTER: "mouseenter" + EVENT_KEY$4,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$4
  };
  /**
   * Class definition
   */

  var Tooltip = /*#__PURE__*/function () {
    function Tooltip(element, config) {
      if (typeof Popper__default["default"] === 'undefined') {
        throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
      } // Private


      this._isEnabled = true;
      this._timeout = 0;
      this._hoverState = '';
      this._activeTrigger = {};
      this._popper = null; // Protected

      this.element = element;
      this.config = this._getConfig(config);
      this.tip = null;

      this._setListeners();
    } // Getters


    var _proto = Tooltip.prototype;

    // Public
    _proto.enable = function enable() {
      this._isEnabled = true;
    };

    _proto.disable = function disable() {
      this._isEnabled = false;
    };

    _proto.toggleEnabled = function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    };

    _proto.toggle = function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var dataKey = this.constructor.DATA_KEY;
        var context = $__default["default"](event.currentTarget).data(dataKey);

        if (!context) {
          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
          $__default["default"](event.currentTarget).data(dataKey, context);
        }

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    };

    _proto.dispose = function dispose() {
      clearTimeout(this._timeout);
      $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
      $__default["default"](this.element).off(this.constructor.EVENT_KEY);
      $__default["default"](this.element).closest('.modal').off('hide.bs.modal', this._hideModalHandler);

      if (this.tip) {
        $__default["default"](this.tip).remove();
      }

      this._isEnabled = null;
      this._timeout = null;
      this._hoverState = null;
      this._activeTrigger = null;

      if (this._popper) {
        this._popper.destroy();
      }

      this._popper = null;
      this.element = null;
      this.config = null;
      this.tip = null;
    };

    _proto.show = function show() {
      var _this = this;

      if ($__default["default"](this.element).css('display') === 'none') {
        throw new Error('Please use show on visible elements');
      }

      var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);

      if (this.isWithContent() && this._isEnabled) {
        $__default["default"](this.element).trigger(showEvent);
        var shadowRoot = Util.findShadowRoot(this.element);
        var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);

        if (showEvent.isDefaultPrevented() || !isInTheDom) {
          return;
        }

        var tip = this.getTipElement();
        var tipId = Util.getUID(this.constructor.NAME);
        tip.setAttribute('id', tipId);
        this.element.setAttribute('aria-describedby', tipId);
        this.setContent();

        if (this.config.animation) {
          $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
        }

        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

        var attachment = this._getAttachment(placement);

        this.addAttachmentClass(attachment);

        var container = this._getContainer();

        $__default["default"](tip).data(this.constructor.DATA_KEY, this);

        if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) {
          $__default["default"](tip).appendTo(container);
        }

        $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
        this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
        $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
        $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html

        if ('ontouchstart' in document.documentElement) {
          $__default["default"](document.body).children().on('mouseover', null, $__default["default"].noop);
        }

        var complete = function complete() {
          if (_this.config.animation) {
            _this._fixTransition();
          }

          var prevHoverState = _this._hoverState;
          _this._hoverState = null;
          $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);

          if (prevHoverState === HOVER_STATE_OUT) {
            _this._leave(null, _this);
          }
        };

        if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
          var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
          $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        } else {
          complete();
        }
      }
    };

    _proto.hide = function hide(callback) {
      var _this2 = this;

      var tip = this.getTipElement();
      var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);

      var complete = function complete() {
        if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) {
          tip.parentNode.removeChild(tip);
        }

        _this2._cleanTipClass();

        _this2.element.removeAttribute('aria-describedby');

        $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);

        if (_this2._popper !== null) {
          _this2._popper.destroy();
        }

        if (callback) {
          callback();
        }
      };

      $__default["default"](this.element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        $__default["default"](document.body).children().off('mouseover', null, $__default["default"].noop);
      }

      this._activeTrigger[TRIGGER_CLICK] = false;
      this._activeTrigger[TRIGGER_FOCUS] = false;
      this._activeTrigger[TRIGGER_HOVER] = false;

      if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
        var transitionDuration = Util.getTransitionDurationFromElement(tip);
        $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }

      this._hoverState = '';
    };

    _proto.update = function update() {
      if (this._popper !== null) {
        this._popper.scheduleUpdate();
      }
    } // Protected
    ;

    _proto.isWithContent = function isWithContent() {
      return Boolean(this.getTitle());
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var tip = this.getTipElement();
      this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
    };

    _proto.setElementContent = function setElementContent($element, content) {
      if (typeof content === 'object' && (content.nodeType || content.jquery)) {
        // Content is a DOM node or a jQuery
        if (this.config.html) {
          if (!$__default["default"](content).parent().is($element)) {
            $element.empty().append(content);
          }
        } else {
          $element.text($__default["default"](content).text());
        }

        return;
      }

      if (this.config.html) {
        if (this.config.sanitize) {
          content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
        }

        $element.html(content);
      } else {
        $element.text(content);
      }
    };

    _proto.getTitle = function getTitle() {
      var title = this.element.getAttribute('data-original-title');

      if (!title) {
        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
      }

      return title;
    } // Private
    ;

    _proto._getPopperConfig = function _getPopperConfig(attachment) {
      var _this3 = this;

      var defaultBsConfig = {
        placement: attachment,
        modifiers: {
          offset: this._getOffset(),
          flip: {
            behavior: this.config.fallbackPlacement
          },
          arrow: {
            element: SELECTOR_ARROW
          },
          preventOverflow: {
            boundariesElement: this.config.boundary
          }
        },
        onCreate: function onCreate(data) {
          if (data.originalPlacement !== data.placement) {
            _this3._handlePopperPlacementChange(data);
          }
        },
        onUpdate: function onUpdate(data) {
          return _this3._handlePopperPlacementChange(data);
        }
      };
      return _extends({}, defaultBsConfig, this.config.popperConfig);
    };

    _proto._getOffset = function _getOffset() {
      var _this4 = this;

      var offset = {};

      if (typeof this.config.offset === 'function') {
        offset.fn = function (data) {
          data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
          return data;
        };
      } else {
        offset.offset = this.config.offset;
      }

      return offset;
    };

    _proto._getContainer = function _getContainer() {
      if (this.config.container === false) {
        return document.body;
      }

      if (Util.isElement(this.config.container)) {
        return $__default["default"](this.config.container);
      }

      return $__default["default"](document).find(this.config.container);
    };

    _proto._getAttachment = function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    };

    _proto._setListeners = function _setListeners() {
      var _this5 = this;

      var triggers = this.config.trigger.split(' ');
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function (event) {
            return _this5.toggle(event);
          });
        } else if (trigger !== TRIGGER_MANUAL) {
          var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
          var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
          $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function (event) {
            return _this5._enter(event);
          }).on(eventOut, _this5.config.selector, function (event) {
            return _this5._leave(event);
          });
        }
      });

      this._hideModalHandler = function () {
        if (_this5.element) {
          _this5.hide();
        }
      };

      $__default["default"](this.element).closest('.modal').on('hide.bs.modal', this._hideModalHandler);

      if (this.config.selector) {
        this.config = _extends({}, this.config, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    };

    _proto._fixTitle = function _fixTitle() {
      var titleType = typeof this.element.getAttribute('data-original-title');

      if (this.element.getAttribute('title') || titleType !== 'string') {
        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');
        this.element.setAttribute('title', '');
      }
    };

    _proto._enter = function _enter(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
      }

      if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
        context._hoverState = HOVER_STATE_SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_SHOW;

      if (!context.config.delay || !context.config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_SHOW) {
          context.show();
        }
      }, context.config.delay.show);
    };

    _proto._leave = function _leave(event, context) {
      var dataKey = this.constructor.DATA_KEY;
      context = context || $__default["default"](event.currentTarget).data(dataKey);

      if (!context) {
        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
        $__default["default"](event.currentTarget).data(dataKey, context);
      }

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_OUT;

      if (!context.config.delay || !context.config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_OUT) {
          context.hide();
        }
      }, context.config.delay.hide);
    };

    _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    };

    _proto._getConfig = function _getConfig(config) {
      var dataAttributes = $__default["default"](this.element).data();
      Object.keys(dataAttributes).forEach(function (dataAttr) {
        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
          delete dataAttributes[dataAttr];
        }
      });
      config = _extends({}, this.constructor.Default, dataAttributes, typeof config === 'object' && config ? config : {});

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);

      if (config.sanitize) {
        config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
      }

      return config;
    };

    _proto._getDelegateConfig = function _getDelegateConfig() {
      var config = {};

      if (this.config) {
        for (var key in this.config) {
          if (this.constructor.Default[key] !== this.config[key]) {
            config[key] = this.config[key];
          }
        }
      }

      return config;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX$1);

      if (tabClass !== null && tabClass.length) {
        $tip.removeClass(tabClass.join(''));
      }
    };

    _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
      this.tip = popperData.instance.popper;

      this._cleanTipClass();

      this.addAttachmentClass(this._getAttachment(popperData.placement));
    };

    _proto._fixTransition = function _fixTransition() {
      var tip = this.getTipElement();
      var initConfigAnimation = this.config.animation;

      if (tip.getAttribute('x-placement') !== null) {
        return;
      }

      $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
      this.config.animation = false;
      this.hide();
      this.show();
      this.config.animation = initConfigAnimation;
    } // Static
    ;

    Tooltip._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY$4);

        var _config = typeof config === 'object' && config;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Tooltip(this, _config);
          $element.data(DATA_KEY$4, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tooltip, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$4;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$3;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$4;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$4;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event$1;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$4;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$3;
      }
    }]);

    return Tooltip;
  }();
  /**
   * jQuery
   */


  $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
  $__default["default"].fn[NAME$4].Constructor = Tooltip;

  $__default["default"].fn[NAME$4].noConflict = function () {
    $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
    return Tooltip._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$3 = 'popover';
  var VERSION$3 = '4.6.2';
  var DATA_KEY$3 = 'bs.popover';
  var EVENT_KEY$3 = "." + DATA_KEY$3;
  var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
  var CLASS_PREFIX = 'bs-popover';
  var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", 'g');
  var CLASS_NAME_FADE$2 = 'fade';
  var CLASS_NAME_SHOW$2 = 'show';
  var SELECTOR_TITLE = '.popover-header';
  var SELECTOR_CONTENT = '.popover-body';

  var Default$2 = _extends({}, Tooltip.Default, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
  });

  var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
    content: '(string|element|function)'
  });

  var Event = {
    HIDE: "hide" + EVENT_KEY$3,
    HIDDEN: "hidden" + EVENT_KEY$3,
    SHOW: "show" + EVENT_KEY$3,
    SHOWN: "shown" + EVENT_KEY$3,
    INSERTED: "inserted" + EVENT_KEY$3,
    CLICK: "click" + EVENT_KEY$3,
    FOCUSIN: "focusin" + EVENT_KEY$3,
    FOCUSOUT: "focusout" + EVENT_KEY$3,
    MOUSEENTER: "mouseenter" + EVENT_KEY$3,
    MOUSELEAVE: "mouseleave" + EVENT_KEY$3
  };
  /**
   * Class definition
   */

  var Popover = /*#__PURE__*/function (_Tooltip) {
    _inheritsLoose(Popover, _Tooltip);

    function Popover() {
      return _Tooltip.apply(this, arguments) || this;
    }

    var _proto = Popover.prototype;

    // Overrides
    _proto.isWithContent = function isWithContent() {
      return this.getTitle() || this._getContent();
    };

    _proto.addAttachmentClass = function addAttachmentClass(attachment) {
      $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
    };

    _proto.getTipElement = function getTipElement() {
      this.tip = this.tip || $__default["default"](this.config.template)[0];
      return this.tip;
    };

    _proto.setContent = function setContent() {
      var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events

      this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());

      var content = this._getContent();

      if (typeof content === 'function') {
        content = content.call(this.element);
      }

      this.setElementContent($tip.find(SELECTOR_CONTENT), content);
      $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
    } // Private
    ;

    _proto._getContent = function _getContent() {
      return this.element.getAttribute('data-content') || this.config.content;
    };

    _proto._cleanTipClass = function _cleanTipClass() {
      var $tip = $__default["default"](this.getTipElement());
      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);

      if (tabClass !== null && tabClass.length > 0) {
        $tip.removeClass(tabClass.join(''));
      }
    } // Static
    ;

    Popover._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$3);

        var _config = typeof config === 'object' ? config : null;

        if (!data && /dispose|hide/.test(config)) {
          return;
        }

        if (!data) {
          data = new Popover(this, _config);
          $__default["default"](this).data(DATA_KEY$3, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Popover, null, [{
      key: "VERSION",
      get: // Getters
      function get() {
        return VERSION$3;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$2;
      }
    }, {
      key: "NAME",
      get: function get() {
        return NAME$3;
      }
    }, {
      key: "DATA_KEY",
      get: function get() {
        return DATA_KEY$3;
      }
    }, {
      key: "Event",
      get: function get() {
        return Event;
      }
    }, {
      key: "EVENT_KEY",
      get: function get() {
        return EVENT_KEY$3;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType$2;
      }
    }]);

    return Popover;
  }(Tooltip);
  /**
   * jQuery
   */


  $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
  $__default["default"].fn[NAME$3].Constructor = Popover;

  $__default["default"].fn[NAME$3].noConflict = function () {
    $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
    return Popover._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$2 = 'scrollspy';
  var VERSION$2 = '4.6.2';
  var DATA_KEY$2 = 'bs.scrollspy';
  var EVENT_KEY$2 = "." + DATA_KEY$2;
  var DATA_API_KEY$1 = '.data-api';
  var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
  var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
  var CLASS_NAME_ACTIVE$1 = 'active';
  var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
  var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
  var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
  var METHOD_OFFSET = 'offset';
  var METHOD_POSITION = 'position';
  var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
  var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
  var SELECTOR_NAV_LINKS = '.nav-link';
  var SELECTOR_NAV_ITEMS = '.nav-item';
  var SELECTOR_LIST_ITEMS = '.list-group-item';
  var SELECTOR_DROPDOWN$1 = '.dropdown';
  var SELECTOR_DROPDOWN_ITEMS = '.dropdown-item';
  var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
  var Default$1 = {
    offset: 10,
    method: 'auto',
    target: ''
  };
  var DefaultType$1 = {
    offset: 'number',
    method: 'string',
    target: '(string|element)'
  };
  /**
   * Class definition
   */

  var ScrollSpy = /*#__PURE__*/function () {
    function ScrollSpy(element, config) {
      var _this = this;

      this._element = element;
      this._scrollElement = element.tagName === 'BODY' ? window : element;
      this._config = this._getConfig(config);
      this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
      this._offsets = [];
      this._targets = [];
      this._activeTarget = null;
      this._scrollHeight = 0;
      $__default["default"](this._scrollElement).on(EVENT_SCROLL, function (event) {
        return _this._process(event);
      });
      this.refresh();

      this._process();
    } // Getters


    var _proto = ScrollSpy.prototype;

    // Public
    _proto.refresh = function refresh() {
      var _this2 = this;

      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = [].slice.call(document.querySelectorAll(this._selector));
      targets.map(function (element) {
        var target;
        var targetSelector = Util.getSelectorFromElement(element);

        if (targetSelector) {
          target = document.querySelector(targetSelector);
        }

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            // TODO (fat): remove sketch reliance on jQuery position/offset
            return [$__default["default"](target)[offsetMethod]().top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(Boolean).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this2._offsets.push(item[0]);

        _this2._targets.push(item[1]);
      });
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$2);
      $__default["default"](this._scrollElement).off(EVENT_KEY$2);
      this._element = null;
      this._scrollElement = null;
      this._config = null;
      this._selector = null;
      this._offsets = null;
      this._targets = null;
      this._activeTarget = null;
      this._scrollHeight = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default$1, typeof config === 'object' && config ? config : {});

      if (typeof config.target !== 'string' && Util.isElement(config.target)) {
        var id = $__default["default"](config.target).attr('id');

        if (!id) {
          id = Util.getUID(NAME$2);
          $__default["default"](config.target).attr('id', id);
        }

        config.target = "#" + id;
      }

      Util.typeCheckConfig(NAME$2, config, DefaultType$1);
      return config;
    };

    _proto._getScrollTop = function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    };

    _proto._getScrollHeight = function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    };

    _proto._getOffsetHeight = function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    };

    _proto._process = function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    };

    _proto._activate = function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = this._selector.split(',').map(function (selector) {
        return selector + "[data-target=\"" + target + "\"]," + selector + "[href=\"" + target + "\"]";
      });

      var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(','))));

      if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
        $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
        $link.addClass(CLASS_NAME_ACTIVE$1);
      } else {
        // Set triggered link as active
        $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item

        $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
      }

      $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
        relatedTarget: target
      });
    };

    _proto._clear = function _clear() {
      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
        return node.classList.contains(CLASS_NAME_ACTIVE$1);
      }).forEach(function (node) {
        return node.classList.remove(CLASS_NAME_ACTIVE$1);
      });
    } // Static
    ;

    ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $__default["default"](this).data(DATA_KEY$2);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new ScrollSpy(this, _config);
          $__default["default"](this).data(DATA_KEY$2, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(ScrollSpy, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$2;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default$1;
      }
    }]);

    return ScrollSpy;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](window).on(EVENT_LOAD_DATA_API, function () {
    var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
    var scrollSpysLength = scrollSpys.length;

    for (var i = scrollSpysLength; i--;) {
      var $spy = $__default["default"](scrollSpys[i]);

      ScrollSpy._jQueryInterface.call($spy, $spy.data());
    }
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
  $__default["default"].fn[NAME$2].Constructor = ScrollSpy;

  $__default["default"].fn[NAME$2].noConflict = function () {
    $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
    return ScrollSpy._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME$1 = 'tab';
  var VERSION$1 = '4.6.2';
  var DATA_KEY$1 = 'bs.tab';
  var EVENT_KEY$1 = "." + DATA_KEY$1;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
  var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
  var CLASS_NAME_ACTIVE = 'active';
  var CLASS_NAME_DISABLED = 'disabled';
  var CLASS_NAME_FADE$1 = 'fade';
  var CLASS_NAME_SHOW$1 = 'show';
  var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
  var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
  var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
  var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
  var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
  var SELECTOR_DROPDOWN = '.dropdown';
  var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
  var SELECTOR_ACTIVE = '.active';
  var SELECTOR_ACTIVE_UL = '> li > .active';
  var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
  var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
  var SELECTOR_DROPDOWN_ACTIVE_CHILD = '> .dropdown-menu .active';
  /**
   * Class definition
   */

  var Tab = /*#__PURE__*/function () {
    function Tab(element) {
      this._element = element;
    } // Getters


    var _proto = Tab.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute('disabled')) {
        return;
      }

      var target;
      var previous;
      var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
      var selector = Util.getSelectorFromElement(this._element);

      if (listElement) {
        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
        previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
        previous = previous[previous.length - 1];
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
        relatedTarget: this._element
      });
      var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
        relatedTarget: previous
      });

      if (previous) {
        $__default["default"](previous).trigger(hideEvent);
      }

      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
        return;
      }

      if (selector) {
        target = document.querySelector(selector);
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
          relatedTarget: _this._element
        });
        var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
          relatedTarget: previous
        });
        $__default["default"](previous).trigger(hiddenEvent);
        $__default["default"](_this._element).trigger(shownEvent);
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    };

    _proto.dispose = function dispose() {
      $__default["default"].removeData(this._element, DATA_KEY$1);
      this._element = null;
    } // Private
    ;

    _proto._activate = function _activate(element, container, callback) {
      var _this2 = this;

      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
      var active = activeElements[0];
      var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);

      var complete = function complete() {
        return _this2._transitionComplete(element, active, callback);
      };

      if (active && isTransitioning) {
        var transitionDuration = Util.getTransitionDurationFromElement(active);
        $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._transitionComplete = function _transitionComplete(element, active, callback) {
      if (active) {
        $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
        var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];

        if (dropdownChild) {
          $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
        }

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      $__default["default"](element).addClass(CLASS_NAME_ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      Util.reflow(element);

      if (element.classList.contains(CLASS_NAME_FADE$1)) {
        element.classList.add(CLASS_NAME_SHOW$1);
      }

      var parent = element.parentNode;

      if (parent && parent.nodeName === 'LI') {
        parent = parent.parentNode;
      }

      if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
        var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];

        if (dropdownElement) {
          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
          $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    } // Static
    ;

    Tab._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $this = $__default["default"](this);
        var data = $this.data(DATA_KEY$1);

        if (!data) {
          data = new Tab(this);
          $this.data(DATA_KEY$1, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config]();
        }
      });
    };

    _createClass(Tab, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION$1;
      }
    }]);

    return Tab;
  }();
  /**
   * Data API implementation
   */


  $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
    event.preventDefault();

    Tab._jQueryInterface.call($__default["default"](this), 'show');
  });
  /**
   * jQuery
   */

  $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
  $__default["default"].fn[NAME$1].Constructor = Tab;

  $__default["default"].fn[NAME$1].noConflict = function () {
    $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
    return Tab._jQueryInterface;
  };

  /**
   * Constants
   */

  var NAME = 'toast';
  var VERSION = '4.6.2';
  var DATA_KEY = 'bs.toast';
  var EVENT_KEY = "." + DATA_KEY;
  var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
  var CLASS_NAME_FADE = 'fade';
  var CLASS_NAME_HIDE = 'hide';
  var CLASS_NAME_SHOW = 'show';
  var CLASS_NAME_SHOWING = 'showing';
  var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
  var EVENT_HIDE = "hide" + EVENT_KEY;
  var EVENT_HIDDEN = "hidden" + EVENT_KEY;
  var EVENT_SHOW = "show" + EVENT_KEY;
  var EVENT_SHOWN = "shown" + EVENT_KEY;
  var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
  var Default = {
    animation: true,
    autohide: true,
    delay: 500
  };
  var DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
  };
  /**
   * Class definition
   */

  var Toast = /*#__PURE__*/function () {
    function Toast(element, config) {
      this._element = element;
      this._config = this._getConfig(config);
      this._timeout = null;

      this._setListeners();
    } // Getters


    var _proto = Toast.prototype;

    // Public
    _proto.show = function show() {
      var _this = this;

      var showEvent = $__default["default"].Event(EVENT_SHOW);
      $__default["default"](this._element).trigger(showEvent);

      if (showEvent.isDefaultPrevented()) {
        return;
      }

      this._clearTimeout();

      if (this._config.animation) {
        this._element.classList.add(CLASS_NAME_FADE);
      }

      var complete = function complete() {
        _this._element.classList.remove(CLASS_NAME_SHOWING);

        _this._element.classList.add(CLASS_NAME_SHOW);

        $__default["default"](_this._element).trigger(EVENT_SHOWN);

        if (_this._config.autohide) {
          _this._timeout = setTimeout(function () {
            _this.hide();
          }, _this._config.delay);
        }
      };

      this._element.classList.remove(CLASS_NAME_HIDE);

      Util.reflow(this._element);

      this._element.classList.add(CLASS_NAME_SHOWING);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto.hide = function hide() {
      if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
        return;
      }

      var hideEvent = $__default["default"].Event(EVENT_HIDE);
      $__default["default"](this._element).trigger(hideEvent);

      if (hideEvent.isDefaultPrevented()) {
        return;
      }

      this._close();
    };

    _proto.dispose = function dispose() {
      this._clearTimeout();

      if (this._element.classList.contains(CLASS_NAME_SHOW)) {
        this._element.classList.remove(CLASS_NAME_SHOW);
      }

      $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
      $__default["default"].removeData(this._element, DATA_KEY);
      this._element = null;
      this._config = null;
    } // Private
    ;

    _proto._getConfig = function _getConfig(config) {
      config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === 'object' && config ? config : {});
      Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    };

    _proto._setListeners = function _setListeners() {
      var _this2 = this;

      $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function () {
        return _this2.hide();
      });
    };

    _proto._close = function _close() {
      var _this3 = this;

      var complete = function complete() {
        _this3._element.classList.add(CLASS_NAME_HIDE);

        $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
      };

      this._element.classList.remove(CLASS_NAME_SHOW);

      if (this._config.animation) {
        var transitionDuration = Util.getTransitionDurationFromElement(this._element);
        $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
      } else {
        complete();
      }
    };

    _proto._clearTimeout = function _clearTimeout() {
      clearTimeout(this._timeout);
      this._timeout = null;
    } // Static
    ;

    Toast._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var $element = $__default["default"](this);
        var data = $element.data(DATA_KEY);

        var _config = typeof config === 'object' && config;

        if (!data) {
          data = new Toast(this, _config);
          $element.data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"" + config + "\"");
          }

          data[config](this);
        }
      });
    };

    _createClass(Toast, null, [{
      key: "VERSION",
      get: function get() {
        return VERSION;
      }
    }, {
      key: "DefaultType",
      get: function get() {
        return DefaultType;
      }
    }, {
      key: "Default",
      get: function get() {
        return Default;
      }
    }]);

    return Toast;
  }();
  /**
   * jQuery
   */


  $__default["default"].fn[NAME] = Toast._jQueryInterface;
  $__default["default"].fn[NAME].Constructor = Toast;

  $__default["default"].fn[NAME].noConflict = function () {
    $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
    return Toast._jQueryInterface;
  };

  exports.Alert = Alert;
  exports.Button = Button;
  exports.Carousel = Carousel;
  exports.Collapse = Collapse;
  exports.Dropdown = Dropdown;
  exports.Modal = Modal;
  exports.Popover = Popover;
  exports.Scrollspy = ScrollSpy;
  exports.Tab = Tab;
  exports.Toast = Toast;
  exports.Tooltip = Tooltip;
  exports.Util = Util;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=bootstrap.js.map

!(function(t) {
  var e = {};
  function n(i) {
    if (e[i]) return e[i].exports;
    var r = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
  }
  (n.m = t),
    (n.c = e),
    (n.d = function(t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (n.r = function(t) {
      'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: 'Module' }),
        Object.defineProperty(t, '__esModule', { value: !0 });
    }),
    (n.t = function(t, e) {
      if ((1 & e && (t = n(t)), 8 & e)) return t;
      if (4 & e && 'object' == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if ((n.r(i), Object.defineProperty(i, 'default', { enumerable: !0, value: t }), 2 & e && 'string' != typeof t))
        for (var r in t)
          n.d(
            i,
            r,
            function(e) {
              return t[e];
            }.bind(null, r)
          );
      return i;
    }),
    (n.n = function(t) {
      var e =
        t && t.__esModule
          ? function() {
              return t.default;
            }
          : function() {
              return t;
            };
      return n.d(e, 'a', e), e;
    }),
    (n.o = function(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ''),
    n((n.s = 13));
})([
  function(t, e, n) {
    (function(e, n) {
      var i;
      (i = function() {
        'use strict';
        function t(e) {
          return (t =
            'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
              ? function(t) {
                  return typeof t;
                }
              : function(t) {
                  return t && 'function' == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? 'symbol' : typeof t;
                })(e);
        }
        function i(t, e, n) {
          return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : (t[e] = n), t;
        }
        function r(t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = null != arguments[e] ? arguments[e] : {},
              r = Object.keys(n);
            'function' == typeof Object.getOwnPropertySymbols &&
              (r = r.concat(
                Object.getOwnPropertySymbols(n).filter(function(t) {
                  return Object.getOwnPropertyDescriptor(n, t).enumerable;
                })
              )),
              r.forEach(function(e) {
                i(t, e, n[e]);
              });
          }
          return t;
        }
        var o = '$default_instance',
          s = 2,
          a = 4096,
          u = 1e3,
          c = '$identify',
          p = '$groupidentify',
          l = 'amplitude_lastEventId',
          M = 'amplitude_lastEventTime',
          y = 'amplitude_lastIdentifyId',
          g = 'amplitude_lastSequenceNumber',
          d = 'amplitude_sessionId',
          f = 'amplitude_deviceId',
          h = 'amplitude_optOut',
          N = 'amplitude_userId',
          m = 'amplitude_cookie_test',
          I = 'revenue_amount',
          j = '$productId',
          b = '$quantity',
          L = '$price',
          T = '$revenueType',
          w = 'amp_device_id',
          D = 'referrer',
          A = 'utm_source',
          v = 'utm_medium',
          _ = 'utm_campaign',
          x = 'utm_term',
          z = 'utm_content',
          S = function(t) {
            for (var e = '', n = 0; n < t.length; n++) {
              var i = t.charCodeAt(n);
              i < 128
                ? (e += String.fromCharCode(i))
                : i > 127 && i < 2048
                ? ((e += String.fromCharCode((i >> 6) | 192)), (e += String.fromCharCode((63 & i) | 128)))
                : ((e += String.fromCharCode((i >> 12) | 224)),
                  (e += String.fromCharCode(((i >> 6) & 63) | 128)),
                  (e += String.fromCharCode((63 & i) | 128)));
            }
            return e;
          },
          E = function(t) {
            for (var e = '', n = 0, i = 0, r = 0, o = 0; n < t.length; )
              (i = t.charCodeAt(n)) < 128
                ? ((e += String.fromCharCode(i)), n++)
                : i > 191 && i < 224
                ? ((r = t.charCodeAt(n + 1)), (e += String.fromCharCode(((31 & i) << 6) | (63 & r))), (n += 2))
                : ((r = t.charCodeAt(n + 1)),
                  (o = t.charCodeAt(n + 2)),
                  (e += String.fromCharCode(((15 & i) << 12) | ((63 & r) << 6) | (63 & o))),
                  (n += 3));
            return e;
          },
          O = {
            _keyStr: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
            encode: function(t) {
              try {
                if (window.btoa && window.atob) return window.btoa(unescape(encodeURIComponent(t)));
              } catch (t) {}
              return O._encode(t);
            },
            _encode: function(t) {
              var e,
                n,
                i,
                r,
                o,
                s,
                a,
                u = '',
                c = 0;
              for (t = S(t); c < t.length; )
                (r = (e = t.charCodeAt(c++)) >> 2),
                  (o = ((3 & e) << 4) | ((n = t.charCodeAt(c++)) >> 4)),
                  (s = ((15 & n) << 2) | ((i = t.charCodeAt(c++)) >> 6)),
                  (a = 63 & i),
                  isNaN(n) ? (s = a = 64) : isNaN(i) && (a = 64),
                  (u = u + O._keyStr.charAt(r) + O._keyStr.charAt(o) + O._keyStr.charAt(s) + O._keyStr.charAt(a));
              return u;
            },
            decode: function(t) {
              try {
                if (window.btoa && window.atob) return decodeURIComponent(escape(window.atob(t)));
              } catch (t) {}
              return O._decode(t);
            },
            _decode: function(t) {
              var e,
                n,
                i,
                r,
                o,
                s,
                a = '',
                u = 0;
              for (t = t.replace(/[^A-Za-z0-9\+\/\=]/g, ''); u < t.length; )
                (e = (O._keyStr.indexOf(t.charAt(u++)) << 2) | ((r = O._keyStr.indexOf(t.charAt(u++))) >> 4)),
                  (n = ((15 & r) << 4) | ((o = O._keyStr.indexOf(t.charAt(u++))) >> 2)),
                  (i = ((3 & o) << 6) | (s = O._keyStr.indexOf(t.charAt(u++)))),
                  (a += String.fromCharCode(e)),
                  64 !== o && (a += String.fromCharCode(n)),
                  64 !== s && (a += String.fromCharCode(i));
              return (a = E(a));
            }
          },
          C = Object.prototype.toString;
        function k(n) {
          switch (C.call(n)) {
            case '[object Date]':
              return 'date';
            case '[object RegExp]':
              return 'regexp';
            case '[object Arguments]':
              return 'arguments';
            case '[object Array]':
              return 'array';
            case '[object Error]':
              return 'error';
          }
          return null === n
            ? 'null'
            : void 0 === n
            ? 'undefined'
            : n != n
            ? 'nan'
            : n && 1 === n.nodeType
            ? 'element'
            : void 0 !== e && 'function' == typeof e.isBuffer && e.isBuffer(n)
            ? 'buffer'
            : t((n = n.valueOf ? n.valueOf() : Object.prototype.valueOf.apply(n)));
        }
        var U,
          Q = { DISABLE: 0, ERROR: 1, WARN: 2, INFO: 3 },
          Y = Q.WARN,
          P = {
            error: function(t) {
              Y >= Q.ERROR && R(t);
            },
            warn: function(t) {
              Y >= Q.WARN && R(t);
            },
            info: function(t) {
              Y >= Q.INFO && R(t);
            }
          },
          R = function(t) {
            try {
              console.log('[Amplitude] ' + t);
            } catch (t) {}
          },
          B = function(t) {
            return 'string' === k(t) && t.length > a ? t.substring(0, a) : t;
          },
          G = function(t) {
            var e = k(t);
            if ('object' !== e)
              return P.error('Error: invalid properties format. Expecting Javascript object, received ' + e + ', ignoring'), {};
            if (Object.keys(t).length > u) return P.error('Error: too many properties (more than 1000), ignoring'), {};
            var n = {};
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var r = i,
                  o = k(r);
                'string' !== o &&
                  ((r = String(r)), P.warn('WARNING: Non-string property key, received type ' + o + ', coercing to string "' + r + '"'));
                var s = W(r, t[i]);
                null !== s && (n[r] = s);
              }
            return n;
          },
          Z = ['nan', 'function', 'arguments', 'regexp', 'element'],
          W = function t(e, n) {
            var i = k(n);
            if (-1 !== Z.indexOf(i)) P.warn('WARNING: Property key "' + e + '" with invalid value type ' + i + ', ignoring'), (n = null);
            else if ('undefined' === i) n = null;
            else if ('error' === i) (n = String(n)), P.warn('WARNING: Property key "' + e + '" with value type error, coercing to ' + n);
            else if ('array' === i) {
              for (var r = [], o = 0; o < n.length; o++) {
                var s = n[o],
                  a = k(s);
                'array' !== a
                  ? 'object' === a
                    ? r.push(G(s))
                    : r.push(t(e, s))
                  : P.warn('WARNING: Cannot have ' + a + ' nested in an array property value, skipping');
              }
              n = r;
            } else 'object' === i && (n = G(n));
            return n;
          },
          q = function(t, e) {
            var n = k(e);
            if ('string' === n) return e;
            if ('date' === n || 'number' === n || 'boolean' === n)
              return (e = String(e)), P.warn('WARNING: Non-string groupName, received type ' + n + ', coercing to string "' + e + '"'), e;
            if ('array' === n) {
              for (var i = [], r = 0; r < e.length; r++) {
                var o = e[r],
                  s = k(o);
                'array' !== s && 'object' !== s
                  ? 'string' === s
                    ? i.push(o)
                    : ('date' !== s && 'number' !== s && 'boolean' !== s) ||
                      ((o = String(o)),
                      P.warn('WARNING: Non-string groupName, received type ' + s + ', coercing to string "' + o + '"'),
                      i.push(o))
                  : P.warn('WARNING: Skipping nested ' + s + ' in array groupName');
              }
              return i;
            }
            P.warn('WARNING: Non-string groupName, received type ' + n + '. Please use strings or array of strings for groupName');
          },
          H = function(t) {
            Q.hasOwnProperty(t) && (Y = Q[t]);
          },
          F = P,
          V = function(t) {
            return !t || 0 === t.length;
          },
          J = function(t, e) {
            t = t.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var n = new RegExp('[\\?&]' + t + '=([^&#]*)').exec(e);
            return null === n ? void 0 : decodeURIComponent(n[1].replace(/\+/g, ' '));
          },
          X = function t(e) {
            if ('array' === k(e)) for (var n = 0; n < e.length; n++) e[n] = t(e[n]);
            else if ('object' === k(e)) for (var i in e) e.hasOwnProperty(i) && (e[i] = t(e[i]));
            else e = B(e);
            return e;
          },
          K = function(t) {
            var e = k(t);
            if ('object' !== e)
              return P.error('Error: invalid groups format. Expecting Javascript object, received ' + e + ', ignoring'), {};
            var n = {};
            for (var i in t)
              if (t.hasOwnProperty(i)) {
                var r = i,
                  o = k(r);
                'string' !== o &&
                  ((r = String(r)), P.warn('WARNING: Non-string groupType, received type ' + o + ', coercing to string "' + r + '"'));
                var s = q(r, t[i]);
                null !== s && (n[r] = s);
              }
            return n;
          },
          $ = function(t, e, n) {
            return k(t) === n || (P.error('Invalid ' + e + ' input type. Expected ' + n + ' but received ' + k(t)), !1);
          },
          tt = G,
          et = function() {
            return window.location;
          },
          nt = function(t, e, n) {
            var i = null !== e ? n.expirationDays : -1;
            if (i) {
              var r = new Date();
              r.setTime(r.getTime() + 24 * i * 60 * 60 * 1e3), (i = r);
            }
            var o = t + '=' + e;
            i && (o += '; expires=' + i.toUTCString()),
              (o += '; path=/'),
              n.domain && (o += '; domain=' + n.domain),
              n.secure && (o += '; Secure'),
              (document.cookie = o);
          },
          it = function(t) {
            try {
              for (var e = document.cookie.split(';'), n = null, i = 0; i < e.length; i++) {
                for (var r = e[i]; ' ' === r.charAt(0); ) r = r.substring(1, r.length);
                if (0 === r.indexOf(t)) {
                  n = r.substring(t.length, r.length);
                  break;
                }
              }
              return n;
            } catch (t) {
              return null;
            }
          },
          rt = { expirationDays: void 0, domain: void 0 },
          ot = function(t) {
            var e = (function(t) {
                var e = document.createElement('a');
                return (e.href = t), e.hostname || location.hostname;
              })(t).split('.'),
              n = e[e.length - 1],
              i = [];
            if (4 === e.length && n === parseInt(n, 10)) return i;
            if (e.length <= 1) return i;
            for (var r = e.length - 2; r >= 0; --r) i.push(e.slice(r).join('.'));
            for (var o = 0; o < i.length; ++o) {
              var s = '__tld_test__',
                a = i[o],
                u = { domain: '.' + a };
              if ((nt(s, 1, u), it(s))) return nt(s, null, u), a;
            }
            return '';
          },
          st = function(t) {
            var e = '';
            return rt.domain && (e = '.' === rt.domain.charAt(0) ? rt.domain.substring(1) : rt.domain), t + e;
          },
          at = function(t) {
            var e = st(t) + '=',
              n = it(e);
            try {
              if (n) return JSON.parse(O.decode(n));
            } catch (t) {
              return null;
            }
            return null;
          },
          ut = function(t, e) {
            try {
              return nt(st(t), O.encode(JSON.stringify(e)), rt), !0;
            } catch (t) {
              return !1;
            }
          },
          ct = function(t) {
            try {
              return nt(st(t), null, rt), !0;
            } catch (t) {
              return !1;
            }
          },
          pt = {
            reset: function() {
              rt = { expirationDays: void 0, domain: void 0 };
            },
            options: function(t) {
              if (0 === arguments.length) return rt;
              (t = t || {}), (rt.expirationDays = t.expirationDays), (rt.secure = t.secure);
              var e = V(t.domain) ? '.' + ot(et().href) : t.domain,
                n = Math.random();
              (rt.domain = e), ut('amplitude_test', n);
              var i = at('amplitude_test');
              return (i && i === n) || (e = null), ct('amplitude_test'), (rt.domain = e), rt;
            },
            get: at,
            set: ut,
            remove: ct
          };
        if (
          (function() {
            var t,
              e = new Date();
            try {
              return (
                window.localStorage.setItem(e, e), (t = window.localStorage.getItem(e) === String(e)), window.localStorage.removeItem(e), t
              );
            } catch (t) {}
            return !1;
          })()
        )
          U = window.localStorage;
        else if (window.globalStorage)
          try {
            U = window.globalStorage[window.location.hostname];
          } catch (t) {}
        else if ('undefined' != typeof document) {
          var lt = document.createElement('div'),
            Mt = 'localStorage';
          (lt.style.display = 'none'),
            document.getElementsByTagName('head')[0].appendChild(lt),
            lt.addBehavior &&
              (lt.addBehavior('#default#userdata'),
              (U = {
                length: 0,
                setItem: function(t, e) {
                  lt.load(Mt), lt.getAttribute(t) || this.length++, lt.setAttribute(t, e), lt.save(Mt);
                },
                getItem: function(t) {
                  return lt.load(Mt), lt.getAttribute(t);
                },
                removeItem: function(t) {
                  lt.load(Mt), lt.getAttribute(t) && this.length--, lt.removeAttribute(t), lt.save(Mt);
                },
                clear: function() {
                  lt.load(Mt);
                  for (var t, e = 0; (t = lt.XMLDocument.documentElement.attributes[e++]); ) lt.removeAttribute(t.name);
                  lt.save(Mt), (this.length = 0);
                },
                key: function(t) {
                  return lt.load(Mt), lt.XMLDocument.documentElement.attributes[t];
                }
              }),
              lt.load(Mt),
              (U.length = lt.XMLDocument.documentElement.attributes.length));
        }
        U ||
          (U = {
            length: 0,
            setItem: function(t, e) {},
            getItem: function(t) {},
            removeItem: function(t) {},
            clear: function() {},
            key: function(t) {}
          });
        var yt = U,
          gt = function() {
            this.storage = null;
          };
        (gt.prototype._cookiesEnabled = function() {
          var t,
            e = String(new Date());
          try {
            return pt.set(m, e), (t = pt.get(m) === e), pt.remove(m), t;
          } catch (t) {}
          return !1;
        }),
          (gt.prototype.getStorage = function() {
            return null !== this.storage
              ? this.storage
              : (this._cookiesEnabled()
                  ? (this.storage = pt)
                  : (this.storage = {
                      _options: { expirationDays: void 0, domain: void 0, secure: !1 },
                      reset: function() {
                        this._options = { expirationDays: void 0, domain: void 0, secure: !1 };
                      },
                      options: function(t) {
                        return 0 === arguments.length
                          ? this._options
                          : ((t = t || {}),
                            (this._options.expirationDays = t.expirationDays || this._options.expirationDays),
                            (this._options.domain =
                              t.domain || this._options.domain || (window && window.location && window.location.hostname)),
                            (this._options.secure = t.secure || !1));
                      },
                      get: function(t) {
                        try {
                          return JSON.parse(yt.getItem('amp_cookiestore_' + t));
                        } catch (t) {}
                        return null;
                      },
                      set: function(t, e) {
                        try {
                          return yt.setItem('amp_cookiestore_' + t, JSON.stringify(e)), !0;
                        } catch (t) {}
                        return !1;
                      },
                      remove: function(t) {
                        try {
                          yt.removeItem('amp_cookiestore_' + t);
                        } catch (t) {
                          return !1;
                        }
                      }
                    }),
                this.storage);
          });
        var dt = function() {
          (this.userPropertiesOperations = {}), (this.properties = []);
        };
        (dt.prototype.add = function(t, e) {
          return (
            'number' === k(e) || 'string' === k(e)
              ? this._addOperation('$add', t, e)
              : F.error('Unsupported type for value: ' + k(e) + ', expecting number or string'),
            this
          );
        }),
          (dt.prototype.append = function(t, e) {
            return this._addOperation('$append', t, e), this;
          }),
          (dt.prototype.clearAll = function() {
            return Object.keys(this.userPropertiesOperations).length > 0
              ? (this.userPropertiesOperations.hasOwnProperty('$clearAll') ||
                  F.error('Need to send $clearAll on its own Identify object without any other operations, skipping $clearAll'),
                this)
              : ((this.userPropertiesOperations.$clearAll = '-'), this);
          }),
          (dt.prototype.prepend = function(t, e) {
            return this._addOperation('$prepend', t, e), this;
          }),
          (dt.prototype.set = function(t, e) {
            return this._addOperation('$set', t, e), this;
          }),
          (dt.prototype.setOnce = function(t, e) {
            return this._addOperation('$setOnce', t, e), this;
          }),
          (dt.prototype.unset = function(t) {
            return this._addOperation('$unset', t, '-'), this;
          }),
          (dt.prototype._addOperation = function(t, e, n) {
            this.userPropertiesOperations.hasOwnProperty('$clearAll')
              ? F.error('This identify already contains a $clearAll operation, skipping operation ' + t)
              : -1 === this.properties.indexOf(e)
              ? (this.userPropertiesOperations.hasOwnProperty(t) || (this.userPropertiesOperations[t] = {}),
                (this.userPropertiesOperations[t][e] = n),
                this.properties.push(e))
              : F.error('User property "' + e + '" already used in this identify, skipping operation ' + t);
          });
        var ft = 'undefined' != typeof window ? window : void 0 !== n ? n : 'undefined' != typeof self ? self : {};
        function ht(t, e) {
          return t((e = { exports: {} }), e.exports), e.exports;
        }
        var Nt = ht(function(t) {
            !(function(e) {
              function n(t, e) {
                var n = (65535 & t) + (65535 & e);
                return (((t >> 16) + (e >> 16) + (n >> 16)) << 16) | (65535 & n);
              }
              function i(t, e, i, r, o, s) {
                return n(((a = n(n(e, t), n(r, s))) << (u = o)) | (a >>> (32 - u)), i);
              }
              function r(t, e, n, r, o, s, a) {
                return i((e & n) | (~e & r), t, e, o, s, a);
              }
              function o(t, e, n, r, o, s, a) {
                return i((e & r) | (n & ~r), t, e, o, s, a);
              }
              function s(t, e, n, r, o, s, a) {
                return i(e ^ n ^ r, t, e, o, s, a);
              }
              function a(t, e, n, r, o, s, a) {
                return i(n ^ (e | ~r), t, e, o, s, a);
              }
              function u(t, e) {
                var i, u, c, p, l;
                (t[e >> 5] |= 128 << e % 32), (t[14 + (((e + 64) >>> 9) << 4)] = e);
                var M = 1732584193,
                  y = -271733879,
                  g = -1732584194,
                  d = 271733878;
                for (i = 0; i < t.length; i += 16)
                  (u = M),
                    (c = y),
                    (p = g),
                    (l = d),
                    (M = r(M, y, g, d, t[i], 7, -680876936)),
                    (d = r(d, M, y, g, t[i + 1], 12, -389564586)),
                    (g = r(g, d, M, y, t[i + 2], 17, 606105819)),
                    (y = r(y, g, d, M, t[i + 3], 22, -1044525330)),
                    (M = r(M, y, g, d, t[i + 4], 7, -176418897)),
                    (d = r(d, M, y, g, t[i + 5], 12, 1200080426)),
                    (g = r(g, d, M, y, t[i + 6], 17, -1473231341)),
                    (y = r(y, g, d, M, t[i + 7], 22, -45705983)),
                    (M = r(M, y, g, d, t[i + 8], 7, 1770035416)),
                    (d = r(d, M, y, g, t[i + 9], 12, -1958414417)),
                    (g = r(g, d, M, y, t[i + 10], 17, -42063)),
                    (y = r(y, g, d, M, t[i + 11], 22, -1990404162)),
                    (M = r(M, y, g, d, t[i + 12], 7, 1804603682)),
                    (d = r(d, M, y, g, t[i + 13], 12, -40341101)),
                    (g = r(g, d, M, y, t[i + 14], 17, -1502002290)),
                    (M = o(M, (y = r(y, g, d, M, t[i + 15], 22, 1236535329)), g, d, t[i + 1], 5, -165796510)),
                    (d = o(d, M, y, g, t[i + 6], 9, -1069501632)),
                    (g = o(g, d, M, y, t[i + 11], 14, 643717713)),
                    (y = o(y, g, d, M, t[i], 20, -373897302)),
                    (M = o(M, y, g, d, t[i + 5], 5, -701558691)),
                    (d = o(d, M, y, g, t[i + 10], 9, 38016083)),
                    (g = o(g, d, M, y, t[i + 15], 14, -660478335)),
                    (y = o(y, g, d, M, t[i + 4], 20, -405537848)),
                    (M = o(M, y, g, d, t[i + 9], 5, 568446438)),
                    (d = o(d, M, y, g, t[i + 14], 9, -1019803690)),
                    (g = o(g, d, M, y, t[i + 3], 14, -187363961)),
                    (y = o(y, g, d, M, t[i + 8], 20, 1163531501)),
                    (M = o(M, y, g, d, t[i + 13], 5, -1444681467)),
                    (d = o(d, M, y, g, t[i + 2], 9, -51403784)),
                    (g = o(g, d, M, y, t[i + 7], 14, 1735328473)),
                    (M = s(M, (y = o(y, g, d, M, t[i + 12], 20, -1926607734)), g, d, t[i + 5], 4, -378558)),
                    (d = s(d, M, y, g, t[i + 8], 11, -2022574463)),
                    (g = s(g, d, M, y, t[i + 11], 16, 1839030562)),
                    (y = s(y, g, d, M, t[i + 14], 23, -35309556)),
                    (M = s(M, y, g, d, t[i + 1], 4, -1530992060)),
                    (d = s(d, M, y, g, t[i + 4], 11, 1272893353)),
                    (g = s(g, d, M, y, t[i + 7], 16, -155497632)),
                    (y = s(y, g, d, M, t[i + 10], 23, -1094730640)),
                    (M = s(M, y, g, d, t[i + 13], 4, 681279174)),
                    (d = s(d, M, y, g, t[i], 11, -358537222)),
                    (g = s(g, d, M, y, t[i + 3], 16, -722521979)),
                    (y = s(y, g, d, M, t[i + 6], 23, 76029189)),
                    (M = s(M, y, g, d, t[i + 9], 4, -640364487)),
                    (d = s(d, M, y, g, t[i + 12], 11, -421815835)),
                    (g = s(g, d, M, y, t[i + 15], 16, 530742520)),
                    (M = a(M, (y = s(y, g, d, M, t[i + 2], 23, -995338651)), g, d, t[i], 6, -198630844)),
                    (d = a(d, M, y, g, t[i + 7], 10, 1126891415)),
                    (g = a(g, d, M, y, t[i + 14], 15, -1416354905)),
                    (y = a(y, g, d, M, t[i + 5], 21, -57434055)),
                    (M = a(M, y, g, d, t[i + 12], 6, 1700485571)),
                    (d = a(d, M, y, g, t[i + 3], 10, -1894986606)),
                    (g = a(g, d, M, y, t[i + 10], 15, -1051523)),
                    (y = a(y, g, d, M, t[i + 1], 21, -2054922799)),
                    (M = a(M, y, g, d, t[i + 8], 6, 1873313359)),
                    (d = a(d, M, y, g, t[i + 15], 10, -30611744)),
                    (g = a(g, d, M, y, t[i + 6], 15, -1560198380)),
                    (y = a(y, g, d, M, t[i + 13], 21, 1309151649)),
                    (M = a(M, y, g, d, t[i + 4], 6, -145523070)),
                    (d = a(d, M, y, g, t[i + 11], 10, -1120210379)),
                    (g = a(g, d, M, y, t[i + 2], 15, 718787259)),
                    (y = a(y, g, d, M, t[i + 9], 21, -343485551)),
                    (M = n(M, u)),
                    (y = n(y, c)),
                    (g = n(g, p)),
                    (d = n(d, l));
                return [M, y, g, d];
              }
              function c(t) {
                var e,
                  n = '',
                  i = 32 * t.length;
                for (e = 0; e < i; e += 8) n += String.fromCharCode((t[e >> 5] >>> e % 32) & 255);
                return n;
              }
              function p(t) {
                var e,
                  n = [];
                for (n[(t.length >> 2) - 1] = void 0, e = 0; e < n.length; e += 1) n[e] = 0;
                var i = 8 * t.length;
                for (e = 0; e < i; e += 8) n[e >> 5] |= (255 & t.charCodeAt(e / 8)) << e % 32;
                return n;
              }
              function l(t) {
                var e,
                  n,
                  i = '';
                for (n = 0; n < t.length; n += 1)
                  (e = t.charCodeAt(n)), (i += '0123456789abcdef'.charAt((e >>> 4) & 15) + '0123456789abcdef'.charAt(15 & e));
                return i;
              }
              function M(t) {
                return unescape(encodeURIComponent(t));
              }
              function y(t) {
                return (function(t) {
                  return c(u(p(t), 8 * t.length));
                })(M(t));
              }
              function g(t, e) {
                return (function(t, e) {
                  var n,
                    i,
                    r = p(t),
                    o = [],
                    s = [];
                  for (o[15] = s[15] = void 0, r.length > 16 && (r = u(r, 8 * t.length)), n = 0; n < 16; n += 1)
                    (o[n] = 909522486 ^ r[n]), (s[n] = 1549556828 ^ r[n]);
                  return (i = u(o.concat(p(e)), 512 + 8 * e.length)), c(u(s.concat(i), 640));
                })(M(t), M(e));
              }
              function d(t, e, n) {
                return e ? (n ? g(e, t) : l(g(e, t))) : n ? y(t) : l(y(t));
              }
              t.exports ? (t.exports = d) : (e.md5 = d);
            })(ft);
          }),
          mt = function(t) {
            return encodeURIComponent(t).replace(/[!'()*]/g, function(t) {
              return (
                '%' +
                t
                  .charCodeAt(0)
                  .toString(16)
                  .toUpperCase()
              );
            });
          },
          It = Object.getOwnPropertySymbols,
          jt = Object.prototype.hasOwnProperty,
          bt = Object.prototype.propertyIsEnumerable;
        function Lt(t) {
          if (null == t) throw new TypeError('Object.assign cannot be called with null or undefined');
          return Object(t);
        }
        var Tt = (function() {
          try {
            if (!Object.assign) return !1;
            var t = new String('abc');
            if (((t[5] = 'de'), '5' === Object.getOwnPropertyNames(t)[0])) return !1;
            for (var e = {}, n = 0; n < 10; n++) e['_' + String.fromCharCode(n)] = n;
            if (
              '0123456789' !==
              Object.getOwnPropertyNames(e)
                .map(function(t) {
                  return e[t];
                })
                .join('')
            )
              return !1;
            var i = {};
            return (
              'abcdefghijklmnopqrst'.split('').forEach(function(t) {
                i[t] = t;
              }),
              'abcdefghijklmnopqrst' === Object.keys(Object.assign({}, i)).join('')
            );
          } catch (t) {
            return !1;
          }
        })()
          ? Object.assign
          : function(t, e) {
              for (var n, i, r = Lt(t), o = 1; o < arguments.length; o++) {
                for (var s in (n = Object(arguments[o]))) jt.call(n, s) && (r[s] = n[s]);
                if (It) {
                  i = It(n);
                  for (var a = 0; a < i.length; a++) bt.call(n, i[a]) && (r[i[a]] = n[i[a]]);
                }
              }
              return r;
            };
        function wt(t, e) {
          return e.encode ? (e.strict ? mt(t) : encodeURIComponent(t)) : t;
        }
        new RegExp('%[a-f0-9]{2}', 'gi'), new RegExp('(%[a-f0-9]{2})+', 'gi');
        var Dt = function(t, e) {
            !1 === (e = Tt({ encode: !0, strict: !0, arrayFormat: 'none' }, e)).sort && (e.sort = function() {});
            var n = (function(t) {
              switch (t.arrayFormat) {
                case 'index':
                  return function(e, n, i) {
                    return null === n ? [wt(e, t), '[', i, ']'].join('') : [wt(e, t), '[', wt(i, t), ']=', wt(n, t)].join('');
                  };
                case 'bracket':
                  return function(e, n) {
                    return null === n ? wt(e, t) : [wt(e, t), '[]=', wt(n, t)].join('');
                  };
                default:
                  return function(e, n) {
                    return null === n ? wt(e, t) : [wt(e, t), '=', wt(n, t)].join('');
                  };
              }
            })(e);
            return t
              ? Object.keys(t)
                  .sort(e.sort)
                  .map(function(i) {
                    var r = t[i];
                    if (void 0 === r) return '';
                    if (null === r) return wt(i, e);
                    if (Array.isArray(r)) {
                      var o = [];
                      return (
                        r.slice().forEach(function(t) {
                          void 0 !== t && o.push(n(i, t, o.length));
                        }),
                        o.join('&')
                      );
                    }
                    return wt(i, e) + '=' + wt(r, e);
                  })
                  .filter(function(t) {
                    return t.length > 0;
                  })
                  .join('&')
              : '';
          },
          At = function(t, e) {
            (this.url = t), (this.data = e || {});
          };
        At.prototype.send = function(t) {
          if (window.XDomainRequest) {
            var e = new window.XDomainRequest();
            e.open('POST', this.url, !0),
              (e.onload = function() {
                t(200, e.responseText);
              }),
              (e.onerror = function() {
                'Request Entity Too Large' === e.responseText ? t(413, e.responseText) : t(500, e.responseText);
              }),
              (e.ontimeout = function() {}),
              (e.onprogress = function() {}),
              e.send(Dt(this.data));
          } else {
            var n = new XMLHttpRequest();
            n.open('POST', this.url, !0),
              (n.onreadystatechange = function() {
                4 === n.readyState && t(n.status, n.responseText);
              }),
              n.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8'),
              n.send(Dt(this.data));
          }
        };
        var vt = function() {
          (this._price = null), (this._productId = null), (this._quantity = 1), (this._revenueType = null), (this._properties = null);
        };
        (vt.prototype.setProductId = function(t) {
          return (
            'string' !== k(t)
              ? F.error('Unsupported type for productId: ' + k(t) + ', expecting string')
              : V(t)
              ? F.error('Invalid empty productId')
              : (this._productId = t),
            this
          );
        }),
          (vt.prototype.setQuantity = function(t) {
            return (
              'number' !== k(t) ? F.error('Unsupported type for quantity: ' + k(t) + ', expecting number') : (this._quantity = parseInt(t)),
              this
            );
          }),
          (vt.prototype.setPrice = function(t) {
            return 'number' !== k(t) ? F.error('Unsupported type for price: ' + k(t) + ', expecting number') : (this._price = t), this;
          }),
          (vt.prototype.setRevenueType = function(t) {
            return (
              'string' !== k(t) ? F.error('Unsupported type for revenueType: ' + k(t) + ', expecting string') : (this._revenueType = t),
              this
            );
          }),
          (vt.prototype.setEventProperties = function(t) {
            return (
              'object' !== k(t)
                ? F.error('Unsupported type for eventProperties: ' + k(t) + ', expecting object')
                : (this._properties = tt(t)),
              this
            );
          }),
          (vt.prototype._isValidRevenue = function() {
            return 'number' === k(this._price) || (F.error('Invalid revenue, need to set price field'), !1);
          }),
          (vt.prototype._toJSONObject = function() {
            var t = 'object' === k(this._properties) ? this._properties : {};
            return (
              null !== this._productId && (t[j] = this._productId),
              null !== this._quantity && (t[b] = this._quantity),
              null !== this._price && (t[L] = this._price),
              null !== this._revenueType && (t[T] = this._revenueType),
              t
            );
          });
        var _t = ht(function(t, e) {
            /*!
             * UAParser.js v0.7.19
             * Lightweight JavaScript-based User-Agent string parser
             * https://github.com/faisalman/ua-parser-js
             *
             * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
             * Dual licensed under GPLv2 or MIT
             */
            !(function(n, i) {
              var r = 'model',
                o = 'name',
                s = 'type',
                a = 'vendor',
                u = 'version',
                c = 'mobile',
                p = 'tablet',
                l = {
                  extend: function(t, e) {
                    var n = {};
                    for (var i in t) e[i] && e[i].length % 2 == 0 ? (n[i] = e[i].concat(t[i])) : (n[i] = t[i]);
                    return n;
                  },
                  has: function(t, e) {
                    return 'string' == typeof t && -1 !== e.toLowerCase().indexOf(t.toLowerCase());
                  },
                  lowerize: function(t) {
                    return t.toLowerCase();
                  },
                  major: function(t) {
                    return 'string' == typeof t ? t.replace(/[^\d\.]/g, '').split('.')[0] : void 0;
                  },
                  trim: function(t) {
                    return t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
                  }
                },
                M = {
                  rgx: function(t, e) {
                    for (var n, i, r, o, s, a, u = 0; u < e.length && !s; ) {
                      var c = e[u],
                        p = e[u + 1];
                      for (n = i = 0; n < c.length && !s; )
                        if ((s = c[n++].exec(t)))
                          for (r = 0; r < p.length; r++)
                            (a = s[++i]),
                              'object' == typeof (o = p[r]) && o.length > 0
                                ? 2 == o.length
                                  ? 'function' == typeof o[1]
                                    ? (this[o[0]] = o[1].call(this, a))
                                    : (this[o[0]] = o[1])
                                  : 3 == o.length
                                  ? 'function' != typeof o[1] || (o[1].exec && o[1].test)
                                    ? (this[o[0]] = a ? a.replace(o[1], o[2]) : void 0)
                                    : (this[o[0]] = a ? o[1].call(this, a, o[2]) : void 0)
                                  : 4 == o.length && (this[o[0]] = a ? o[3].call(this, a.replace(o[1], o[2])) : void 0)
                                : (this[o] = a || void 0);
                      u += 2;
                    }
                  },
                  str: function(t, e) {
                    for (var n in e)
                      if ('object' == typeof e[n] && e[n].length > 0) {
                        for (var i = 0; i < e[n].length; i++) if (l.has(e[n][i], t)) return '?' === n ? void 0 : n;
                      } else if (l.has(e[n], t)) return '?' === n ? void 0 : n;
                    return t;
                  }
                },
                y = {
                  browser: {
                    oldsafari: {
                      version: {
                        '1.0': '/8',
                        1.2: '/1',
                        1.3: '/3',
                        '2.0': '/412',
                        '2.0.2': '/416',
                        '2.0.3': '/417',
                        '2.0.4': '/419',
                        '?': '/'
                      }
                    },
                    name: { 'Opera Mobile': 'Opera Mobi', 'IE Mobile': 'IEMobile' }
                  },
                  device: {
                    amazon: { model: { 'Fire Phone': ['SD', 'KF'] } },
                    sprint: { model: { 'Evo Shift 4G': '7373KT' }, vendor: { HTC: 'APA', Sprint: 'Sprint' } }
                  },
                  os: {
                    windows: {
                      version: {
                        ME: '4.90',
                        'NT 3.11': 'NT3.51',
                        'NT 4.0': 'NT4.0',
                        2e3: 'NT 5.0',
                        XP: ['NT 5.1', 'NT 5.2'],
                        Vista: 'NT 6.0',
                        7: 'NT 6.1',
                        8: 'NT 6.2',
                        8.1: 'NT 6.3',
                        10: ['NT 6.4', 'NT 10.0'],
                        RT: 'ARM'
                      },
                      name: { 'Windows Phone': 'Windows Phone OS' }
                    }
                  }
                },
                g = {
                  browser: [
                    [
                      /(opera\smini)\/([\w\.-]+)/i,
                      /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,
                      /(opera).+version\/([\w\.]+)/i,
                      /(opera)[\/\s]+([\w\.]+)/i
                    ],
                    [o, u],
                    [/(opios)[\/\s]+([\w\.]+)/i],
                    [[o, 'Opera Mini'], u],
                    [/\s(opr)\/([\w\.]+)/i],
                    [[o, 'Opera'], u],
                    [
                      /(kindle)\/([\w\.]+)/i,
                      /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                      /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                      /(?:ms|\()(ie)\s([\w\.]+)/i,
                      /(rekonq)\/([\w\.]*)/i,
                      /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                    ],
                    [o, u],
                    [/(konqueror)\/([\w\.]+)/i],
                    [[o, 'Konqueror'], u],
                    [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],
                    [[o, 'IE'], u],
                    [/(edge|edgios|edga)\/((\d+)?[\w\.]+)/i],
                    [[o, 'Edge'], u],
                    [/(yabrowser)\/([\w\.]+)/i],
                    [[o, 'Yandex'], u],
                    [/(puffin)\/([\w\.]+)/i],
                    [[o, 'Puffin'], u],
                    [/(focus)\/([\w\.]+)/i],
                    [[o, 'Firefox Focus'], u],
                    [/(opt)\/([\w\.]+)/i],
                    [[o, 'Opera Touch'], u],
                    [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],
                    [[o, 'UCBrowser'], u],
                    [/(comodo_dragon)\/([\w\.]+)/i],
                    [[o, /_/g, ' '], u],
                    [/((?:android.+)crmo|crios)\/([\w\.]+)/i, /android.+(chrome)\/([\w\.]+)\s+(?:mobile\s?safari)/i],
                    [[o, 'Chrome Mobile'], u],
                    [/(micromessenger)\/([\w\.]+)/i],
                    [[o, 'WeChat'], u],
                    [/(brave)\/([\w\.]+)/i],
                    [[o, 'Brave'], u],
                    [/(qqbrowserlite)\/([\w\.]+)/i],
                    [o, u],
                    [/(QQ)\/([\d\.]+)/i],
                    [o, u],
                    [/m?(qqbrowser)[\/\s]?([\w\.]+)/i],
                    [o, u],
                    [/(BIDUBrowser)[\/\s]?([\w\.]+)/i],
                    [o, u],
                    [/(2345Explorer)[\/\s]?([\w\.]+)/i],
                    [o, u],
                    [/(MetaSr)[\/\s]?([\w\.]+)/i],
                    [o],
                    [/(LBBROWSER)/i],
                    [o],
                    [/xiaomi\/miuibrowser\/([\w\.]+)/i],
                    [u, [o, 'MIUI Browser']],
                    [/;fbav\/([\w\.]+);/i],
                    [u, [o, 'Facebook']],
                    [/safari\s(line)\/([\w\.]+)/i, /android.+(line)\/([\w\.]+)\/iab/i],
                    [o, u],
                    [/headlesschrome(?:\/([\w\.]+)|\s)/i],
                    [u, [o, 'Chrome Headless']],
                    [/\swv\).+(chrome)\/([\w\.]+)/i],
                    [[o, /(.+)/, '$1 WebView'], u],
                    [/((?:oculus|samsung)browser)\/([\w\.]+)/i],
                    [[o, /(.+(?:g|us))(.+)/, '$1 $2'], u],
                    [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],
                    [u, [o, 'Android Browser']],
                    [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],
                    [o, u],
                    [/(dolfin)\/([\w\.]+)/i],
                    [[o, 'Dolphin'], u],
                    [/(coast)\/([\w\.]+)/i],
                    [[o, 'Opera Coast'], u],
                    [/fxios\/([\w\.-]+)/i],
                    [u, [o, 'Firefox']],
                    [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],
                    [u, [o, 'Mobile Safari']],
                    [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],
                    [u, o],
                    [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],
                    [[o, 'GSA'], u],
                    [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],
                    [o, [u, M.str, y.browser.oldsafari.version]],
                    [/(webkit|khtml)\/([\w\.]+)/i],
                    [o, u],
                    [/(navigator|netscape)\/([\w\.-]+)/i],
                    [[o, 'Netscape'], u],
                    [
                      /(swiftfox)/i,
                      /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                      /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)/i,
                      /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,
                      /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                      /(links)\s\(([\w\.]+)/i,
                      /(gobrowser)\/?([\w\.]*)/i,
                      /(ice\s?browser)\/v?([\w\._]+)/i,
                      /(mosaic)[\/\s]([\w\.]+)/i
                    ],
                    [o, u]
                  ],
                  cpu: [
                    [/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],
                    [['architecture', 'amd64']],
                    [/(ia32(?=;))/i],
                    [['architecture', l.lowerize]],
                    [/((?:i[346]|x)86)[;\)]/i],
                    [['architecture', 'ia32']],
                    [/windows\s(ce|mobile);\sppc;/i],
                    [['architecture', 'arm']],
                    [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],
                    [['architecture', /ower/, '', l.lowerize]],
                    [/(sun4\w)[;\)]/i],
                    [['architecture', 'sparc']],
                    [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],
                    [['architecture', l.lowerize]]
                  ],
                  device: [
                    [/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i],
                    [r, a, [s, p]],
                    [/applecoremedia\/[\w\.]+ \((ipad)/],
                    [r, [a, 'Apple'], [s, p]],
                    [/(apple\s{0,1}tv)/i],
                    [
                      [r, 'Apple TV'],
                      [a, 'Apple']
                    ],
                    [
                      /(archos)\s(gamepad2?)/i,
                      /(hp).+(touchpad)/i,
                      /(hp).+(tablet)/i,
                      /(kindle)\/([\w\.]+)/i,
                      /\s(nook)[\w\s]+build\/(\w+)/i,
                      /(dell)\s(strea[kpr\s\d]*[\dko])/i
                    ],
                    [a, r, [s, p]],
                    [/(kf[A-z]+)\sbuild\/.+silk\//i],
                    [r, [a, 'Amazon'], [s, p]],
                    [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],
                    [
                      [r, M.str, y.device.amazon.model],
                      [a, 'Amazon'],
                      [s, c]
                    ],
                    [/android.+aft([bms])\sbuild/i],
                    [r, [a, 'Amazon'], [s, 'smarttv']],
                    [/\((ip[honed|\s\w*]+);.+(apple)/i],
                    [r, a, [s, c]],
                    [/\((ip[honed|\s\w*]+);/i],
                    [r, [a, 'Apple'], [s, c]],
                    [
                      /(blackberry)[\s-]?(\w+)/i,
                      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                      /(hp)\s([\w\s]+\w)/i,
                      /(asus)-?(\w+)/i
                    ],
                    [a, r, [s, c]],
                    [/\(bb10;\s(\w+)/i],
                    [r, [a, 'BlackBerry'], [s, c]],
                    [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i],
                    [r, [a, 'Asus'], [s, p]],
                    [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i],
                    [
                      [a, 'Sony'],
                      [r, 'Xperia Tablet'],
                      [s, p]
                    ],
                    [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i],
                    [r, [a, 'Sony'], [s, c]],
                    [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i],
                    [a, r, [s, 'console']],
                    [/android.+;\s(shield)\sbuild/i],
                    [r, [a, 'Nvidia'], [s, 'console']],
                    [/(playstation\s[34portablevi]+)/i],
                    [r, [a, 'Sony'], [s, 'console']],
                    [/(sprint\s(\w+))/i],
                    [
                      [a, M.str, y.device.sprint.vendor],
                      [r, M.str, y.device.sprint.model],
                      [s, c]
                    ],
                    [/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],
                    [a, r, [s, p]],
                    [
                      /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,
                      /(zte)-(\w*)/i,
                      /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                    ],
                    [a, [r, /_/g, ' '], [s, c]],
                    [/(nexus\s9)/i],
                    [r, [a, 'HTC'], [s, p]],
                    [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p)/i],
                    [r, [a, 'Huawei'], [s, c]],
                    [/(microsoft);\s(lumia[\s\w]+)/i],
                    [a, r, [s, c]],
                    [/[\s\(;](xbox(?:\sone)?)[\s\);]/i],
                    [r, [a, 'Microsoft'], [s, 'console']],
                    [/(kin\.[onetw]{3})/i],
                    [
                      [r, /\./g, ' '],
                      [a, 'Microsoft'],
                      [s, c]
                    ],
                    [
                      /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
                      /mot[\s-]?(\w*)/i,
                      /(XT\d{3,4}) build\//i,
                      /(nexus\s6)/i
                    ],
                    [r, [a, 'Motorola'], [s, c]],
                    [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],
                    [r, [a, 'Motorola'], [s, p]],
                    [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],
                    [
                      [a, l.trim],
                      [r, l.trim],
                      [s, 'smarttv']
                    ],
                    [/hbbtv.+maple;(\d+)/i],
                    [
                      [r, /^/, 'SmartTV'],
                      [a, 'Samsung'],
                      [s, 'smarttv']
                    ],
                    [/\(dtv[\);].+(aquos)/i],
                    [r, [a, 'Sharp'], [s, 'smarttv']],
                    [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i],
                    [[a, 'Samsung'], r, [s, p]],
                    [/smart-tv.+(samsung)/i],
                    [a, [s, 'smarttv'], r],
                    [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i],
                    [[a, 'Samsung'], r, [s, c]],
                    [/sie-(\w*)/i],
                    [r, [a, 'Siemens'], [s, c]],
                    [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i],
                    [[a, 'Nokia'], r, [s, c]],
                    [/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i],
                    [r, [a, 'Acer'], [s, p]],
                    [/android.+([vl]k\-?\d{3})\s+build/i],
                    [r, [a, 'LG'], [s, p]],
                    [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],
                    [[a, 'LG'], r, [s, p]],
                    [/(lg) netcast\.tv/i],
                    [a, r, [s, 'smarttv']],
                    [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i],
                    [r, [a, 'LG'], [s, c]],
                    [/android.+(ideatab[a-z0-9\-\s]+)/i],
                    [r, [a, 'Lenovo'], [s, p]],
                    [/linux;.+((jolla));/i],
                    [a, r, [s, c]],
                    [/((pebble))app\/[\d\.]+\s/i],
                    [a, r, [s, 'wearable']],
                    [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],
                    [a, r, [s, c]],
                    [/crkey/i],
                    [
                      [r, 'Chromecast'],
                      [a, 'Google']
                    ],
                    [/android.+;\s(glass)\s\d/i],
                    [r, [a, 'Google'], [s, 'wearable']],
                    [/android.+;\s(pixel c)[\s)]/i],
                    [r, [a, 'Google'], [s, p]],
                    [/android.+;\s(pixel( [23])?( xl)?)\s/i],
                    [r, [a, 'Google'], [s, c]],
                    [
                      /android.+;\s(\w+)\s+build\/hm\1/i,
                      /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,
                      /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,
                      /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i
                    ],
                    [
                      [r, /_/g, ' '],
                      [a, 'Xiaomi'],
                      [s, c]
                    ],
                    [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],
                    [
                      [r, /_/g, ' '],
                      [a, 'Xiaomi'],
                      [s, p]
                    ],
                    [/android.+;\s(m[1-5]\snote)\sbuild/i],
                    [r, [a, 'Meizu'], [s, p]],
                    [/(mz)-([\w-]{2,})/i],
                    [[a, 'Meizu'], r, [s, c]],
                    [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})\s+build/i],
                    [r, [a, 'OnePlus'], [s, c]],
                    [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],
                    [r, [a, 'RCA'], [s, p]],
                    [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],
                    [r, [a, 'Dell'], [s, p]],
                    [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],
                    [r, [a, 'Verizon'], [s, p]],
                    [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],
                    [[a, 'Barnes & Noble'], r, [s, p]],
                    [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],
                    [r, [a, 'NuVision'], [s, p]],
                    [/android.+;\s(k88)\sbuild/i],
                    [r, [a, 'ZTE'], [s, p]],
                    [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],
                    [r, [a, 'Swiss'], [s, c]],
                    [/android.+[;\/]\s*(zur\d{3})\s+build/i],
                    [r, [a, 'Swiss'], [s, p]],
                    [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],
                    [r, [a, 'Zeki'], [s, p]],
                    [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],
                    [[a, 'Dragon Touch'], r, [s, p]],
                    [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],
                    [r, [a, 'Insignia'], [s, p]],
                    [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],
                    [r, [a, 'NextBook'], [s, p]],
                    [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],
                    [[a, 'Voice'], r, [s, c]],
                    [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],
                    [[a, 'LvTel'], r, [s, c]],
                    [/android.+;\s(PH-1)\s/i],
                    [r, [a, 'Essential'], [s, c]],
                    [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],
                    [r, [a, 'Envizen'], [s, p]],
                    [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],
                    [a, r, [s, p]],
                    [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],
                    [r, [a, 'MachSpeed'], [s, p]],
                    [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],
                    [a, r, [s, p]],
                    [/android.+[;\/]\s*TU_(1491)\s+build/i],
                    [r, [a, 'Rotor'], [s, p]],
                    [/android.+(KS(.+))\s+build/i],
                    [r, [a, 'Amazon'], [s, p]],
                    [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],
                    [a, r, [s, p]],
                    [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i],
                    [[s, l.lowerize], a, r],
                    [/[\s\/\(](smart-?tv)[;\)]/i],
                    [[s, 'smarttv']],
                    [/(android[\w\.\s\-]{0,9});.+build/i],
                    [r, [a, 'Generic']]
                  ],
                  engine: [
                    [/windows.+\sedge\/([\w\.]+)/i],
                    [u, [o, 'EdgeHTML']],
                    [/webkit\/537\.36.+chrome\/(?!27)/i],
                    [[o, 'Blink']],
                    [
                      /(presto)\/([\w\.]+)/i,
                      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                      /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,
                      /(icab)[\/\s]([23]\.[\d\.]+)/i
                    ],
                    [o, u],
                    [/rv\:([\w\.]{1,9}).+(gecko)/i],
                    [u, o]
                  ],
                  os: [
                    [/microsoft\s(windows)\s(vista|xp)/i],
                    [o, u],
                    [
                      /(windows)\snt\s6\.2;\s(arm)/i,
                      /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,
                      /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
                    ],
                    [
                      [o, M.str, y.os.windows.name],
                      [u, M.str, y.os.windows.version]
                    ],
                    [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],
                    [
                      [o, 'Windows'],
                      [u, M.str, y.os.windows.version]
                    ],
                    [/\((bb)(10);/i],
                    [[o, 'BlackBerry'], u],
                    [
                      /(blackberry)\w*\/?([\w\.]*)/i,
                      /(tizen)[\/\s]([\w\.]+)/i,
                      /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,
                      /linux;.+(sailfish);/i
                    ],
                    [o, u],
                    [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],
                    [[o, 'Symbian'], u],
                    [/\((series40);/i],
                    [o],
                    [/mozilla.+\(mobile;.+gecko.+firefox/i],
                    [[o, 'Firefox OS'], u],
                    [
                      /(nintendo|playstation)\s([wids34portablevu]+)/i,
                      /(mint)[\/\s\(]?(\w*)/i,
                      /(mageia|vectorlinux)[;\s]/i,
                      /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                      /(hurd|linux)\s?([\w\.]*)/i,
                      /(gnu)\s?([\w\.]*)/i
                    ],
                    [[o, 'Linux'], u],
                    [/(cros)\s[\w]+\s([\w\.]+\w)/i],
                    [[o, 'Chromium OS'], u],
                    [/(sunos)\s?([\w\.\d]*)/i],
                    [[o, 'Solaris'], u],
                    [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],
                    [[o, 'Linux'], u],
                    [/(iphone)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i],
                    [
                      [o, 'iPhone'],
                      [u, /_/g, '.']
                    ],
                    [/(ipad)(?:.*os\s*([\w]*)\slike\smac|;\sopera)/i],
                    [
                      [o, 'iPad'],
                      [u, /_/g, '.']
                    ],
                    [/(haiku)\s(\w+)/i],
                    [o, u],
                    [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],
                    [
                      [u, /_/g, '.'],
                      [o, 'iOS']
                    ],
                    [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i],
                    [
                      [o, 'Mac'],
                      [u, /_/g, '.']
                    ],
                    [
                      /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,
                      /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,
                      /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                      /(unix)\s?([\w\.]*)/i
                    ],
                    [o, u]
                  ]
                },
                d = function(t, e) {
                  if (('object' == typeof t && ((e = t), (t = void 0)), !(this instanceof d))) return new d(t, e).getResult();
                  var i = t || (n && n.navigator && n.navigator.userAgent ? n.navigator.userAgent : ''),
                    r = e ? l.extend(g, e) : g;
                  return (
                    (this.getBrowser = function() {
                      var t = { name: void 0, version: void 0 };
                      return M.rgx.call(t, i, r.browser), (t.major = l.major(t.version)), t;
                    }),
                    (this.getCPU = function() {
                      var t = { architecture: void 0 };
                      return M.rgx.call(t, i, r.cpu), t;
                    }),
                    (this.getDevice = function() {
                      var t = { vendor: void 0, model: void 0, type: void 0 };
                      return M.rgx.call(t, i, r.device), t;
                    }),
                    (this.getEngine = function() {
                      var t = { name: void 0, version: void 0 };
                      return M.rgx.call(t, i, r.engine), t;
                    }),
                    (this.getOS = function() {
                      var t = { name: void 0, version: void 0 };
                      return M.rgx.call(t, i, r.os), t;
                    }),
                    (this.getResult = function() {
                      return {
                        ua: this.getUA(),
                        browser: this.getBrowser(),
                        engine: this.getEngine(),
                        os: this.getOS(),
                        device: this.getDevice(),
                        cpu: this.getCPU()
                      };
                    }),
                    (this.getUA = function() {
                      return i;
                    }),
                    (this.setUA = function(t) {
                      return (i = t), this;
                    }),
                    this
                  );
                };
              (d.VERSION = '0.7.19'),
                (d.BROWSER = { NAME: o, MAJOR: 'major', VERSION: u }),
                (d.CPU = { ARCHITECTURE: 'architecture' }),
                (d.DEVICE = {
                  MODEL: r,
                  VENDOR: a,
                  TYPE: s,
                  CONSOLE: 'console',
                  MOBILE: c,
                  SMARTTV: 'smarttv',
                  TABLET: p,
                  WEARABLE: 'wearable',
                  EMBEDDED: 'embedded'
                }),
                (d.ENGINE = { NAME: o, VERSION: u }),
                (d.OS = { NAME: o, VERSION: u }),
                t.exports && (e = t.exports = d),
                (e.UAParser = d);
              var f = n && (n.jQuery || n.Zepto);
              if (void 0 !== f && !f.ua) {
                var h = new d();
                (f.ua = h.getResult()),
                  (f.ua.get = function() {
                    return h.getUA();
                  }),
                  (f.ua.set = function(t) {
                    h.setUA(t);
                    var e = h.getResult();
                    for (var n in e) f.ua[n] = e[n];
                  });
              }
            })('object' == typeof window ? window : ft);
          }),
          xt =
            (_t.UAParser,
            function t(e) {
              return e ? (e ^ ((16 * Math.random()) >> (e / 4))).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, t);
            }),
          zt = {
            apiEndpoint: 'api.amplitude.com',
            batchEvents: !1,
            cookieExpiration: 3650,
            cookieName: 'amplitude_id',
            deviceIdFromUrlParam: !1,
            domain: '',
            eventUploadPeriodMillis: 3e4,
            eventUploadThreshold: 30,
            forceHttps: !0,
            includeGclid: !1,
            includeReferrer: !1,
            includeUtm: !1,
            language:
              (navigator && ((navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage)) || void 0,
            logLevel: 'WARN',
            optOut: !1,
            onError: function() {},
            platform: 'Web',
            savedMaxCount: 1e3,
            saveEvents: !0,
            saveParamsReferrerOncePerSession: !0,
            secureCookie: !1,
            sessionTimeout: 18e5,
            trackingOptions: {
              city: !0,
              country: !0,
              carrier: !0,
              device_manufacturer: !0,
              device_model: !0,
              dma: !0,
              ip_address: !0,
              language: !0,
              os_name: !0,
              os_version: !0,
              platform: !0,
              region: !0,
              version_name: !0
            },
            unsetParamsReferrerOnNewSession: !1,
            unsentKey: 'amplitude_unsent',
            unsentIdentifyKey: 'amplitude_unsent_identify',
            uploadBatchSize: 100
          },
          St = function(t) {
            (this._instanceName = V(t) ? o : t.toLowerCase()),
              (this._legacyStorageSuffix = this._instanceName === o ? '' : '_' + this._instanceName),
              (this._unsentEvents = []),
              (this._unsentIdentifys = []),
              (this._ua = new _t(navigator.userAgent).getResult()),
              (this.options = r({}, zt, { trackingOptions: r({}, zt.trackingOptions) })),
              (this.cookieStorage = new gt().getStorage()),
              (this._q = []),
              (this._sending = !1),
              (this._updateScheduled = !1),
              (this._onInit = []),
              (this._eventId = 0),
              (this._identifyId = 0),
              (this._lastEventTime = null),
              (this._newSession = !1),
              (this._sequenceNumber = 0),
              (this._sessionId = null),
              (this._isInitialized = !1),
              (this._userAgent = (navigator && navigator.userAgent) || null);
          };
        (St.prototype.Identify = dt),
          (St.prototype.Revenue = vt),
          (St.prototype.init = function(t, e, n, i) {
            var r = this;
            if ('string' !== k(t) || V(t)) F.error('Invalid apiKey. Please re-initialize with a valid apiKey');
            else
              try {
                (this.options.apiKey = t), (this._storageSuffix = '_' + t + this._legacyStorageSuffix);
                var s = !!this.cookieStorage.get(this.options.cookieName + this._storageSuffix);
                if (n && n.deferInitialization && !s) return void this._deferInitialization(t, e, n, i);
                Et(this.options, n), 'string' === k(this.options.logLevel) && H(this.options.logLevel);
                var a = Rt(this);
                (this._apiPropertiesTrackingOptions = Object.keys(a).length > 0 ? { tracking_options: a } : {}),
                  this.cookieStorage.options({
                    expirationDays: this.options.cookieExpiration,
                    domain: this.options.domain,
                    secure: this.options.secureCookie
                  }),
                  (this.options.domain = this.cookieStorage.options().domain),
                  this._instanceName === o && Ot(this),
                  Ct(this),
                  (this._pendingReadStorage = !0);
                var u = function(t) {
                  (r.options.deviceId =
                    ('object' === k(n) && 'string' === k(n.deviceId) && !V(n.deviceId) && n.deviceId) ||
                    (r.options.deviceIdFromUrlParam && r._getDeviceIdFromUrlParam(r._getUrlParams())) ||
                    r.options.deviceId ||
                    t ||
                    xt() + 'R'),
                    (r.options.userId =
                      ('string' === k(e) && !V(e) && e) || ('number' === k(e) && e.toString()) || r.options.userId || null);
                  var i = new Date().getTime();
                  if (
                    ((!r._sessionId || !r._lastEventTime || i - r._lastEventTime > r.options.sessionTimeout) &&
                      (r.options.unsetParamsReferrerOnNewSession && r._unsetUTMParams(),
                      (r._newSession = !0),
                      (r._sessionId = i),
                      r.options.saveParamsReferrerOncePerSession && r._trackParamsAndReferrer()),
                    r.options.saveParamsReferrerOncePerSession || r._trackParamsAndReferrer(),
                    r.options.saveEvents)
                  ) {
                    for (var o = 0; o < r._unsentEvents.length; o++) {
                      var s = r._unsentEvents[o].event_properties,
                        a = r._unsentEvents[o].groups;
                      (r._unsentEvents[o].event_properties = tt(s)), (r._unsentEvents[o].groups = K(a));
                    }
                    for (var u = 0; u < r._unsentIdentifys.length; u++) {
                      var c = r._unsentIdentifys[u].user_properties,
                        p = r._unsentIdentifys[u].groups;
                      (r._unsentIdentifys[u].user_properties = tt(c)), (r._unsentIdentifys[u].groups = K(p));
                    }
                  }
                  (r._lastEventTime = i), Ut(r), (r._pendingReadStorage = !1), r._sendEventsIfReady();
                  for (var l = 0; l < r._onInit.length; l++) r._onInit[l]();
                  (r._onInit = []), (r._isInitialized = !0);
                };
                this.options.saveEvents &&
                  ((this._unsentEvents = this._loadSavedUnsentEvents(this.options.unsentKey).concat(this._unsentEvents)),
                  (this._unsentIdentifys = this._loadSavedUnsentEvents(this.options.unsentIdentifyKey).concat(this._unsentIdentifys))),
                  u(),
                  this.runQueuedFunctions(),
                  'function' === k(i) && i(this);
              } catch (t) {
                F.error(t), this.options.onError(t);
              }
          }),
          (St.prototype._migrateUnsentEvents = function(t) {
            var e = this;
            Promise.all([(void 0).getItem(this.options.unsentKey), (void 0).getItem(this.options.unsentIdentifyKey)])
              .then(function(t) {
                if (e.options.saveEvents) {
                  var n = t[0],
                    i = t[1],
                    r = [],
                    o = [];
                  n &&
                    (r.push((void 0).setItem(e.options.unsentKey + e._storageSuffix, JSON.stringify(n))),
                    o.push((void 0).removeItem(e.options.unsentKey))),
                    i &&
                      (r.push((void 0).setItem(e.options.unsentIdentifyKey + e._storageSuffix, JSON.stringify(i))),
                      o.push((void 0).removeItem(e.options.unsentIdentifyKey))),
                    r.length > 0 &&
                      Promise.all(r)
                        .then(function() {})
                        .catch(function(t) {
                          e.options.onError(t);
                        });
                }
              })
              .then(t)
              .catch(function(t) {
                e.options.onError(t);
              });
          }),
          (St.prototype._trackParamsAndReferrer = function() {
            this.options.includeUtm && this._initUtmData(),
              this.options.includeReferrer && this._saveReferrer(this._getReferrer()),
              this.options.includeGclid && this._saveGclid(this._getUrlParams());
          });
        var Et = function t(e, n) {
          if ('object' === k(n)) {
            var i = function(i) {
              if (e.hasOwnProperty(i)) {
                var r = n[i],
                  o = k(e[i]);
                $(r, i + ' option', o) &&
                  ('boolean' === o
                    ? (e[i] = !!r)
                    : ('string' === o && !V(r)) || ('number' === o && r > 0)
                    ? (e[i] = r)
                    : 'object' === o && t(e[i], r));
              }
            };
            for (var r in n) n.hasOwnProperty(r) && i(r);
          }
        };
        (St.prototype.runQueuedFunctions = function() {
          var t = this._q;
          this._q = [];
          for (var e = 0; e < t.length; e++) {
            var n = this[t[e][0]];
            'function' === k(n) && n.apply(this, t[e].slice(1));
          }
        }),
          (St.prototype._apiKeySet = function(t) {
            return !V(this.options.apiKey) || (F.error('Invalid apiKey. Please set a valid apiKey with init() before calling ' + t), !1);
          }),
          (St.prototype._loadSavedUnsentEvents = function(t) {
            var e = this._getFromStorage(yt, t),
              n = this._parseSavedUnsentEventsString(e, t);
            return this._setInStorage(yt, t, JSON.stringify(n)), n;
          }),
          (St.prototype._parseSavedUnsentEventsString = function(t, e) {
            if (V(t)) return [];
            if ('string' === k(t))
              try {
                var n = JSON.parse(t);
                if ('array' === k(n)) return n;
              } catch (t) {}
            return F.error('Unable to load ' + e + ' events. Restart with a new empty queue.'), [];
          }),
          (St.prototype.isNewSession = function() {
            return this._newSession;
          }),
          (St.prototype.onInit = function(t) {
            this._isInitialized ? t() : this._onInit.push(t);
          }),
          (St.prototype.getSessionId = function() {
            return this._sessionId;
          }),
          (St.prototype.nextEventId = function() {
            return this._eventId++, this._eventId;
          }),
          (St.prototype.nextIdentifyId = function() {
            return this._identifyId++, this._identifyId;
          }),
          (St.prototype.nextSequenceNumber = function() {
            return this._sequenceNumber++, this._sequenceNumber;
          }),
          (St.prototype._unsentCount = function() {
            return this._unsentEvents.length + this._unsentIdentifys.length;
          }),
          (St.prototype._sendEventsIfReady = function(t) {
            return (
              0 !== this._unsentCount() &&
              (this.options.batchEvents
                ? this._unsentCount() >= this.options.eventUploadThreshold
                  ? (this.sendEvents(t), !0)
                  : (this._updateScheduled ||
                      ((this._updateScheduled = !0),
                      setTimeout(
                        function() {
                          (this._updateScheduled = !1), this.sendEvents();
                        }.bind(this),
                        this.options.eventUploadPeriodMillis
                      )),
                    !1)
                : (this.sendEvents(t), !0))
            );
          }),
          (St.prototype._getFromStorage = function(t, e) {
            return t.getItem(e + this._storageSuffix);
          }),
          (St.prototype._setInStorage = function(t, e, n) {
            t.setItem(e + this._storageSuffix, n);
          });
        var Ot = function(t) {
            var e = t.cookieStorage.get(t.options.cookieName + t._storageSuffix);
            if (
              'object' !== k(e) &&
              !(
                'object' === k((e = t.cookieStorage.get(t.options.cookieName + t._legacyStorageSuffix))) &&
                e.deviceId &&
                e.sessionId &&
                e.lastEventTime
              )
            ) {
              var n = function(t) {
                  var e = yt.getItem(t);
                  return yt.removeItem(t), e;
                },
                i = ('string' === k(t.options.apiKey) && '_' + t.options.apiKey.slice(0, 6)) || '',
                r = n(f + i),
                o = n(N + i),
                s = n(h + i);
              null != s && (s = 'true' === String(s));
              var a = parseInt(n(d)),
                u = parseInt(n(M)),
                c = parseInt(n(l)),
                p = parseInt(n(y)),
                m = parseInt(n(g)),
                I = function(t) {
                  return 'object' === k(e) && e[t];
                };
              (t.options.deviceId = I('deviceId') || r),
                (t.options.userId = I('userId') || o),
                (t._sessionId = I('sessionId') || a || t._sessionId),
                (t._lastEventTime = I('lastEventTime') || u || t._lastEventTime),
                (t._eventId = I('eventId') || c || t._eventId),
                (t._identifyId = I('identifyId') || p || t._identifyId),
                (t._sequenceNumber = I('sequenceNumber') || m || t._sequenceNumber),
                (t.options.optOut = s || !1),
                e && void 0 !== e.optOut && null !== e.optOut && (t.options.optOut = 'true' === String(e.optOut)),
                Ut(t);
            }
          },
          Ct = function(t) {
            var e = t.cookieStorage.get(t.options.cookieName + t._storageSuffix);
            if ('object' === k(e)) kt(t, e);
            else {
              var n = t.cookieStorage.get(t.options.cookieName + t._legacyStorageSuffix);
              'object' === k(n) && (t.cookieStorage.remove(t.options.cookieName + t._legacyStorageSuffix), kt(t, n));
            }
          },
          kt = function(t, e) {
            e.deviceId && (t.options.deviceId = e.deviceId),
              e.userId && (t.options.userId = e.userId),
              null !== e.optOut && void 0 !== e.optOut && !1 !== e.optOut && (t.options.optOut = e.optOut),
              e.sessionId && (t._sessionId = parseInt(e.sessionId)),
              e.lastEventTime && (t._lastEventTime = parseInt(e.lastEventTime)),
              e.eventId && (t._eventId = parseInt(e.eventId)),
              e.identifyId && (t._identifyId = parseInt(e.identifyId)),
              e.sequenceNumber && (t._sequenceNumber = parseInt(e.sequenceNumber));
          },
          Ut = function(t) {
            var e = {
              deviceId: t.options.deviceId,
              userId: t.options.userId,
              optOut: t.options.optOut,
              sessionId: t._sessionId,
              lastEventTime: t._lastEventTime,
              eventId: t._eventId,
              identifyId: t._identifyId,
              sequenceNumber: t._sequenceNumber
            };
            t.cookieStorage.set(t.options.cookieName + t._storageSuffix, e);
          };
        (St.prototype._initUtmData = function(t, e) {
          (t = t || this._getUrlParams()), (e = e || this.cookieStorage.get('__utmz'));
          var n,
            i,
            r,
            o,
            s,
            a,
            u,
            c,
            p,
            l,
            M,
            y =
              ((i = t),
              (r = (n = e)
                ? '?' +
                  n
                    .split('.')
                    .slice(-1)[0]
                    .replace(/\|/g, '&')
                : ''),
              (s = (o = function(t, e, n, i) {
                return J(t, e) || J(n, i);
              })(A, i, 'utmcsr', r)),
              (a = o(v, i, 'utmcmd', r)),
              (u = o(_, i, 'utmccn', r)),
              (c = o(x, i, 'utmctr', r)),
              (p = o(z, i, 'utmcct', r)),
              (l = {}),
              (M = function(t, e) {
                V(e) || (l[t] = e);
              })(A, s),
              M(v, a),
              M(_, u),
              M(x, c),
              M(z, p),
              l);
          Qt(this, y);
        }),
          (St.prototype._unsetUTMParams = function() {
            var t = new dt();
            t.unset(D), t.unset(A), t.unset(v), t.unset(_), t.unset(x), t.unset(z), this.identify(t);
          });
        var Qt = function(t, e) {
          if ('object' === k(e) && 0 !== Object.keys(e).length) {
            var n = new dt();
            for (var i in e) e.hasOwnProperty(i) && (n.setOnce('initial_' + i, e[i]), n.set(i, e[i]));
            t.identify(n);
          }
        };
        (St.prototype._getReferrer = function() {
          return document.referrer;
        }),
          (St.prototype._getUrlParams = function() {
            return location.search;
          }),
          (St.prototype._saveGclid = function(t) {
            var e = J('gclid', t);
            V(e) || Qt(this, { gclid: e });
          }),
          (St.prototype._getDeviceIdFromUrlParam = function(t) {
            return J(w, t);
          }),
          (St.prototype._getReferringDomain = function(t) {
            if (V(t)) return null;
            var e = t.split('/');
            return e.length >= 3 ? e[2] : null;
          }),
          (St.prototype._saveReferrer = function(t) {
            if (!V(t)) {
              var e = { referrer: t, referring_domain: this._getReferringDomain(t) };
              Qt(this, e);
            }
          }),
          (St.prototype.saveEvents = function() {
            try {
              this._setInStorage(yt, this.options.unsentKey, JSON.stringify(this._unsentEvents));
            } catch (t) {}
            try {
              this._setInStorage(yt, this.options.unsentIdentifyKey, JSON.stringify(this._unsentIdentifys));
            } catch (t) {}
          }),
          (St.prototype.setDomain = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setDomain'].concat(Array.prototype.slice.call(arguments, 0)));
            if ($(t, 'domain', 'string'))
              try {
                this.cookieStorage.options({ expirationDays: this.options.cookieExpiration, secure: this.options.secureCookie, domain: t }),
                  (this.options.domain = this.cookieStorage.options().domain),
                  Ct(this),
                  Ut(this);
              } catch (t) {
                F.error(t);
              }
          }),
          (St.prototype.setUserId = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setUserId'].concat(Array.prototype.slice.call(arguments, 0)));
            try {
              (this.options.userId = (null != t && '' + t) || null), Ut(this);
            } catch (t) {
              F.error(t);
            }
          }),
          (St.prototype.setGroup = function(t, e) {
            if (this._shouldDeferCall()) return this._q.push(['setGroup'].concat(Array.prototype.slice.call(arguments, 0)));
            if (this._apiKeySet('setGroup()') && $(t, 'groupType', 'string') && !V(t)) {
              var n = {};
              n[t] = e;
              var i = new dt().set(t, e);
              this._logEvent(c, null, null, i.userPropertiesOperations, n, null, null, null);
            }
          }),
          (St.prototype.setOptOut = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setOptOut'].concat(Array.prototype.slice.call(arguments, 0)));
            if ($(t, 'enable', 'boolean'))
              try {
                (this.options.optOut = t), Ut(this);
              } catch (t) {
                F.error(t);
              }
          }),
          (St.prototype.setSessionId = function(t) {
            if ($(t, 'sessionId', 'number'))
              try {
                (this._sessionId = t), Ut(this);
              } catch (t) {
                F.error(t);
              }
          }),
          (St.prototype.resetSessionId = function() {
            this.setSessionId(new Date().getTime());
          }),
          (St.prototype.regenerateDeviceId = function() {
            if (this._shouldDeferCall()) return this._q.push(['regenerateDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
            this.setDeviceId(xt() + 'R');
          }),
          (St.prototype.setDeviceId = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setDeviceId'].concat(Array.prototype.slice.call(arguments, 0)));
            if ($(t, 'deviceId', 'string'))
              try {
                V(t) || ((this.options.deviceId = '' + t), Ut(this));
              } catch (t) {
                F.error(t);
              }
          }),
          (St.prototype.setUserProperties = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
            if (this._apiKeySet('setUserProperties()') && $(t, 'userProperties', 'object')) {
              var e = X(tt(t));
              if (0 !== Object.keys(e).length) {
                var n = new dt();
                for (var i in e) e.hasOwnProperty(i) && n.set(i, e[i]);
                this.identify(n);
              }
            }
          }),
          (St.prototype.clearUserProperties = function() {
            if (this._shouldDeferCall()) return this._q.push(['clearUserProperties'].concat(Array.prototype.slice.call(arguments, 0)));
            if (this._apiKeySet('clearUserProperties()')) {
              var t = new dt();
              t.clearAll(), this.identify(t);
            }
          });
        var Yt = function(t, e) {
          for (var n = 0; n < e._q.length; n++) {
            var i = t[e._q[n][0]];
            'function' === k(i) && i.apply(t, e._q[n].slice(1));
          }
          return t;
        };
        (St.prototype.identify = function(t, e) {
          if (this._shouldDeferCall()) return this._q.push(['identify'].concat(Array.prototype.slice.call(arguments, 0)));
          if (this._apiKeySet('identify()'))
            if (('object' === k(t) && t.hasOwnProperty('_q') && (t = Yt(new dt(), t)), t instanceof dt)) {
              if (Object.keys(t.userPropertiesOperations).length > 0)
                return this._logEvent(c, null, null, t.userPropertiesOperations, null, null, null, e);
              'function' === k(e) && e(0, 'No request sent', { reason: 'No user property operations' });
            } else
              F.error('Invalid identify input type. Expected Identify object but saw ' + k(t)),
                'function' === k(e) && e(0, 'No request sent', { reason: 'Invalid identify input type' });
          else 'function' === k(e) && e(0, 'No request sent', { reason: 'API key is not set' });
        }),
          (St.prototype.groupIdentify = function(t, e, n, r) {
            if (this._shouldDeferCall()) return this._q.push(['groupIdentify'].concat(Array.prototype.slice.call(arguments, 0)));
            if (this._apiKeySet('groupIdentify()'))
              if ($(t, 'group_type', 'string') && !V(t))
                if (null != e)
                  if (('object' === k(n) && n.hasOwnProperty('_q') && (n = Yt(new dt(), n)), n instanceof dt)) {
                    if (Object.keys(n.userPropertiesOperations).length > 0)
                      return this._logEvent(p, null, null, null, i({}, t, e), n.userPropertiesOperations, null, r);
                    'function' === k(r) && r(0, 'No request sent', { reason: 'No group property operations' });
                  } else
                    F.error('Invalid identify input type. Expected Identify object but saw ' + k(n)),
                      'function' === k(r) && r(0, 'No request sent', { reason: 'Invalid identify input type' });
                else 'function' === k(r) && r(0, 'No request sent', { reason: 'Invalid group name' });
              else 'function' === k(r) && r(0, 'No request sent', { reason: 'Invalid group type' });
            else 'function' === k(r) && r(0, 'No request sent', { reason: 'API key is not set' });
          }),
          (St.prototype.setVersionName = function(t) {
            if (this._shouldDeferCall()) return this._q.push(['setVersionName'].concat(Array.prototype.slice.call(arguments, 0)));
            $(t, 'versionName', 'string') && (this.options.versionName = t);
          }),
          (St.prototype._logEvent = function(t, e, n, i, o, s, a, u) {
            if ((Ct(this), t))
              if (this.options.optOut) 'function' === k(u) && u(0, 'No request sent', { reason: 'optOut is set to true' });
              else
                try {
                  var l;
                  l = t === c || t === p ? this.nextIdentifyId() : this.nextEventId();
                  var M = this.nextSequenceNumber(),
                    y = 'number' === k(a) ? a : new Date().getTime();
                  (!this._sessionId || !this._lastEventTime || y - this._lastEventTime > this.options.sessionTimeout) &&
                    (this._sessionId = y),
                    (this._lastEventTime = y),
                    Ut(this);
                  var g = this._ua.browser.name,
                    d = this._ua.browser.major,
                    f = this._ua.os.name;
                  i = i || {};
                  var h = r({}, this._apiPropertiesTrackingOptions);
                  (n = r({}, n || {}, h)), (e = e || {}), (o = o || {}), (s = s || {});
                  var N = {
                    device_id: this.options.deviceId,
                    user_id: this.options.userId,
                    timestamp: y,
                    event_id: l,
                    session_id: this._sessionId || -1,
                    event_type: t,
                    version_name: (Pt(this, 'version_name') && this.options.versionName) || null,
                    platform: Pt(this, 'platform') ? this.options.platform : null,
                    os_name: (Pt(this, 'os_name') && g) || null,
                    os_version: (Pt(this, 'os_version') && d) || null,
                    device_model: (Pt(this, 'device_model') && f) || null,
                    device_manufacturer: (Pt(this, 'device_manufacturer'), null),
                    language: Pt(this, 'language') ? this.options.language : null,
                    carrier: (Pt(this, 'carrier'), null),
                    api_properties: n,
                    event_properties: X(tt(e)),
                    user_properties: X(tt(i)),
                    uuid: xt(),
                    library: { name: 'amplitude-js', version: '5.8.0' },
                    sequence_number: M,
                    groups: X(K(o)),
                    group_properties: X(tt(s)),
                    user_agent: this._userAgent
                  };
                  return (
                    t === c || t === p
                      ? (this._unsentIdentifys.push(N), this._limitEventsQueued(this._unsentIdentifys))
                      : (this._unsentEvents.push(N), this._limitEventsQueued(this._unsentEvents)),
                    this.options.saveEvents && this.saveEvents(),
                    this._sendEventsIfReady(u) ||
                      'function' !== k(u) ||
                      u(0, 'No request sent', { reason: 'No events to send or upload queued' }),
                    l
                  );
                } catch (t) {
                  F.error(t);
                }
            else 'function' === k(u) && u(0, 'No request sent', { reason: 'Missing eventType' });
          });
        var Pt = function(t, e) {
            return !!t.options.trackingOptions[e];
          },
          Rt = function(t) {
            for (var e = ['city', 'country', 'dma', 'ip_address', 'region'], n = {}, i = 0; i < e.length; i++) {
              var r = e[i];
              Pt(t, r) || (n[r] = !1);
            }
            return n;
          };
        (St.prototype._limitEventsQueued = function(t) {
          t.length > this.options.savedMaxCount && t.splice(0, t.length - this.options.savedMaxCount);
        }),
          (St.prototype.logEvent = function(t, e, n) {
            return this._shouldDeferCall()
              ? this._q.push(['logEvent'].concat(Array.prototype.slice.call(arguments, 0)))
              : this.logEventWithTimestamp(t, e, null, n);
          }),
          (St.prototype.logEventWithTimestamp = function(t, e, n, i) {
            return this._shouldDeferCall()
              ? this._q.push(['logEventWithTimestamp'].concat(Array.prototype.slice.call(arguments, 0)))
              : this._apiKeySet('logEvent()')
              ? $(t, 'eventType', 'string')
                ? V(t)
                  ? ('function' === k(i) && i(0, 'No request sent', { reason: 'Missing eventType' }), -1)
                  : this._logEvent(t, e, null, null, null, null, n, i)
                : ('function' === k(i) && i(0, 'No request sent', { reason: 'Invalid type for eventType' }), -1)
              : ('function' === k(i) && i(0, 'No request sent', { reason: 'API key not set' }), -1);
          }),
          (St.prototype.logEventWithGroups = function(t, e, n, i) {
            return this._shouldDeferCall()
              ? this._q.push(['logEventWithGroups'].concat(Array.prototype.slice.call(arguments, 0)))
              : this._apiKeySet('logEventWithGroups()')
              ? $(t, 'eventType', 'string')
                ? this._logEvent(t, e, null, null, n, null, null, i)
                : ('function' === k(i) && i(0, 'No request sent', { reason: 'Invalid type for eventType' }), -1)
              : ('function' === k(i) && i(0, 'No request sent', { reason: 'API key not set' }), -1);
          });
        var Bt = function(t) {
          return !isNaN(parseFloat(t)) && isFinite(t);
        };
        (St.prototype.logRevenueV2 = function(t) {
          if (this._shouldDeferCall()) return this._q.push(['logRevenueV2'].concat(Array.prototype.slice.call(arguments, 0)));
          if (this._apiKeySet('logRevenueV2()'))
            if (('object' === k(t) && t.hasOwnProperty('_q') && (t = Yt(new vt(), t)), t instanceof vt)) {
              if (t && t._isValidRevenue()) return this.logEvent(I, t._toJSONObject());
            } else F.error('Invalid revenue input type. Expected Revenue object but saw ' + k(t));
        }),
          (St.prototype.logRevenue = function(t, e, n) {
            return this._shouldDeferCall()
              ? this._q.push(['logRevenue'].concat(Array.prototype.slice.call(arguments, 0)))
              : this._apiKeySet('logRevenue()') && Bt(t) && (void 0 === e || Bt(e))
              ? this._logEvent(I, {}, { productId: n, special: 'revenue_amount', quantity: e || 1, price: t }, null, null, null, null, null)
              : -1;
          }),
          (St.prototype.removeEvents = function(t, e) {
            Gt(this, '_unsentEvents', t), Gt(this, '_unsentIdentifys', e);
          });
        var Gt = function(t, e, n) {
          if (!(n < 0)) {
            for (var i = [], r = 0; r < t[e].length; r++) t[e][r].event_id > n && i.push(t[e][r]);
            t[e] = i;
          }
        };
        (St.prototype.sendEvents = function(t) {
          if (this._apiKeySet('sendEvents()'))
            if (this.options.optOut) 'function' === k(t) && t(0, 'No request sent', { reason: 'optOut is set to true' });
            else if (0 !== this._unsentCount())
              if (this._sending)
                'function' === k(t) &&
                  t(0, 'No request sent', { reason: 'Request already in progress. Events will be sent once this request is complete' });
              else {
                this._sending = !0;
                var e =
                    (this.options.forceHttps ? 'https' : 'https:' === window.location.protocol ? 'https' : 'http') +
                    '://' +
                    this.options.apiEndpoint,
                  n = Math.min(this._unsentCount(), this.options.uploadBatchSize),
                  i = this._mergeEventsAndIdentifys(n),
                  r = i.maxEventId,
                  o = i.maxIdentifyId,
                  a = JSON.stringify(i.eventsToSend),
                  u = new Date().getTime(),
                  c = { client: this.options.apiKey, e: a, v: s, upload_time: u, checksum: Nt(s + this.options.apiKey + a + u) },
                  p = this;
                new At(e, c).send(function(e, i) {
                  p._sending = !1;
                  try {
                    200 === e && 'success' === i
                      ? (p.removeEvents(r, o),
                        p.options.saveEvents && p.saveEvents(),
                        p._sendEventsIfReady(t) || 'function' !== k(t) || t(e, i))
                      : 413 === e
                      ? (1 === p.options.uploadBatchSize && p.removeEvents(r, o),
                        (p.options.uploadBatchSize = Math.ceil(n / 2)),
                        p.sendEvents(t))
                      : 'function' === k(t) && t(e, i);
                  } catch (t) {}
                });
              }
            else 'function' === k(t) && t(0, 'No request sent', { reason: 'No events to send' });
          else 'function' === k(t) && t(0, 'No request sent', { reason: 'API key not set' });
        }),
          (St.prototype._mergeEventsAndIdentifys = function(t) {
            for (var e = [], n = 0, i = -1, r = 0, o = -1; e.length < t; ) {
              var s,
                a = r >= this._unsentIdentifys.length,
                u = n >= this._unsentEvents.length;
              if (u && a) {
                F.error('Merging Events and Identifys, less events and identifys than expected');
                break;
              }
              a
                ? (i = (s = this._unsentEvents[n++]).event_id)
                : u
                ? (o = (s = this._unsentIdentifys[r++]).event_id)
                : !('sequence_number' in this._unsentEvents[n]) ||
                  this._unsentEvents[n].sequence_number < this._unsentIdentifys[r].sequence_number
                ? (i = (s = this._unsentEvents[n++]).event_id)
                : (o = (s = this._unsentIdentifys[r++]).event_id),
                e.push(s);
            }
            return { eventsToSend: e, maxEventId: i, maxIdentifyId: o };
          }),
          (St.prototype.setGlobalUserProperties = function(t) {
            this.setUserProperties(t);
          }),
          (St.prototype.__VERSION__ = '5.8.0'),
          (St.prototype._shouldDeferCall = function() {
            return this._pendingReadStorage || this._initializationDeferred;
          }),
          (St.prototype._deferInitialization = function() {
            (this._initializationDeferred = !0), this._q.push(['init'].concat(Array.prototype.slice.call(arguments, 0)));
          }),
          (St.prototype.enableTracking = function() {
            (this._initializationDeferred = !1), Ut(this), this.runQueuedFunctions();
          });
        var Zt = function() {
          (this.options = r({}, zt)), (this._q = []), (this._instances = {});
        };
        (Zt.prototype.Identify = dt),
          (Zt.prototype.Revenue = vt),
          (Zt.prototype.getInstance = function(t) {
            t = V(t) ? o : t.toLowerCase();
            var e = this._instances[t];
            return void 0 === e && ((e = new St(t)), (this._instances[t] = e)), e;
          }),
          (Zt.prototype.runQueuedFunctions = function() {
            for (var t = 0; t < this._q.length; t++) {
              var e = this[this._q[t][0]];
              'function' === k(e) && e.apply(this, this._q[t].slice(1));
            }
            for (var n in ((this._q = []), this._instances)) this._instances.hasOwnProperty(n) && this._instances[n].runQueuedFunctions();
          }),
          (Zt.prototype.init = function(t, e, n, i) {
            this.getInstance().init(
              t,
              e,
              n,
              function(t) {
                (this.options = t.options), 'function' === k(i) && i(t);
              }.bind(this)
            );
          }),
          (Zt.prototype.isNewSession = function() {
            return this.getInstance().isNewSession();
          }),
          (Zt.prototype.getSessionId = function() {
            return this.getInstance().getSessionId();
          }),
          (Zt.prototype.nextEventId = function() {
            return this.getInstance().nextEventId();
          }),
          (Zt.prototype.nextIdentifyId = function() {
            return this.getInstance().nextIdentifyId();
          }),
          (Zt.prototype.nextSequenceNumber = function() {
            return this.getInstance().nextSequenceNumber();
          }),
          (Zt.prototype.saveEvents = function() {
            this.getInstance().saveEvents();
          }),
          (Zt.prototype.setDomain = function(t) {
            this.getInstance().setDomain(t);
          }),
          (Zt.prototype.setUserId = function(t) {
            this.getInstance().setUserId(t);
          }),
          (Zt.prototype.setGroup = function(t, e) {
            this.getInstance().setGroup(t, e);
          }),
          (Zt.prototype.setOptOut = function(t) {
            this.getInstance().setOptOut(t);
          }),
          (Zt.prototype.regenerateDeviceId = function() {
            this.getInstance().regenerateDeviceId();
          }),
          (Zt.prototype.setDeviceId = function(t) {
            this.getInstance().setDeviceId(t);
          }),
          (Zt.prototype.setUserProperties = function(t) {
            this.getInstance().setUserProperties(t);
          }),
          (Zt.prototype.clearUserProperties = function() {
            this.getInstance().clearUserProperties();
          }),
          (Zt.prototype.identify = function(t, e) {
            this.getInstance().identify(t, e);
          }),
          (Zt.prototype.setVersionName = function(t) {
            this.getInstance().setVersionName(t);
          }),
          (Zt.prototype.logEvent = function(t, e, n) {
            return this.getInstance().logEvent(t, e, n);
          }),
          (Zt.prototype.logEventWithGroups = function(t, e, n, i) {
            return this.getInstance().logEventWithGroups(t, e, n, i);
          }),
          (Zt.prototype.logRevenueV2 = function(t) {
            return this.getInstance().logRevenueV2(t);
          }),
          (Zt.prototype.logRevenue = function(t, e, n) {
            return this.getInstance().logRevenue(t, e, n);
          }),
          (Zt.prototype.removeEvents = function(t, e) {
            this.getInstance().removeEvents(t, e);
          }),
          (Zt.prototype.sendEvents = function(t) {
            this.getInstance().sendEvents(t);
          }),
          (Zt.prototype.setGlobalUserProperties = function(t) {
            this.getInstance().setUserProperties(t);
          }),
          (Zt.prototype.__VERSION__ = '5.8.0');
        var Wt = window.amplitude || {},
          qt = new Zt();
        for (var Ht in ((qt._q = Wt._q || []), Wt._iq)) Wt._iq.hasOwnProperty(Ht) && (qt.getInstance(Ht)._q = Wt._iq[Ht]._q || []);
        return qt.runQueuedFunctions(), qt;
      }),
        (t.exports = i());
    }.call(this, n(5).Buffer, n(3)));
  },
  function(t, e, n) {
    var i = n(9),
      r = n(14);
    'string' == typeof (r = r.__esModule ? r.default : r) && (r = [[t.i, r, '']]);
    var o = { insert: 'head', singleton: !1 },
      s = (i(t.i, r, o), r.locals ? r.locals : {});
    t.exports = s;
  },
  ,
  function(t, e) {
    var n;
    n = (function() {
      return this;
    })();
    try {
      n = n || new Function('return this')();
    } catch (t) {
      'object' == typeof window && (n = window);
    }
    t.exports = n;
  },
  function(t, e, n) {
    'use strict';
    n.r(e),
      n.d(e, 'TabbyPromo', function() {
        return o;
      });
    var i = n(0),
      r = n.n(i);
    class o {
      constructor({ selector: t, infoButtons: e, ...n }) {
        (this.snippetContainer = t),
          (this.popupContainer = null),
          (this.popupWrapper = null),
          (this.infoButtons = e),
          (this.params = n),
          (this.params.lang = n.lang || document.documentElement.lang || 'en'),
          (this.amplitudePublicKey = 'ff949064827f33762dcae4735ce508aa'),
          this.initAmplitude(),
          (this.outSidePopupClickListener = this.outSidePopupClickListener.bind(this)),
          (this.removePopup = this.removePopup.bind(this)),
          (this.addOnEscapeListener = this.addOnEscapeListener.bind(this)),
          'loading' == document.readyState ? document.addEventListener('DOMContentLoaded', () => this.init()) : this.init(),
          (this.popupTemplates = {
            installments: {
              en:
                '\n        <span id="tabby-promo-close" class="tabby-promo__close"></span>\n        <a class="tabby-promo__logo" href="https://tabby.ai" target="_blank"\n          ><img\n            class="tabby-promo__logo-img"\n            src="data:image/svg+xml;base64,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"\n            alt="Tabby logo"\n            width="62"\n            height="20"\n        /></a>\n        <h3 class="tabby-promo__title">\n          Split into 4 equal monthly payments\n        </h3>\n        <ul class="tabby-promo__features">\n          <li class="tabby-promo__feature tabby-promo__feature--no-interest">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title">No fees</b>\n              <p class="tabby-promo__feature-desc">\n                Zero interest and no hidden fees.\n              </p>\n            </div>\n          </li>\n  \n          <li class="tabby-promo__feature tabby-promo__feature--credit-card">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title"\n                >No credit card? No problem!\n              </b>\n              <p class="tabby-promo__feature-desc">\n                Use any debit card to repay.\n              </p>\n            </div>\n          </li>\n  \n          <li class="tabby-promo__feature tabby-promo__feature--quick-easy">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title">Quick and easy</b>\n              <p class="tabby-promo__feature-desc">\n                Simply verify your details and complete your checkout.\n              </p>\n            </div>\n          </li>\n        </ul>\n        <p class="tabby-promo__final-text">\n          Sounds good? Just select Tabby at checkout.\n        </p>\n      ',
              ar:
                '\n        <span id="tabby-promo-close" class="tabby-promo__close"></span>\n        <a class="tabby-promo__logo" href="https://tabby.ai/ar.html" target="_blank"\n          ><img\n            class="tabby-promo__logo-img"\n            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iNjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzFDMUQxQiI+PHBhdGggZD0iTTguODggMTUuMjhjLjkyLjc2IDEuNTQgMS44NCAxLjc0IDNINy4xNGwxLjc0LTNtLS4xLS41NGwtMi4yNiAzLjloNC41MmMtLjE2LTEuNi0xLjAyLTMtMi4yNi0zLjl6bS01LjQgOS4zNGMuNjguMzIgMS40NC41IDIuMjYuNS44IDAgMS41Ni0uMTggMi4yNi0uNWwtMi4yNi0zLjktMi4yNiAzLjl6bTMuMTQtNC40bDIuMjYgMy45YTUuNDcgNS40NyAwIDAwMi4yNi0zLjlINi41MnptMS4zOC01LjQ0Yy0uNjgtLjMyLTEuNDQtLjUtMi4yNi0uNS0uOCAwLTEuNTYuMTgtMi4yNi41bDIuMjYgMy45IDIuMjYtMy45em0tMy4yMiA1LjM4SC4xNmMuMTYgMS42MiAxIDMuMDIgMi4yNiAzLjlsMi4yNi0zLjl6bTAtMS4wMmwtMi4yNi0zLjlhNS40NyA1LjQ3IDAgMDAtMi4yNiAzLjloNC41MnpNOTAuNiA5LjAycy03Ljc2LjMyLTcuNzYgOC4zOGMwIDQuMjQtLjA0IDkuODYtLjA0IDkuODYgMCA0LjU2LTIuOTggMTAuMi05LjI2IDEwLjItNi4yOCAwLTkuMjYtNS4xLTkuMjYtMTAuMlY1LjQ4TDU3Ljk0IDhsLS4wNCAyMC4wMmMwIDcuNTIgNi4yMiAxMy45IDE1LjY0IDEzLjkgOS40MiAwIDE1LjY0LTYuMzggMTUuNjQtMTMuOVYxOC44YzAtNS40NiAyLjIyLTYuMiAyLjIyLTYuMmwtLjgtMy41OHpNNDguNTQgMTkuMTh2OC4wNGMwIDUuODQtMy41IDcuMy02LjYgNy4zLTEuNTQgMC0zLjU0LS40NC0zLjU0LS40NGwtLjk0IDMuNnMxLjkyIDEuMTIgNi4yNCAxLjEyYzQuMzYgMCAxMS4xOC0xLjkgMTEuMTgtMTAuNjZWMTYuNjZsLTYuMzQgMi41MnptNC41IDIwLjU2bC0yLjM2IDMuNTggMi4zNiAzLjYgMi4zOC0zLjZ6TTI2LjIgNTMuODZsLTIuMzYgMy42IDIuMzYgMy41OCAyLjM4LTMuNTh6bTYuOTQgMGwtMi4zNiAzLjYgMi4zNiAzLjU4IDIuMzYtMy41OHoiLz48cGF0aCBkPSJNNzYuMDIgMGwtMi4zOCAzLjYgMi4zOCAzLjU4IDIuMzYtMy41OHptNi45MiAwbC0yLjM2IDMuNiAyLjM2IDMuNTggMi4zOC0zLjU4ek0zOS43MiAzNi4xNGMwIDYuMDQtMy41MiAxMC4zNi0xMC4wNCAxMC4zNnMtMTAuMDQtNC4zMi0xMC4wNC0xMC4zNmwtLjA0LTYuNDYtNi4zNCAyLjUydjMuMzRjMCAxMC45MiA4LjEgMTUuMTYgMTYuNDIgMTUuMTYgOC4zMiAwIDE2LjQyLTQuMjQgMTYuNDItMTUuMTZsLTYuMzguNnoiLz48L2c+PC9zdmc+"\n            alt="Tabby logo"\n            width="62"\n            height="40"\n        /></a>\n        <h3 class="tabby-promo__title">\n         مقسمة على 4 دفعات شهرية متساوية\n        </h3>\n        <ul class="tabby-promo__features">\n          <li class="tabby-promo__feature tabby-promo__feature--no-interest">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title">بدون أي رسوم</b>\n              <p class="tabby-promo__feature-desc">\n               بدون أي فوائد أو رسوم إضافية              \n              </p>\n            </div>\n          </li>\n\n          <li class="tabby-promo__feature tabby-promo__feature--credit-card">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title">\n               ليس عندك بطاقة ائتمان؟ الحل بسيط \n              </b>\n              <p class="tabby-promo__feature-desc">\n                استخدم أي بطاقة بنكية للسداد              \n              </p>\n            </div>\n          </li>\n\n          <li class="tabby-promo__feature tabby-promo__feature--quick-easy">\n            <i class="tabby-promo__feature-icon"></i>\n            <div class="tabby-promo__feature-info">\n              <b class="tabby-promo__feature-title">سريع وسهل\n              </b>\n              <p class="tabby-promo__feature-desc">\n              ببساطة تحقق من التفاصيل الخاصة بك وأكمل الشراء</p>\n            </div>\n          </li>\n        </ul>\n        <p class="tabby-promo__final-text">\n        كل ما عليك هو اختيار تابي عند صفحة الدفع \n        </p>\n      '
            },
            payLater: {
              en:
                '\n        <button id="tabby-promo-close" class="tabby-promo__close"></button>\n        <a class="tabby-promo__logo" href="https://tabby.ai" target="_blank"\n          ><img\n            class="tabby-promo__logo-img"\n            src="data:image/svg+xml;base64,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"\n            alt="Tabby logo"\n            width="62"\n            height="20"\n        /></a>\n        <h3 class="tabby-promo__title">\n          Buy now and pay after delivery\n        </h3>\n        <div class="tabby-promo__features-wrapper">\n          <ol class="tabby-promo__instruction">\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">1</div>\n              <p class="tabby-promo__instruction-text">\n                Select Pay after delivery and complete your order\n              </p>\n            </li>\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">2</div>\n              <p class="tabby-promo__instruction-text">\n                Receive your package and enjoy it\n              </p>\n            </li>\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">3</div>\n              <p class="tabby-promo__instruction-text">\n                Pay 14 days later using your debit or credit card by logging\n                into your Tabby account\n              </p>\n            </li>\n          </ol>\n          <ul class="tabby-promo__features">\n            <li class="tabby-promo__feature tabby-promo__feature--credit-card">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">Get 14 days to pay</b>\n                <p class="tabby-promo__feature-desc">\n                  Why pay cash on delivery when you can pay 14 days after\n                  delivery?\n                </p>\n              </div>\n            </li>\n\n            <li class="tabby-promo__feature tabby-promo__feature--no-interest">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">No fees</b>\n                <p class="tabby-promo__feature-desc">\n                  Zero interest and no hidden fees.\n                </p>\n              </div>\n            </li>\n\n            <li class="tabby-promo__feature tabby-promo__feature--quick-easy">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">Quick and easy</b>\n                <p class="tabby-promo__feature-desc">\n                  Simply verify your details and complete your checkout.\n                </p>\n              </div>\n            </li>\n          </ul>\n        </div>\n\n        <p class="tabby-promo__final-text">\n          Sounds good? Select Pay after delivery at checkout.\n        </p>\n        ',
              ar:
                '\n        <button id="tabby-promo-close" class="tabby-promo__close"></button>\n        <a class="tabby-promo__logo" href="https://tabby.ai/ar.html" target="_blank"\n          ><img\n            class="tabby-promo__logo-img"\n            src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTIiIGhlaWdodD0iNjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzFDMUQxQiI+PHBhdGggZD0iTTguODggMTUuMjhjLjkyLjc2IDEuNTQgMS44NCAxLjc0IDNINy4xNGwxLjc0LTNtLS4xLS41NGwtMi4yNiAzLjloNC41MmMtLjE2LTEuNi0xLjAyLTMtMi4yNi0zLjl6bS01LjQgOS4zNGMuNjguMzIgMS40NC41IDIuMjYuNS44IDAgMS41Ni0uMTggMi4yNi0uNWwtMi4yNi0zLjktMi4yNiAzLjl6bTMuMTQtNC40bDIuMjYgMy45YTUuNDcgNS40NyAwIDAwMi4yNi0zLjlINi41MnptMS4zOC01LjQ0Yy0uNjgtLjMyLTEuNDQtLjUtMi4yNi0uNS0uOCAwLTEuNTYuMTgtMi4yNi41bDIuMjYgMy45IDIuMjYtMy45em0tMy4yMiA1LjM4SC4xNmMuMTYgMS42MiAxIDMuMDIgMi4yNiAzLjlsMi4yNi0zLjl6bTAtMS4wMmwtMi4yNi0zLjlhNS40NyA1LjQ3IDAgMDAtMi4yNiAzLjloNC41MnpNOTAuNiA5LjAycy03Ljc2LjMyLTcuNzYgOC4zOGMwIDQuMjQtLjA0IDkuODYtLjA0IDkuODYgMCA0LjU2LTIuOTggMTAuMi05LjI2IDEwLjItNi4yOCAwLTkuMjYtNS4xLTkuMjYtMTAuMlY1LjQ4TDU3Ljk0IDhsLS4wNCAyMC4wMmMwIDcuNTIgNi4yMiAxMy45IDE1LjY0IDEzLjkgOS40MiAwIDE1LjY0LTYuMzggMTUuNjQtMTMuOVYxOC44YzAtNS40NiAyLjIyLTYuMiAyLjIyLTYuMmwtLjgtMy41OHpNNDguNTQgMTkuMTh2OC4wNGMwIDUuODQtMy41IDcuMy02LjYgNy4zLTEuNTQgMC0zLjU0LS40NC0zLjU0LS40NGwtLjk0IDMuNnMxLjkyIDEuMTIgNi4yNCAxLjEyYzQuMzYgMCAxMS4xOC0xLjkgMTEuMTgtMTAuNjZWMTYuNjZsLTYuMzQgMi41MnptNC41IDIwLjU2bC0yLjM2IDMuNTggMi4zNiAzLjYgMi4zOC0zLjZ6TTI2LjIgNTMuODZsLTIuMzYgMy42IDIuMzYgMy41OCAyLjM4LTMuNTh6bTYuOTQgMGwtMi4zNiAzLjYgMi4zNiAzLjU4IDIuMzYtMy41OHoiLz48cGF0aCBkPSJNNzYuMDIgMGwtMi4zOCAzLjYgMi4zOCAzLjU4IDIuMzYtMy41OHptNi45MiAwbC0yLjM2IDMuNiAyLjM2IDMuNTggMi4zOC0zLjU4ek0zOS43MiAzNi4xNGMwIDYuMDQtMy41MiAxMC4zNi0xMC4wNCAxMC4zNnMtMTAuMDQtNC4zMi0xMC4wNC0xMC4zNmwtLjA0LTYuNDYtNi4zNCAyLjUydjMuMzRjMCAxMC45MiA4LjEgMTUuMTYgMTYuNDIgMTUuMTYgOC4zMiAwIDE2LjQyLTQuMjQgMTYuNDItMTUuMTZsLTYuMzguNnoiLz48L2c+PC9zdmc+"\n            alt="Tabby logo"\n            width="62"\n            height="40"\n        /></a>\n        <h3 class="tabby-promo__title">\n          تسوق الان وادفع لاحقًا بعد الاستلام\n        </h3>\n        <div class="tabby-promo__features-wrapper">\n          <ol class="tabby-promo__instruction">\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">1</div>\n              <p class="tabby-promo__instruction-text">\n                إختر الدفع بعد الإستلام عند إتمام عملية الشراء\n              </p>\n            </li>\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">2</div>\n              <p class="tabby-promo__instruction-text">\n                إستلم طلبيتك وإستمتع بها\n              </p>\n            </li>\n            <li class="tabby-promo__instruction-item">\n              <div class="tabby-promo__instruction-number">3</div>\n              <p class="tabby-promo__instruction-text">\n                أكمل الدفع بعد ١٤ يوم من الإستلام باستخدام بطاقة الائتمان أو\n                السحب الآلي عبر موقع تابي\n              </p>\n            </li>\n          </ol>\n          <ul class="tabby-promo__features">\n            <li class="tabby-promo__feature tabby-promo__feature--credit-card">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">إحصل على ١٤ يوم للدفع</b>\n                <p class="tabby-promo__feature-desc">\n                  لماذا تدفع عند الاستلام عندما يمكنك أن تدفع ١٤ يوم بعد\n                  الاستلام؟\n                </p>\n              </div>\n            </li>\n\n            <li class="tabby-promo__feature tabby-promo__feature--no-interest">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">\n                  بدون فوائد\n                </b>\n                <p class="tabby-promo__feature-desc">\n                 بدون أي فوائد أو رسوم إضافية                \n                </p>\n              </div>\n            </li>\n\n            <li class="tabby-promo__feature tabby-promo__feature--quick-easy">\n              <i class="tabby-promo__feature-icon"></i>\n              <div class="tabby-promo__feature-info">\n                <b class="tabby-promo__feature-title">سريع وسهل</b>\n                <p class="tabby-promo__feature-desc">\n                 ببساطة تحقق من التفاصيل الخاصة بك وأكمل الشراء  \n                </p>\n              </div>\n            </li>\n          </ul>\n        </div>\n\n        <p class="tabby-promo__final-text">\n          ما رأيك؟ كل ما عليك هو تحديد الدفع ١٤ يوم بعد الاستلام عند صفحة الدفع\n        </p>\n        '
            }
          });
      }
      init() {
        this.injectStyles(),
          this.addDataAttributesListeners(),
          this.snippetContainer && this.appendPromoSnippet(this.snippetContainer),
          this.addSnippetClickListener(['.tabby-promo-popup-trigger', '.tabby-promo-snippet']);
      }
      injectStyles() {
        const t = document.createElement('style');
        (t.innerHTML =
          '\n    .tabby-promo-wrapper {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      z-index: 9999999999 !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-wrap: wrap;\n      width: 100%;\n      height: 100%;\n      padding: 16px;\n      box-sizing: border-box;\n      background: rgba(0, 0, 0, 0.5);\n    }\n\n    .tabby-promo-popup-trigger {\n      cursor: pointer;\n    }\n    \n    .tabby-promo {\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      width: 450px;\n      min-height: 470px;\n      margin: auto;\n      padding: 40px 64px 30px;\n      box-sizing: border-box;\n      background: #ffffff;\n      border-radius: 17px;\n      font-family: "Arial", "Roboto", "Helvetica", "Verdana", sans-serif;\n      color: #292929;\n      animation: scale 0.75s;\n    }\n    \n    .tabby-promo--pay-later {\n      width: 710px;\n      padding-left: 30px;\n      padding-right: 30px;\n    }\n    \n    .tabby-promo--pay-later .tabby-promo__features {\n      width: 50%;\n      padding-left: 15px;\n    }\n    \n    .tabby-promo--pay-later.tabby-promo--rtl .tabby-promo__features {\n      padding-left: 0;\n      padding-right: 15px;\n    }\n    \n    .tabby-promo__features-wrapper {\n      display: flex;\n    }\n    \n    .tabby-promo__instruction {\n      position: relative;\n      width: 50%;\n      margin: 0;\n      padding: 0;\n      padding-right: 15px;\n      list-style-type: none;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__instruction {\n      padding-right: 0;\n      padding-left: 15px;\n    }\n    \n    .tabby-promo__instruction::before {\n      content: "";\n      position: absolute;\n      top: 0;\n      right: 0;\n      width: 2px;\n      height: 100%;\n      background: #f4f4f4;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__instruction::before {\n      right: auto;\n      left: 0;\n    }\n    \n    .tabby-promo__instruction-number {\n      position: relative;\n      z-index: 1;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-shrink: 0;\n      width: 56px;\n      height: 56px;\n      margin-right: 24px;\n      border: 2px solid #3eedbf;\n      border-radius: 50%;\n      font-size: 16px;\n      line-height: 22px;\n      background: #fff;\n      color: #000000;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__instruction-number {\n      margin-right: 0;\n      margin-left: 24px;\n    }\n    \n    .tabby-promo__instruction-item {\n      position: relative;\n      display: flex;\n      align-items: center;\n      padding: 12px 0;\n      margin: 0 !important;\n    }\n    \n    .tabby-promo__instruction-item::before {\n      content: "";\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 27px;\n      width: 2px;\n      height: 100%;\n      background: #3eedbf;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__instruction-item::before {\n      left: auto;\n      right: 27px;\n    }\n    \n    .tabby-promo__instruction-item:first-child::before {\n      top: auto;\n      height: 50%;\n      bottom: 0;\n    }\n    \n    .tabby-promo__instruction-item:last-child::before {\n      top: 0;\n      height: 50%;\n      bottom: auto;\n    }\n    \n    .tabby-promo__instruction-item:first-child {\n      padding-top: 0;\n    }\n    \n    .tabby-promo__instruction-item:last-child {\n      padding-bottom: 0;\n    }\n    \n    .tabby-promo__instruction-text {\n      margin: 0;\n      font-size: 14px;\n      line-height: 19px;\n      letter-spacing: 0.39px;\n      color: #000000;\n    }\n    \n    .tabby-promo.dissapearing {\n      animation: dissapearing 0.7s;\n      animation-fill-mode: forwards;\n    }\n    \n    .tabby-promo *,\n    .tabby-promo *:before,\n    .tabby-promo *:after {\n      box-sizing: inherit;\n      text-transform: initial;\n      font-weight: normal;\n    }\n    \n    .tabby-promo__logo {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 62px;\n      height: 20px;\n      margin-bottom: 25px;\n    }\n    \n    .tabby-promo__logo-img {\n      max-height: initial;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__logo {\n      height: 40px;\n    }\n    \n    .tabby-promo__feature {\n      display: flex;\n      align-items: center;\n      margin-bottom: 30px;\n    }\n    \n    .tabby-promo__features {\n      margin: 0;\n      padding: 0;\n      list-style: none;\n    }\n    \n    .tabby-promo__feature:last-child {\n      margin-bottom: 0;\n    }\n    \n    .tabby-promo__feature-icon {\n      width: 56px;\n      height: 56px;\n      flex-shrink: 0;\n      margin-right: 24px;\n      background-color: rgba(62, 237, 191, 0.15);\n      background-position: center center;\n      background-repeat: no-repeat;\n      border-radius: 21px;\n    }\n    \n    .tabby-promo__feature--no-interest .tabby-promo__feature-icon {\n      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM1LjUxIDE5LjUxOGMtLjIyNS0uNzItLjQzOC0xLjQtLjQzOC0yLjAxOCAwLS42MTcuMjEzLTEuMjk4LjQzOS0yLjAxOC4zNDktMS4xMTYuNzEtMi4yNy4zMi0zLjM5MS0uNDA2LTEuMTY4LTEuNDUtMS45MTUtMi40NTgtMi42MzctLjYxNi0uNDQyLTEuMTk4LS44NTgtMS41Ni0xLjMyMy0uMzctLjQ3NS0uNjItMS4xMjctLjg4My0xLjgxNy0uNDI0LTEuMTExLS44NjItMi4yNi0xLjkxLTIuOTczLTEuMDM5LS43MDUtMi4zMzgtLjc0LTMuNTk1LS43NzYtLjc5MS0uMDIyLTEuNTM4LS4wNDMtMi4xNDctLjIyOC0uNTctLjE3Mi0xLjE2NS0uNTU1LTEuNzk0LS45NkMyMC40NzguNzMzIDE5LjM0IDAgMTggMGMtMS4zNCAwLTIuNDguNzMyLTMuNDg0IDEuMzc4LS42My40MDUtMS4yMjQuNzg3LTEuNzkzLjk2LS42MS4xODQtMS4zNTcuMjA1LTIuMTQ4LjIyNy0xLjI1Ni4wMzUtMi41NTYuMDcxLTMuNTk0Ljc3Ny0xLjA1LjcxMi0xLjQ4NyAxLjg2LTEuOTExIDIuOTcxLS4yNjQuNjktLjUxMyAxLjM0My0uODgzIDEuODE4LS4zNjMuNDY1LS45NDQuODgxLTEuNTYgMS4zMjMtMS4wMS43MjItMi4wNTIgMS40NjktMi40NTggMi42MzctLjM5IDEuMTItLjAyOSAyLjI3NS4zMiAzLjM5MS4yMjYuNzIuNDM5IDEuNC40MzkgMi4wMTggMCAuNjE4LS4yMTMgMS4yOTgtLjQzOCAyLjAxOC0uMzUgMS4xMTYtLjcxIDIuMjctLjMyMSAzLjM5LjQwNiAxLjE2OSAxLjQ1IDEuOTE2IDIuNDU4IDIuNjM5LjYxNi40NCAxLjE5OC44NTcgMS41NiAxLjMyMi4zNy40NzUuNjIgMS4xMjcuODgzIDEuODE3LjQyNCAxLjExMS44NjIgMi4yNiAxLjkxMSAyLjk3MyAxLjAzOC43MDUgMi4zMzguNzQgMy41OTQuNzc2Ljc5MS4wMjIgMS41MzguMDQzIDIuMTQ4LjIyOC41Ny4xNzIgMS4xNjQuNTU1IDEuNzk0Ljk2QzE1LjUyIDM0LjI2NyAxNi42NiAzNSAxOCAzNWMxLjM0IDAgMi40NzktLjczMiAzLjQ4My0xLjM3OC42My0uNDA1IDEuMjI0LS43ODcgMS43OTMtLjk2LjYxLS4xODQgMS4zNTctLjIwNSAyLjE0OC0uMjI3IDEuMjU3LS4wMzUgMi41NTYtLjA3MSAzLjU5NS0uNzc3IDEuMDQ5LS43MTIgMS40ODctMS44NiAxLjkxLTIuOTcxLjI2NS0uNjkuNTEzLTEuMzQzLjg4NC0xLjgxOC4zNjItLjQ2NS45NDQtLjg4MSAxLjU2LTEuMzIzIDEuMDA5LS43MjIgMi4wNTItMS40NjkgMi40NTgtMi42MzcuMzktMS4xMi4wMjgtMi4yNzUtLjMyLTMuMzkxem0tMS41MzEuNDE4Yy4yOTQuOTQxLjU3MyAxLjgzLjMzNSAyLjUxMy0uMjUzLjcyOC0xLjA1OSAxLjMwNS0xLjkxMiAxLjkxNi0uNjc5LjQ4Ni0xLjM4Ljk4OC0xLjg4IDEuNjI4LS41MDUuNjQ5LS44MDUgMS40MzQtMS4wOTUgMi4xOTQtLjM1OC45MzktLjY5NiAxLjgyNS0xLjM0NyAyLjI2Ny0uNjQuNDM1LTEuNjQyLjQ2My0yLjcwMy40OTMtLjg2OC4wMjQtMS43NjYuMDQ5LTIuNTkzLjMtLjc5LjI0LTEuNTEuNzAxLTIuMjA2IDEuMTQ5LS44OTEuNTc0LTEuNzM0IDEuMTE1LTIuNTc4IDEuMTE1LS44NDQgMC0xLjY4Ni0uNTQxLTIuNTc5LTEuMTE1LS42OTUtLjQ0Ny0xLjQxNS0uOTEtMi4yMDUtMS4xNS0uODI3LS4yNS0xLjcyNS0uMjc1LTIuNTkzLS4zLTEuMDYyLS4wMjktMi4wNjQtLjA1Ny0yLjcwNC0uNDkxLS42NS0uNDQyLS45ODgtMS4zMy0xLjM0Ny0yLjI2OC0uMjktLjc2LS41OS0xLjU0NS0xLjA5NS0yLjE5NC0uNDk5LS42NC0xLjItMS4xNDItMS44OC0xLjYyOC0uODUzLS42MS0xLjY1OC0xLjE4OC0xLjkxMS0xLjkxNi0uMjM4LS42ODMuMDQtMS41NzIuMzM0LTIuNTEzLjI0Ny0uNzkuNTAzLTEuNjA1LjUwMy0yLjQzNiAwLS44My0uMjU2LTEuNjQ3LS41MDMtMi40MzYtLjI5NC0uOTQxLS41NzItMS44My0uMzM0LTIuNTEzLjI1My0uNzI4IDEuMDU4LTEuMzA1IDEuOTExLTEuOTE2LjY3OS0uNDg2IDEuMzgxLS45ODggMS44OC0xLjYyOC41MDUtLjY0OS44MDUtMS40MzQgMS4wOTUtMi4xOTQuMzU4LS45MzkuNjk2LTEuODI1IDEuMzQ3LTIuMjY3LjY0LS40MzUgMS42NDItLjQ2MyAyLjcwNC0uNDkzLjg2OC0uMDI0IDEuNzY2LS4wNDkgMi41OTItLjMuNzktLjI0IDEuNTEtLjcwMSAyLjIwNi0xLjE0OS44OTItLjU3MyAxLjczNS0xLjExNSAyLjU3OS0xLjExNS44NDQgMCAxLjY4Ni41NDIgMi41NzggMS4xMTYuNjk2LjQ0NyAxLjQxNS45MDkgMi4yMDYgMS4xNS44MjcuMjUgMS43MjUuMjc1IDIuNTkzLjMgMS4wNi4wMjkgMi4wNjQuMDU3IDIuNzAzLjQ5MS42NS40NDIuOTg5IDEuMzI5IDEuMzQ3IDIuMjY4LjI5Ljc2LjU5IDEuNTQ1IDEuMDk2IDIuMTk0LjQ5OC42NCAxLjIgMS4xNDIgMS44NzkgMS42MjguODUzLjYxIDEuNjU5IDEuMTg3IDEuOTEyIDEuOTE2LjIzNy42ODMtLjA0IDEuNTcxLS4zMzUgMi41MTItLjI0Ny43OS0uNTAyIDEuNjA2LS41MDIgMi40MzcgMCAuODMuMjU1IDEuNjQ2LjUwMiAyLjQzNXoiIGZpbGw9IiM2NUFFOUEiIGZpbGwtb3BhY2l0eT0iLjkiLz48cGF0aCBkPSJNMTguMTU1IDEzLjQxN2MwLTIuMzMtMi4wMzEtNC4yMjgtNC41MjgtNC4yMjgtMi40OTcgMC00LjUyOCAxLjg5Ny00LjUyOCA0LjIyOCAwIDIuMzMxIDIuMDMxIDQuMjI4IDQuNTI4IDQuMjI4IDIuNDk3IDAgNC41MjgtMS44OTcgNC41MjgtNC4yMjh6bS03LjQ2MSAwYzAtMS41MSAxLjMxNi0yLjczOSAyLjkzMy0yLjczOSAxLjYxOCAwIDIuOTM0IDEuMjI5IDIuOTM0IDIuNzQgMCAxLjUxLTEuMzE2IDIuNzM4LTIuOTM0IDIuNzM4LTEuNjE3IDAtMi45MzMtMS4yMjktMi45MzMtMi43Mzl6TTIyLjM3MiAxNy4zNTRjLTIuNDk3IDAtNC41MjggMS44OTctNC41MjggNC4yMjggMCAyLjMzMSAyLjAzMiA0LjIyOCA0LjUyOCA0LjIyOCAyLjQ5NyAwIDQuNTI5LTEuODk3IDQuNTI5LTQuMjI4IDAtMi4zMzEtMi4wMzItNC4yMjgtNC41MjktNC4yMjh6bTAgNi45NjdjLTEuNjE3IDAtMi45MzMtMS4yMjgtMi45MzMtMi43MzkgMC0xLjUxIDEuMzE2LTIuNzM4IDIuOTMzLTIuNzM4IDEuNjE4IDAgMi45MzQgMS4yMjggMi45MzQgMi43MzhzLTEuMzE2IDIuNzM5LTIuOTM0IDIuNzM5ek0yNS4wMjYgMTAuOTRhLjgzOC44MzggMCAwMC0xLjEyOCAwTDEwLjk3MiAyMy4wMDhhLjcxLjcxIDAgMDAwIDEuMDUzYy4xNTYuMTQ1LjM2LjIxOC41NjQuMjE4YS44MjUuODI1IDAgMDAuNTY0LS4yMThsMTIuOTI2LTEyLjA2OGEuNzEuNzEgMCAwMDAtMS4wNTN6IiBmaWxsPSIjNjVBRTlBIiBmaWxsLW9wYWNpdHk9Ii45Ii8+PC9zdmc+");\n      background-size: 36px 35px;\n    }\n    \n    .tabby-promo__feature--credit-card .tabby-promo__feature-icon {\n      background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMSIgZmlsbD0ibm9uZSI+PHBhdGggZD0iTTEyLjMxMyAyMC41NjNjLjE5OC4xNjQuNDMuMjMuNjYuMjMuMjY0IDAgLjUyOC0uMDk5LjcyNi0uMjk2bDguNjc3LTguNzUzYTEuMDMxIDEuMDMxIDAgMDAwLTEuNDQ4IDEuMDM4IDEuMDM4IDAgMDAtMS40NTIgMGwtOC4wMTcgOC4wOTUtMy40My0yLjg5NmExLjA0MiAxLjA0MiAwIDAwLTEuNDUyLjEzMiAxLjAzNiAxLjAzNiAwIDAwLjEzMiAxLjQ0OGw0LjE1NiAzLjQ4OHoiIGZpbGw9IiM2NUFFOUEiIGZpbGwtb3BhY2l0eT0iLjgiLz48cGF0aCBkPSJNMjguODQ2IDE1LjVjMCA3LjYyMy02LjE5NyAxMy44MDgtMTMuODQ2IDEzLjgwOC03LjY1IDAtMTMuODQ2LTYuMTg1LTEzLjg0Ni0xMy44MDhTNy4zNSAxLjY5MiAxNSAxLjY5MmM3LjY1IDAgMTMuODQ2IDYuMTg1IDEzLjg0NiAxMy44MDh6IiBzdHJva2U9IiM2NUFFOUEiIHN0cm9rZS1vcGFjaXR5PSIuOCIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+");\n      background-size: 30px 30px;\n    }\n    \n    .tabby-promo__feature--quick-easy .tabby-promo__feature-icon {\n      background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMzAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0IDBDNi4yODQgMCAwIDYuMjg0IDAgMTRzNi4yODQgMTQgMTQgMTQgMTQtNi4yODQgMTQtMTRTMjEuNzE2IDAgMTQgMHptMCAxLjg5N2M2LjY3OCAwIDEyLjEwMiA1LjQyNyAxMi4xMDIgMTIuMTA1IDAgNi42NzctNS40MjQgMTIuMTAyLTEyLjEwMiAxMi4xMDJTMS44OTggMjAuNjc5IDEuODk4IDE0LjAwMkMxLjg5OCA3LjMyNCA3LjMyMiAxLjg5NyAxNCAxLjg5N3ptLS40ODIgNC42OTdhLjk1NS45NTUgMCAwMC0uOTQ4Ljk0N3Y2Ljk0NGEuOTUuOTUgMCAwMC4yNzcuNjdsNC43NTIgNC43NWEuOTU0Ljk1NCAwIDAwLjY3LjI3OC45NTUuOTU1IDAgMDAuNjY1LS4yNzVsLjAwMy0uMDAyYS45NTIuOTUyIDAgMDAwLTEuMzM5di0uMDAybC00LjQ3Mi00LjQ3NHYtNi41NWEuOTU1Ljk1NSAwIDAwLS45NDctLjk0OHptMTAuNzY4IDE3LjU4OWEuOTQ0Ljk0NCAwIDAwLS43MDEuMTc1bC0uMDAyLjAwMmMtLjQxMi4zMS0uNTAxLjkxLS4xOSAxLjMyNXYuMDAybDIuOTAxIDMuODY3LjAwMi4wMDNjLjE4My4yNC40NjYuMzc4Ljc1Ni4zNzguMTk5IDAgLjQtLjA2My41Ny0uMTkzbC4wMDItLjAwMmEuOTU1Ljk1NSAwIDAwLjE4Ni0xLjMyM3YtLjAwMS0uMDAxbC0yLjktMy44NjVhLjk0Ni45NDYgMCAwMC0uNjI0LS4zNjd6bS0yMC41NzIuMDAyYS45NDMuOTQzIDAgMDAtLjYyNC4zNjVsLTIuOSAzLjg2NnYuMDAyYS45NTMuOTUzIDAgMDAuMTkgMS4zMjZ2LjAwMmEuOTUuOTUgMCAwMDEuMzI1LS4xOWwyLjkwMi0zLjg2N3YtLjAwMmEuOTUyLjk1MiAwIDAwLS4xOTItMS4zMjUuOTQ3Ljk0NyAwIDAwLS43MDEtLjE3N3oiIGZpbGw9IiM3RUJFQUMiLz48L3N2Zz4=");\n      background-size: 28px 30px;\n    }\n    \n    .tabby-promo__title {\n      margin: 0;\n      margin-bottom: 20px;\n      font-weight: normal;\n      font-size: 18px;\n      line-height: 24px;\n      text-align: center;\n    }\n    \n    .tabby-promo__feature-desc {\n      margin: 0;\n      color: #949494;\n      font-size: 12px;\n      line-height: 16px;\n    }\n    \n    .tabby-promo__feature-title {\n      font-size: 16px;\n      line-height: 22px;\n      font-weight: normal;\n      color: #000000;\n    }\n\n    .tabby-promo--rtl .tabby-promo__feature-title {\n      font-size: 18px;\n    }\n\n    .tabby-promo--rtl .tabby-promo__feature-desc {\n      font-size: 16px;\n    }\n    \n    .tabby-promo--pay-later .tabby-promo__final-text {\n      padding-top: 40px;\n    }\n    \n    .tabby-promo__amount {\n      color: #292929;\n    }\n    \n    .tabby-promo__final-text {\n      margin: 0;\n      margin-top: auto;\n      padding-top: 15px;\n      font-size: 16px;\n      line-height: 22px;\n      text-align: center;\n    }\n\n    .tabby-promo--rtl .tabby-promo__final-text {\n      font-size: 18px;\n    }\n    \n    .tabby-promo__close {\n      position: absolute;\n      right: 18px;\n      top: 18px;\n      width: 15px;\n      height: 16px;\n      padding: 0;\n      background: transparent !important;\n      transition: transform 0.3s;\n      border: none !important;\n      cursor: pointer;\n      outline: none;\n    }\n    \n    .tabby-promo__close:hover {\n      transform: scale(1.3);\n    }\n    \n    .tabby-promo__close:before,\n    .tabby-promo__close:after {\n      position: absolute;\n      top: 0;\n      left: 6px;\n      content: "";\n      height: 17px;\n      width: 2px;\n      background-color: #3e3e3e;\n      border-radius: 2px;\n    }\n    \n    .tabby-promo__close:before {\n      transform: rotate(45deg);\n    }\n    \n    .tabby-promo__close:after {\n      transform: rotate(-45deg);\n    }\n    \n    .tabby-promo-snippet {\n      direction: ltr;\n      display: flex;\n      align-items: flex-start;\n      width: 100%;\n      max-width: 335px;\n      padding: 18px 15px;\n      box-sizing: border-box;\n      background: #ffffff;\n      box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.1);\n      border-radius: 7px;\n      color: #696969;\n      font-size: 14px;\n      line-height: 18px;\n      font-family: "Arial", "Roboto", "Helvetica", sans-serif;\n      transition: all 0.5s;\n      cursor: pointer;\n    }\n\n    .tabby-promo-snippet:hover {\n      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5)\n    }\n\n    .tabby-promo-snippet br {\n      display: none;\n    }\n    \n    .tabby-promo-snippet--rtl {\n      direction: rtl;\n    }\n    \n    .tabby-promo-snippet__content {\n      margin-right: 5px;\n    }\n    \n    .tabby-promo-snippet--rtl .tabby-promo-snippet__content {\n      margin-right: 0;\n      margin-left: 5px;\n    }\n    \n    .tabby-promo-snippet--rtl .tabby-promo-snippet__text {\n      margin-left: 13px;\n    }\n    \n    .tabby-promo-snippet__link {\n      color: #696969 !important;\n      transition: opacity 0.2s;\n      text-decoration: underline !important;\n    }\n    \n    .tabby-promo-snippet__link:hover {\n      opacity: 0.6;\n    }\n    \n    .tabby-promo-snippet__logo {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-left: auto;\n    }\n    \n    .tabby-promo-snippet__logo-img {\n      max-height: initial;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__close {\n      left: 18px;\n      right: auto;\n    }\n    \n    .tabby-promo--rtl .tabby-promo__feature-icon {\n      margin-right: 0;\n      margin-left: 24px;\n    }\n    \n    .tabby-promo-snippet--rtl .tabby-promo-snippet__logo {\n      margin-left: 0;\n      margin-right: auto;\n    }\n    \n    @media (orientation: landscape) and (max-width: 900px) {\n      .tabby-promo-wrapper {\n        overflow-y: scroll;\n      }\n    }\n    \n    @media (orientation: portrait) and (max-width: 500px) {\n      .tabby-promo {\n        padding: 20px 16px;\n      }\n    }\n    \n    @media (orientation: portrait) and (max-width: 325px) {\n      .tabby-promo {\n        min-height: 100%;\n      }\n    }\n    \n    @media (max-width: 600px) {\n      .tabby-promo-snippet {\n        padding-right: 10px;\n        padding-left: 10px;\n      }\n\n      .tabby-promo-snippet br {\n        display: inline;\n      }\n\n      .tabby-promo-wrapper {\n        overflow-y: scroll;\n      }\n\n      .tabby-promo-snippet__content {\n        display: flex;\n        flex-direction: column;\n      }\n    \n      .tabby-promo__feature {\n        margin-bottom: 25px;\n      }\n    \n      .tabby-promo__features-wrapper {\n        display: block;\n      }\n      .tabby-promo--rtl.tabby-promo--pay-later .tabby-promo__features,\n      .tabby-promo--pay-later .tabby-promo__features {\n        width: 100%;\n        padding: 0;\n        padding-top: 25px;\n      }\n    \n      .tabby-promo--rtl .tabby-promo__instruction,\n      .tabby-promo__instruction {\n        width: 100%;\n        padding: 0;\n        padding-bottom: 25px;\n      }\n    \n      .tabby-promo__instruction::before {\n        top: auto;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 2px;\n      }\n    \n      .tabby-promo--pay-later .tabby-promo__final-text {\n        padding-top: 20px;\n      }\n    }\n    \n    @keyframes scale {\n      from {\n        transform: scale(0);\n      }\n      to {\n        transform: scale(1);\n      }\n    }\n    \n    @keyframes dissapearing {\n      from {\n        opacity: 1;\n      }\n      to {\n        opacity: 0;\n        transform: translateY(-200%);\n      }\n    }\n    \n    '),
          document.head.appendChild(t);
      }
      addDataAttributesListeners() {
        document.addEventListener('click', t => {
          if (!t.target.dataset.tabbyInfo) return !1;
          t.preventDefault();
          const e = this.createPopup(t.target.dataset.tabbyInfo);
          this.appendPopup(e);
        });
      }
      initAmplitude() {
        r.a.getInstance().init(this.amplitudePublicKey);
      }
      logAmplitudeEvent(t, e = null) {
        r.a.getInstance().logEvent(t, { events: { ...e, merchant: document.location.origin } });
      }
      calculatePrice(t) {
        return Math.floor(+t.replace(',', '') / 4).toFixed(0);
      }
      appendPromoSnippet(t) {
        this.setSnippetHtml(t),
          this.logAmplitudeEvent('PP-SNIPPET:SHOW', {
            unitPrice: this.params.price,
            splitPrice: this.calculatePrice(this.params.price),
            productTitle: this.params.productTitle,
            sku: this.params.sku
          });
      }
      setSnippetHtml(t) {
        if (!document.querySelector(t)) return !1;
        const e = this.calculatePrice(this.params.price);
        if (this.params.lang.includes('ar')) {
          const n = e
            ? `\n        مقسمة على 4 دفعات بقيمة ${e} ${this.params.currency}. بدون أي رسوم\n      `
            : 'الدفع الميسر مع تابي. لمعرفة المزيد';
          return void (document.querySelector(
            t
          ).innerHTML = `\n      <div class="tabby-promo-snippet tabby-promo-snippet--rtl">\n      <div class="tabby-promo-snippet__content"> \n        <span class="tabby-promo-snippet__text">${n}</span>\n        <a\n          class="tabby-promo-snippet__link"\n          href="#"\n          >لمعرفة المزيد\n        </a>\n      </div>\n\n      <a\n        class="tabby-promo-snippet__logo"\n        href="https://tabby.ai/"\n        target="_blank"\n        ><img\n          class="tabby-promo-snippet__logo-img"\n          src="data:image/svg+xml;base64,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"\n          alt="Tabby Logo"\n          width="47"\n          height="25"\n      /></a>\n    </div>\n      `);
        }
        const n = e ? `Split in 4 payments of ${e} ${this.params.currency}. <br> No fees` : 'Easy payments with Tabby.';
        document.querySelector(
          t
        ).innerHTML = `\n    <div class="tabby-promo-snippet">\n      <div class="tabby-promo-snippet__content"> \n      <span class="tabby-promo-snippet__text">${n}</span>\n        <a\n          href="#"\n          class="tabby-promo-snippet__link"\n          >Learn more\n        </a>\n      </div>\n\n      <a\n        class="tabby-promo-snippet__logo"\n        href="https://tabby.ai/"\n        target="_blank"\n        ><img\n          class="tabby-promo-snippet__logo-img"\n          src="data:image/svg+xml;base64,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"\n          alt="Tabby Logo"\n          width="47"\n          height="25"\n      /></a>\n      </div>\n    `;
      }
      addSnippetClickListener(t) {
        const e = document.querySelectorAll(t);
        if (!e.length) return !1;
        Array.from(e).forEach(t => {
          t.addEventListener('click', t => {
            t.preventDefault(), t.stopPropagation();
            const e = this.createPopup();
            this.appendPopup(e), this.logAmplitudeEvent('PP-SNIPPET:CLICK');
          });
        });
      }
      addCloseButtonListener() {
        const t = document.getElementById('tabby-promo-close'),
          e = () => {
            t.removeEventListener('click', e), this.removePopup();
          };
        t.addEventListener('click', e);
      }
      outSidePopupClickListener(t) {
        if (this.popupContainer.contains(t.target)) return !1;
        this.removePopup();
      }
      addOnEscapeListener(t) {
        'Escape' === t.key && this.removePopup();
      }
      appendPopup(t) {
        document.body.appendChild(t),
          this.logAmplitudeEvent('PP-POPUP:OPEN'),
          setTimeout(() => {
            document.addEventListener('click', this.outSidePopupClickListener),
              document.addEventListener('keydown', this.addOnEscapeListener),
              this.addCloseButtonListener();
          }, 0);
      }
      removePopup() {
        this.popupContainer.classList.add('dissapearing'),
          setTimeout(() => {
            this.logAmplitudeEvent('PP-POPUP:CLOSE'),
              this.popupContainer.classList.remove('dissapearing'),
              document.body.contains(this.popupWrapper) && document.body.removeChild(this.popupWrapper),
              document.removeEventListener('click', this.outSidePopupClickListener),
              document.removeEventListener('keydown', this.addOnEscapeListener);
          }, 500);
      }
      createPopup(t = 'installments') {
        const e = document.createElement('div');
        e.classList.add('tabby-promo-wrapper');
        const n = document.createElement('div');
        return (
          n.setAttribute('id', 'tabby-promo'),
          this.params.lang.includes('ar')
            ? (n.setAttribute('dir', 'rtl'), (n.className = 'tabby-promo tabby-promo--rtl'), (n.innerHTML = this.popupTemplates[t].ar))
            : ((n.className = 'tabby-promo'), (n.innerHTML = this.popupTemplates[t].en)),
          'payLater' === t && n.classList.add('tabby-promo--pay-later'),
          e.appendChild(n),
          (this.popupContainer = n),
          (this.popupWrapper = e),
          e
        );
      }
    }
    window.TabbyPromo = o;
  },
  function(t, e, n) {
    'use strict';
    (function(t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var i = n(6),
        r = n(7),
        o = n(8);
      function s() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }
      function a(t, e) {
        if (s() < e) throw new RangeError('Invalid typed array length');
        return (
          u.TYPED_ARRAY_SUPPORT ? ((t = new Uint8Array(e)).__proto__ = u.prototype) : (null === t && (t = new u(e)), (t.length = e)), t
        );
      }
      function u(t, e, n) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, n);
        if ('number' == typeof t) {
          if ('string' == typeof e) throw new Error('If encoding is specified then the first argument must be a string');
          return l(this, t);
        }
        return c(this, t, e, n);
      }
      function c(t, e, n, i) {
        if ('number' == typeof e) throw new TypeError('"value" argument must not be a number');
        return 'undefined' != typeof ArrayBuffer && e instanceof ArrayBuffer
          ? (function(t, e, n, i) {
              if ((e.byteLength, n < 0 || e.byteLength < n)) throw new RangeError("'offset' is out of bounds");
              if (e.byteLength < n + (i || 0)) throw new RangeError("'length' is out of bounds");
              e = void 0 === n && void 0 === i ? new Uint8Array(e) : void 0 === i ? new Uint8Array(e, n) : new Uint8Array(e, n, i);
              u.TYPED_ARRAY_SUPPORT ? ((t = e).__proto__ = u.prototype) : (t = M(t, e));
              return t;
            })(t, e, n, i)
          : 'string' == typeof e
          ? (function(t, e, n) {
              ('string' == typeof n && '' !== n) || (n = 'utf8');
              if (!u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
              var i = 0 | g(e, n),
                r = (t = a(t, i)).write(e, n);
              r !== i && (t = t.slice(0, r));
              return t;
            })(t, e, n)
          : (function(t, e) {
              if (u.isBuffer(e)) {
                var n = 0 | y(e.length);
                return 0 === (t = a(t, n)).length ? t : (e.copy(t, 0, 0, n), t);
              }
              if (e) {
                if (('undefined' != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer) || 'length' in e)
                  return 'number' != typeof e.length || (i = e.length) != i ? a(t, 0) : M(t, e);
                if ('Buffer' === e.type && o(e.data)) return M(t, e.data);
              }
              var i;
              throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.');
            })(t, e);
      }
      function p(t) {
        if ('number' != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }
      function l(t, e) {
        if ((p(e), (t = a(t, e < 0 ? 0 : 0 | y(e))), !u.TYPED_ARRAY_SUPPORT)) for (var n = 0; n < e; ++n) t[n] = 0;
        return t;
      }
      function M(t, e) {
        var n = e.length < 0 ? 0 : 0 | y(e.length);
        t = a(t, n);
        for (var i = 0; i < n; i += 1) t[i] = 255 & e[i];
        return t;
      }
      function y(t) {
        if (t >= s()) throw new RangeError('Attempt to allocate Buffer larger than maximum size: 0x' + s().toString(16) + ' bytes');
        return 0 | t;
      }
      function g(t, e) {
        if (u.isBuffer(t)) return t.length;
        if (
          'undefined' != typeof ArrayBuffer &&
          'function' == typeof ArrayBuffer.isView &&
          (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)
        )
          return t.byteLength;
        'string' != typeof t && (t = '' + t);
        var n = t.length;
        if (0 === n) return 0;
        for (var i = !1; ; )
          switch (e) {
            case 'ascii':
            case 'latin1':
            case 'binary':
              return n;
            case 'utf8':
            case 'utf-8':
            case void 0:
              return R(t).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return 2 * n;
            case 'hex':
              return n >>> 1;
            case 'base64':
              return B(t).length;
            default:
              if (i) return R(t).length;
              (e = ('' + e).toLowerCase()), (i = !0);
          }
      }
      function d(t, e, n) {
        var i = !1;
        if (((void 0 === e || e < 0) && (e = 0), e > this.length)) return '';
        if (((void 0 === n || n > this.length) && (n = this.length), n <= 0)) return '';
        if ((n >>>= 0) <= (e >>>= 0)) return '';
        for (t || (t = 'utf8'); ; )
          switch (t) {
            case 'hex':
              return x(this, e, n);
            case 'utf8':
            case 'utf-8':
              return D(this, e, n);
            case 'ascii':
              return v(this, e, n);
            case 'latin1':
            case 'binary':
              return _(this, e, n);
            case 'base64':
              return w(this, e, n);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return z(this, e, n);
            default:
              if (i) throw new TypeError('Unknown encoding: ' + t);
              (t = (t + '').toLowerCase()), (i = !0);
          }
      }
      function f(t, e, n) {
        var i = t[e];
        (t[e] = t[n]), (t[n] = i);
      }
      function h(t, e, n, i, r) {
        if (0 === t.length) return -1;
        if (
          ('string' == typeof n ? ((i = n), (n = 0)) : n > 2147483647 ? (n = 2147483647) : n < -2147483648 && (n = -2147483648),
          (n = +n),
          isNaN(n) && (n = r ? 0 : t.length - 1),
          n < 0 && (n = t.length + n),
          n >= t.length)
        ) {
          if (r) return -1;
          n = t.length - 1;
        } else if (n < 0) {
          if (!r) return -1;
          n = 0;
        }
        if (('string' == typeof e && (e = u.from(e, i)), u.isBuffer(e))) return 0 === e.length ? -1 : N(t, e, n, i, r);
        if ('number' == typeof e)
          return (
            (e &= 255),
            u.TYPED_ARRAY_SUPPORT && 'function' == typeof Uint8Array.prototype.indexOf
              ? r
                ? Uint8Array.prototype.indexOf.call(t, e, n)
                : Uint8Array.prototype.lastIndexOf.call(t, e, n)
              : N(t, [e], n, i, r)
          );
        throw new TypeError('val must be string, number or Buffer');
      }
      function N(t, e, n, i, r) {
        var o,
          s = 1,
          a = t.length,
          u = e.length;
        if (void 0 !== i && ('ucs2' === (i = String(i).toLowerCase()) || 'ucs-2' === i || 'utf16le' === i || 'utf-16le' === i)) {
          if (t.length < 2 || e.length < 2) return -1;
          (s = 2), (a /= 2), (u /= 2), (n /= 2);
        }
        function c(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }
        if (r) {
          var p = -1;
          for (o = n; o < a; o++)
            if (c(t, o) === c(e, -1 === p ? 0 : o - p)) {
              if ((-1 === p && (p = o), o - p + 1 === u)) return p * s;
            } else -1 !== p && (o -= o - p), (p = -1);
        } else
          for (n + u > a && (n = a - u), o = n; o >= 0; o--) {
            for (var l = !0, M = 0; M < u; M++)
              if (c(t, o + M) !== c(e, M)) {
                l = !1;
                break;
              }
            if (l) return o;
          }
        return -1;
      }
      function m(t, e, n, i) {
        n = Number(n) || 0;
        var r = t.length - n;
        i ? (i = Number(i)) > r && (i = r) : (i = r);
        var o = e.length;
        if (o % 2 != 0) throw new TypeError('Invalid hex string');
        i > o / 2 && (i = o / 2);
        for (var s = 0; s < i; ++s) {
          var a = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(a)) return s;
          t[n + s] = a;
        }
        return s;
      }
      function I(t, e, n, i) {
        return G(R(e, t.length - n), t, n, i);
      }
      function j(t, e, n, i) {
        return G(
          (function(t) {
            for (var e = [], n = 0; n < t.length; ++n) e.push(255 & t.charCodeAt(n));
            return e;
          })(e),
          t,
          n,
          i
        );
      }
      function b(t, e, n, i) {
        return j(t, e, n, i);
      }
      function L(t, e, n, i) {
        return G(B(e), t, n, i);
      }
      function T(t, e, n, i) {
        return G(
          (function(t, e) {
            for (var n, i, r, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s)
              (n = t.charCodeAt(s)), (i = n >> 8), (r = n % 256), o.push(r), o.push(i);
            return o;
          })(e, t.length - n),
          t,
          n,
          i
        );
      }
      function w(t, e, n) {
        return 0 === e && n === t.length ? i.fromByteArray(t) : i.fromByteArray(t.slice(e, n));
      }
      function D(t, e, n) {
        n = Math.min(t.length, n);
        for (var i = [], r = e; r < n; ) {
          var o,
            s,
            a,
            u,
            c = t[r],
            p = null,
            l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (r + l <= n)
            switch (l) {
              case 1:
                c < 128 && (p = c);
                break;
              case 2:
                128 == (192 & (o = t[r + 1])) && (u = ((31 & c) << 6) | (63 & o)) > 127 && (p = u);
                break;
              case 3:
                (o = t[r + 1]),
                  (s = t[r + 2]),
                  128 == (192 & o) &&
                    128 == (192 & s) &&
                    (u = ((15 & c) << 12) | ((63 & o) << 6) | (63 & s)) > 2047 &&
                    (u < 55296 || u > 57343) &&
                    (p = u);
                break;
              case 4:
                (o = t[r + 1]),
                  (s = t[r + 2]),
                  (a = t[r + 3]),
                  128 == (192 & o) &&
                    128 == (192 & s) &&
                    128 == (192 & a) &&
                    (u = ((15 & c) << 18) | ((63 & o) << 12) | ((63 & s) << 6) | (63 & a)) > 65535 &&
                    u < 1114112 &&
                    (p = u);
            }
          null === p ? ((p = 65533), (l = 1)) : p > 65535 && ((p -= 65536), i.push(((p >>> 10) & 1023) | 55296), (p = 56320 | (1023 & p))),
            i.push(p),
            (r += l);
        }
        return (function(t) {
          var e = t.length;
          if (e <= A) return String.fromCharCode.apply(String, t);
          var n = '',
            i = 0;
          for (; i < e; ) n += String.fromCharCode.apply(String, t.slice(i, (i += A)));
          return n;
        })(i);
      }
      (e.Buffer = u),
        (e.SlowBuffer = function(t) {
          +t != t && (t = 0);
          return u.alloc(+t);
        }),
        (e.INSPECT_MAX_BYTES = 50),
        (u.TYPED_ARRAY_SUPPORT =
          void 0 !== t.TYPED_ARRAY_SUPPORT
            ? t.TYPED_ARRAY_SUPPORT
            : (function() {
                try {
                  var t = new Uint8Array(1);
                  return (
                    (t.__proto__ = {
                      __proto__: Uint8Array.prototype,
                      foo: function() {
                        return 42;
                      }
                    }),
                    42 === t.foo() && 'function' == typeof t.subarray && 0 === t.subarray(1, 1).byteLength
                  );
                } catch (t) {
                  return !1;
                }
              })()),
        (e.kMaxLength = s()),
        (u.poolSize = 8192),
        (u._augment = function(t) {
          return (t.__proto__ = u.prototype), t;
        }),
        (u.from = function(t, e, n) {
          return c(null, t, e, n);
        }),
        u.TYPED_ARRAY_SUPPORT &&
          ((u.prototype.__proto__ = Uint8Array.prototype),
          (u.__proto__ = Uint8Array),
          'undefined' != typeof Symbol &&
            Symbol.species &&
            u[Symbol.species] === u &&
            Object.defineProperty(u, Symbol.species, { value: null, configurable: !0 })),
        (u.alloc = function(t, e, n) {
          return (function(t, e, n, i) {
            return p(e), e <= 0 ? a(t, e) : void 0 !== n ? ('string' == typeof i ? a(t, e).fill(n, i) : a(t, e).fill(n)) : a(t, e);
          })(null, t, e, n);
        }),
        (u.allocUnsafe = function(t) {
          return l(null, t);
        }),
        (u.allocUnsafeSlow = function(t) {
          return l(null, t);
        }),
        (u.isBuffer = function(t) {
          return !(null == t || !t._isBuffer);
        }),
        (u.compare = function(t, e) {
          if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError('Arguments must be Buffers');
          if (t === e) return 0;
          for (var n = t.length, i = e.length, r = 0, o = Math.min(n, i); r < o; ++r)
            if (t[r] !== e[r]) {
              (n = t[r]), (i = e[r]);
              break;
            }
          return n < i ? -1 : i < n ? 1 : 0;
        }),
        (u.isEncoding = function(t) {
          switch (String(t).toLowerCase()) {
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
              return !0;
            default:
              return !1;
          }
        }),
        (u.concat = function(t, e) {
          if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === t.length) return u.alloc(0);
          var n;
          if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) e += t[n].length;
          var i = u.allocUnsafe(e),
            r = 0;
          for (n = 0; n < t.length; ++n) {
            var s = t[n];
            if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
            s.copy(i, r), (r += s.length);
          }
          return i;
        }),
        (u.byteLength = g),
        (u.prototype._isBuffer = !0),
        (u.prototype.swap16 = function() {
          var t = this.length;
          if (t % 2 != 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
          for (var e = 0; e < t; e += 2) f(this, e, e + 1);
          return this;
        }),
        (u.prototype.swap32 = function() {
          var t = this.length;
          if (t % 4 != 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
          for (var e = 0; e < t; e += 4) f(this, e, e + 3), f(this, e + 1, e + 2);
          return this;
        }),
        (u.prototype.swap64 = function() {
          var t = this.length;
          if (t % 8 != 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
          for (var e = 0; e < t; e += 8) f(this, e, e + 7), f(this, e + 1, e + 6), f(this, e + 2, e + 5), f(this, e + 3, e + 4);
          return this;
        }),
        (u.prototype.toString = function() {
          var t = 0 | this.length;
          return 0 === t ? '' : 0 === arguments.length ? D(this, 0, t) : d.apply(this, arguments);
        }),
        (u.prototype.equals = function(t) {
          if (!u.isBuffer(t)) throw new TypeError('Argument must be a Buffer');
          return this === t || 0 === u.compare(this, t);
        }),
        (u.prototype.inspect = function() {
          var t = '',
            n = e.INSPECT_MAX_BYTES;
          return (
            this.length > 0 &&
              ((t = this.toString('hex', 0, n)
                .match(/.{2}/g)
                .join(' ')),
              this.length > n && (t += ' ... ')),
            '<Buffer ' + t + '>'
          );
        }),
        (u.prototype.compare = function(t, e, n, i, r) {
          if (!u.isBuffer(t)) throw new TypeError('Argument must be a Buffer');
          if (
            (void 0 === e && (e = 0),
            void 0 === n && (n = t ? t.length : 0),
            void 0 === i && (i = 0),
            void 0 === r && (r = this.length),
            e < 0 || n > t.length || i < 0 || r > this.length)
          )
            throw new RangeError('out of range index');
          if (i >= r && e >= n) return 0;
          if (i >= r) return -1;
          if (e >= n) return 1;
          if (this === t) return 0;
          for (
            var o = (r >>>= 0) - (i >>>= 0),
              s = (n >>>= 0) - (e >>>= 0),
              a = Math.min(o, s),
              c = this.slice(i, r),
              p = t.slice(e, n),
              l = 0;
            l < a;
            ++l
          )
            if (c[l] !== p[l]) {
              (o = c[l]), (s = p[l]);
              break;
            }
          return o < s ? -1 : s < o ? 1 : 0;
        }),
        (u.prototype.includes = function(t, e, n) {
          return -1 !== this.indexOf(t, e, n);
        }),
        (u.prototype.indexOf = function(t, e, n) {
          return h(this, t, e, n, !0);
        }),
        (u.prototype.lastIndexOf = function(t, e, n) {
          return h(this, t, e, n, !1);
        }),
        (u.prototype.write = function(t, e, n, i) {
          if (void 0 === e) (i = 'utf8'), (n = this.length), (e = 0);
          else if (void 0 === n && 'string' == typeof e) (i = e), (n = this.length), (e = 0);
          else {
            if (!isFinite(e)) throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
            (e |= 0), isFinite(n) ? ((n |= 0), void 0 === i && (i = 'utf8')) : ((i = n), (n = void 0));
          }
          var r = this.length - e;
          if (((void 0 === n || n > r) && (n = r), (t.length > 0 && (n < 0 || e < 0)) || e > this.length))
            throw new RangeError('Attempt to write outside buffer bounds');
          i || (i = 'utf8');
          for (var o = !1; ; )
            switch (i) {
              case 'hex':
                return m(this, t, e, n);
              case 'utf8':
              case 'utf-8':
                return I(this, t, e, n);
              case 'ascii':
                return j(this, t, e, n);
              case 'latin1':
              case 'binary':
                return b(this, t, e, n);
              case 'base64':
                return L(this, t, e, n);
              case 'ucs2':
              case 'ucs-2':
              case 'utf16le':
              case 'utf-16le':
                return T(this, t, e, n);
              default:
                if (o) throw new TypeError('Unknown encoding: ' + i);
                (i = ('' + i).toLowerCase()), (o = !0);
            }
        }),
        (u.prototype.toJSON = function() {
          return { type: 'Buffer', data: Array.prototype.slice.call(this._arr || this, 0) };
        });
      var A = 4096;
      function v(t, e, n) {
        var i = '';
        n = Math.min(t.length, n);
        for (var r = e; r < n; ++r) i += String.fromCharCode(127 & t[r]);
        return i;
      }
      function _(t, e, n) {
        var i = '';
        n = Math.min(t.length, n);
        for (var r = e; r < n; ++r) i += String.fromCharCode(t[r]);
        return i;
      }
      function x(t, e, n) {
        var i = t.length;
        (!e || e < 0) && (e = 0), (!n || n < 0 || n > i) && (n = i);
        for (var r = '', o = e; o < n; ++o) r += P(t[o]);
        return r;
      }
      function z(t, e, n) {
        for (var i = t.slice(e, n), r = '', o = 0; o < i.length; o += 2) r += String.fromCharCode(i[o] + 256 * i[o + 1]);
        return r;
      }
      function S(t, e, n) {
        if (t % 1 != 0 || t < 0) throw new RangeError('offset is not uint');
        if (t + e > n) throw new RangeError('Trying to access beyond buffer length');
      }
      function E(t, e, n, i, r, o) {
        if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > r || e < o) throw new RangeError('"value" argument is out of bounds');
        if (n + i > t.length) throw new RangeError('Index out of range');
      }
      function O(t, e, n, i) {
        e < 0 && (e = 65535 + e + 1);
        for (var r = 0, o = Math.min(t.length - n, 2); r < o; ++r)
          t[n + r] = (e & (255 << (8 * (i ? r : 1 - r)))) >>> (8 * (i ? r : 1 - r));
      }
      function C(t, e, n, i) {
        e < 0 && (e = 4294967295 + e + 1);
        for (var r = 0, o = Math.min(t.length - n, 4); r < o; ++r) t[n + r] = (e >>> (8 * (i ? r : 3 - r))) & 255;
      }
      function k(t, e, n, i, r, o) {
        if (n + i > t.length) throw new RangeError('Index out of range');
        if (n < 0) throw new RangeError('Index out of range');
      }
      function U(t, e, n, i, o) {
        return o || k(t, 0, n, 4), r.write(t, e, n, i, 23, 4), n + 4;
      }
      function Q(t, e, n, i, o) {
        return o || k(t, 0, n, 8), r.write(t, e, n, i, 52, 8), n + 8;
      }
      (u.prototype.slice = function(t, e) {
        var n,
          i = this.length;
        if (
          ((t = ~~t) < 0 ? (t += i) < 0 && (t = 0) : t > i && (t = i),
          (e = void 0 === e ? i : ~~e) < 0 ? (e += i) < 0 && (e = 0) : e > i && (e = i),
          e < t && (e = t),
          u.TYPED_ARRAY_SUPPORT)
        )
          (n = this.subarray(t, e)).__proto__ = u.prototype;
        else {
          var r = e - t;
          n = new u(r, void 0);
          for (var o = 0; o < r; ++o) n[o] = this[o + t];
        }
        return n;
      }),
        (u.prototype.readUIntLE = function(t, e, n) {
          (t |= 0), (e |= 0), n || S(t, e, this.length);
          for (var i = this[t], r = 1, o = 0; ++o < e && (r *= 256); ) i += this[t + o] * r;
          return i;
        }),
        (u.prototype.readUIntBE = function(t, e, n) {
          (t |= 0), (e |= 0), n || S(t, e, this.length);
          for (var i = this[t + --e], r = 1; e > 0 && (r *= 256); ) i += this[t + --e] * r;
          return i;
        }),
        (u.prototype.readUInt8 = function(t, e) {
          return e || S(t, 1, this.length), this[t];
        }),
        (u.prototype.readUInt16LE = function(t, e) {
          return e || S(t, 2, this.length), this[t] | (this[t + 1] << 8);
        }),
        (u.prototype.readUInt16BE = function(t, e) {
          return e || S(t, 2, this.length), (this[t] << 8) | this[t + 1];
        }),
        (u.prototype.readUInt32LE = function(t, e) {
          return e || S(t, 4, this.length), (this[t] | (this[t + 1] << 8) | (this[t + 2] << 16)) + 16777216 * this[t + 3];
        }),
        (u.prototype.readUInt32BE = function(t, e) {
          return e || S(t, 4, this.length), 16777216 * this[t] + ((this[t + 1] << 16) | (this[t + 2] << 8) | this[t + 3]);
        }),
        (u.prototype.readIntLE = function(t, e, n) {
          (t |= 0), (e |= 0), n || S(t, e, this.length);
          for (var i = this[t], r = 1, o = 0; ++o < e && (r *= 256); ) i += this[t + o] * r;
          return i >= (r *= 128) && (i -= Math.pow(2, 8 * e)), i;
        }),
        (u.prototype.readIntBE = function(t, e, n) {
          (t |= 0), (e |= 0), n || S(t, e, this.length);
          for (var i = e, r = 1, o = this[t + --i]; i > 0 && (r *= 256); ) o += this[t + --i] * r;
          return o >= (r *= 128) && (o -= Math.pow(2, 8 * e)), o;
        }),
        (u.prototype.readInt8 = function(t, e) {
          return e || S(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
        }),
        (u.prototype.readInt16LE = function(t, e) {
          e || S(t, 2, this.length);
          var n = this[t] | (this[t + 1] << 8);
          return 32768 & n ? 4294901760 | n : n;
        }),
        (u.prototype.readInt16BE = function(t, e) {
          e || S(t, 2, this.length);
          var n = this[t + 1] | (this[t] << 8);
          return 32768 & n ? 4294901760 | n : n;
        }),
        (u.prototype.readInt32LE = function(t, e) {
          return e || S(t, 4, this.length), this[t] | (this[t + 1] << 8) | (this[t + 2] << 16) | (this[t + 3] << 24);
        }),
        (u.prototype.readInt32BE = function(t, e) {
          return e || S(t, 4, this.length), (this[t] << 24) | (this[t + 1] << 16) | (this[t + 2] << 8) | this[t + 3];
        }),
        (u.prototype.readFloatLE = function(t, e) {
          return e || S(t, 4, this.length), r.read(this, t, !0, 23, 4);
        }),
        (u.prototype.readFloatBE = function(t, e) {
          return e || S(t, 4, this.length), r.read(this, t, !1, 23, 4);
        }),
        (u.prototype.readDoubleLE = function(t, e) {
          return e || S(t, 8, this.length), r.read(this, t, !0, 52, 8);
        }),
        (u.prototype.readDoubleBE = function(t, e) {
          return e || S(t, 8, this.length), r.read(this, t, !1, 52, 8);
        }),
        (u.prototype.writeUIntLE = function(t, e, n, i) {
          ((t = +t), (e |= 0), (n |= 0), i) || E(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
          var r = 1,
            o = 0;
          for (this[e] = 255 & t; ++o < n && (r *= 256); ) this[e + o] = (t / r) & 255;
          return e + n;
        }),
        (u.prototype.writeUIntBE = function(t, e, n, i) {
          ((t = +t), (e |= 0), (n |= 0), i) || E(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
          var r = n - 1,
            o = 1;
          for (this[e + r] = 255 & t; --r >= 0 && (o *= 256); ) this[e + r] = (t / o) & 255;
          return e + n;
        }),
        (u.prototype.writeUInt8 = function(t, e, n) {
          return (
            (t = +t), (e |= 0), n || E(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), (this[e] = 255 & t), e + 1
          );
        }),
        (u.prototype.writeUInt16LE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 2, 65535, 0),
            u.TYPED_ARRAY_SUPPORT ? ((this[e] = 255 & t), (this[e + 1] = t >>> 8)) : O(this, t, e, !0),
            e + 2
          );
        }),
        (u.prototype.writeUInt16BE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 2, 65535, 0),
            u.TYPED_ARRAY_SUPPORT ? ((this[e] = t >>> 8), (this[e + 1] = 255 & t)) : O(this, t, e, !1),
            e + 2
          );
        }),
        (u.prototype.writeUInt32LE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 4, 4294967295, 0),
            u.TYPED_ARRAY_SUPPORT
              ? ((this[e + 3] = t >>> 24), (this[e + 2] = t >>> 16), (this[e + 1] = t >>> 8), (this[e] = 255 & t))
              : C(this, t, e, !0),
            e + 4
          );
        }),
        (u.prototype.writeUInt32BE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 4, 4294967295, 0),
            u.TYPED_ARRAY_SUPPORT
              ? ((this[e] = t >>> 24), (this[e + 1] = t >>> 16), (this[e + 2] = t >>> 8), (this[e + 3] = 255 & t))
              : C(this, t, e, !1),
            e + 4
          );
        }),
        (u.prototype.writeIntLE = function(t, e, n, i) {
          if (((t = +t), (e |= 0), !i)) {
            var r = Math.pow(2, 8 * n - 1);
            E(this, t, e, n, r - 1, -r);
          }
          var o = 0,
            s = 1,
            a = 0;
          for (this[e] = 255 & t; ++o < n && (s *= 256); )
            t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), (this[e + o] = (((t / s) >> 0) - a) & 255);
          return e + n;
        }),
        (u.prototype.writeIntBE = function(t, e, n, i) {
          if (((t = +t), (e |= 0), !i)) {
            var r = Math.pow(2, 8 * n - 1);
            E(this, t, e, n, r - 1, -r);
          }
          var o = n - 1,
            s = 1,
            a = 0;
          for (this[e + o] = 255 & t; --o >= 0 && (s *= 256); )
            t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), (this[e + o] = (((t / s) >> 0) - a) & 255);
          return e + n;
        }),
        (u.prototype.writeInt8 = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 1, 127, -128),
            u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)),
            t < 0 && (t = 255 + t + 1),
            (this[e] = 255 & t),
            e + 1
          );
        }),
        (u.prototype.writeInt16LE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 2, 32767, -32768),
            u.TYPED_ARRAY_SUPPORT ? ((this[e] = 255 & t), (this[e + 1] = t >>> 8)) : O(this, t, e, !0),
            e + 2
          );
        }),
        (u.prototype.writeInt16BE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 2, 32767, -32768),
            u.TYPED_ARRAY_SUPPORT ? ((this[e] = t >>> 8), (this[e + 1] = 255 & t)) : O(this, t, e, !1),
            e + 2
          );
        }),
        (u.prototype.writeInt32LE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 4, 2147483647, -2147483648),
            u.TYPED_ARRAY_SUPPORT
              ? ((this[e] = 255 & t), (this[e + 1] = t >>> 8), (this[e + 2] = t >>> 16), (this[e + 3] = t >>> 24))
              : C(this, t, e, !0),
            e + 4
          );
        }),
        (u.prototype.writeInt32BE = function(t, e, n) {
          return (
            (t = +t),
            (e |= 0),
            n || E(this, t, e, 4, 2147483647, -2147483648),
            t < 0 && (t = 4294967295 + t + 1),
            u.TYPED_ARRAY_SUPPORT
              ? ((this[e] = t >>> 24), (this[e + 1] = t >>> 16), (this[e + 2] = t >>> 8), (this[e + 3] = 255 & t))
              : C(this, t, e, !1),
            e + 4
          );
        }),
        (u.prototype.writeFloatLE = function(t, e, n) {
          return U(this, t, e, !0, n);
        }),
        (u.prototype.writeFloatBE = function(t, e, n) {
          return U(this, t, e, !1, n);
        }),
        (u.prototype.writeDoubleLE = function(t, e, n) {
          return Q(this, t, e, !0, n);
        }),
        (u.prototype.writeDoubleBE = function(t, e, n) {
          return Q(this, t, e, !1, n);
        }),
        (u.prototype.copy = function(t, e, n, i) {
          if (
            (n || (n = 0),
            i || 0 === i || (i = this.length),
            e >= t.length && (e = t.length),
            e || (e = 0),
            i > 0 && i < n && (i = n),
            i === n)
          )
            return 0;
          if (0 === t.length || 0 === this.length) return 0;
          if (e < 0) throw new RangeError('targetStart out of bounds');
          if (n < 0 || n >= this.length) throw new RangeError('sourceStart out of bounds');
          if (i < 0) throw new RangeError('sourceEnd out of bounds');
          i > this.length && (i = this.length), t.length - e < i - n && (i = t.length - e + n);
          var r,
            o = i - n;
          if (this === t && n < e && e < i) for (r = o - 1; r >= 0; --r) t[r + e] = this[r + n];
          else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (r = 0; r < o; ++r) t[r + e] = this[r + n];
          else Uint8Array.prototype.set.call(t, this.subarray(n, n + o), e);
          return o;
        }),
        (u.prototype.fill = function(t, e, n, i) {
          if ('string' == typeof t) {
            if (
              ('string' == typeof e ? ((i = e), (e = 0), (n = this.length)) : 'string' == typeof n && ((i = n), (n = this.length)),
              1 === t.length)
            ) {
              var r = t.charCodeAt(0);
              r < 256 && (t = r);
            }
            if (void 0 !== i && 'string' != typeof i) throw new TypeError('encoding must be a string');
            if ('string' == typeof i && !u.isEncoding(i)) throw new TypeError('Unknown encoding: ' + i);
          } else 'number' == typeof t && (t &= 255);
          if (e < 0 || this.length < e || this.length < n) throw new RangeError('Out of range index');
          if (n <= e) return this;
          var o;
          if (((e >>>= 0), (n = void 0 === n ? this.length : n >>> 0), t || (t = 0), 'number' == typeof t))
            for (o = e; o < n; ++o) this[o] = t;
          else {
            var s = u.isBuffer(t) ? t : R(new u(t, i).toString()),
              a = s.length;
            for (o = 0; o < n - e; ++o) this[o + e] = s[o % a];
          }
          return this;
        });
      var Y = /[^+\/0-9A-Za-z-_]/g;
      function P(t) {
        return t < 16 ? '0' + t.toString(16) : t.toString(16);
      }
      function R(t, e) {
        var n;
        e = e || 1 / 0;
        for (var i = t.length, r = null, o = [], s = 0; s < i; ++s) {
          if ((n = t.charCodeAt(s)) > 55295 && n < 57344) {
            if (!r) {
              if (n > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              if (s + 1 === i) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }
              r = n;
              continue;
            }
            if (n < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), (r = n);
              continue;
            }
            n = 65536 + (((r - 55296) << 10) | (n - 56320));
          } else r && (e -= 3) > -1 && o.push(239, 191, 189);
          if (((r = null), n < 128)) {
            if ((e -= 1) < 0) break;
            o.push(n);
          } else if (n < 2048) {
            if ((e -= 2) < 0) break;
            o.push((n >> 6) | 192, (63 & n) | 128);
          } else if (n < 65536) {
            if ((e -= 3) < 0) break;
            o.push((n >> 12) | 224, ((n >> 6) & 63) | 128, (63 & n) | 128);
          } else {
            if (!(n < 1114112)) throw new Error('Invalid code point');
            if ((e -= 4) < 0) break;
            o.push((n >> 18) | 240, ((n >> 12) & 63) | 128, ((n >> 6) & 63) | 128, (63 & n) | 128);
          }
        }
        return o;
      }
      function B(t) {
        return i.toByteArray(
          (function(t) {
            if (
              (t = (function(t) {
                return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, '');
              })(t).replace(Y, '')).length < 2
            )
              return '';
            for (; t.length % 4 != 0; ) t += '=';
            return t;
          })(t)
        );
      }
      function G(t, e, n, i) {
        for (var r = 0; r < i && !(r + n >= e.length || r >= t.length); ++r) e[r + n] = t[r];
        return r;
      }
    }.call(this, n(3)));
  },
  function(t, e, n) {
    'use strict';
    (e.byteLength = function(t) {
      var e = c(t),
        n = e[0],
        i = e[1];
      return (3 * (n + i)) / 4 - i;
    }),
      (e.toByteArray = function(t) {
        var e,
          n,
          i = c(t),
          s = i[0],
          a = i[1],
          u = new o(
            (function(t, e, n) {
              return (3 * (e + n)) / 4 - n;
            })(0, s, a)
          ),
          p = 0,
          l = a > 0 ? s - 4 : s;
        for (n = 0; n < l; n += 4)
          (e = (r[t.charCodeAt(n)] << 18) | (r[t.charCodeAt(n + 1)] << 12) | (r[t.charCodeAt(n + 2)] << 6) | r[t.charCodeAt(n + 3)]),
            (u[p++] = (e >> 16) & 255),
            (u[p++] = (e >> 8) & 255),
            (u[p++] = 255 & e);
        2 === a && ((e = (r[t.charCodeAt(n)] << 2) | (r[t.charCodeAt(n + 1)] >> 4)), (u[p++] = 255 & e));
        1 === a &&
          ((e = (r[t.charCodeAt(n)] << 10) | (r[t.charCodeAt(n + 1)] << 4) | (r[t.charCodeAt(n + 2)] >> 2)),
          (u[p++] = (e >> 8) & 255),
          (u[p++] = 255 & e));
        return u;
      }),
      (e.fromByteArray = function(t) {
        for (var e, n = t.length, r = n % 3, o = [], s = 0, a = n - r; s < a; s += 16383) o.push(p(t, s, s + 16383 > a ? a : s + 16383));
        1 === r
          ? ((e = t[n - 1]), o.push(i[e >> 2] + i[(e << 4) & 63] + '=='))
          : 2 === r && ((e = (t[n - 2] << 8) + t[n - 1]), o.push(i[e >> 10] + i[(e >> 4) & 63] + i[(e << 2) & 63] + '='));
        return o.join('');
      });
    for (
      var i = [],
        r = [],
        o = 'undefined' != typeof Uint8Array ? Uint8Array : Array,
        s = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
        a = 0,
        u = s.length;
      a < u;
      ++a
    )
      (i[a] = s[a]), (r[s.charCodeAt(a)] = a);
    function c(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
      var n = t.indexOf('=');
      return -1 === n && (n = e), [n, n === e ? 0 : 4 - (n % 4)];
    }
    function p(t, e, n) {
      for (var r, o, s = [], a = e; a < n; a += 3)
        (r = ((t[a] << 16) & 16711680) + ((t[a + 1] << 8) & 65280) + (255 & t[a + 2])),
          s.push(i[((o = r) >> 18) & 63] + i[(o >> 12) & 63] + i[(o >> 6) & 63] + i[63 & o]);
      return s.join('');
    }
    (r['-'.charCodeAt(0)] = 62), (r['_'.charCodeAt(0)] = 63);
  },
  function(t, e) {
    (e.read = function(t, e, n, i, r) {
      var o,
        s,
        a = 8 * r - i - 1,
        u = (1 << a) - 1,
        c = u >> 1,
        p = -7,
        l = n ? r - 1 : 0,
        M = n ? -1 : 1,
        y = t[e + l];
      for (l += M, o = y & ((1 << -p) - 1), y >>= -p, p += a; p > 0; o = 256 * o + t[e + l], l += M, p -= 8);
      for (s = o & ((1 << -p) - 1), o >>= -p, p += i; p > 0; s = 256 * s + t[e + l], l += M, p -= 8);
      if (0 === o) o = 1 - c;
      else {
        if (o === u) return s ? NaN : (1 / 0) * (y ? -1 : 1);
        (s += Math.pow(2, i)), (o -= c);
      }
      return (y ? -1 : 1) * s * Math.pow(2, o - i);
    }),
      (e.write = function(t, e, n, i, r, o) {
        var s,
          a,
          u,
          c = 8 * o - r - 1,
          p = (1 << c) - 1,
          l = p >> 1,
          M = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          y = i ? 0 : o - 1,
          g = i ? 1 : -1,
          d = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0;
        for (
          e = Math.abs(e),
            isNaN(e) || e === 1 / 0
              ? ((a = isNaN(e) ? 1 : 0), (s = p))
              : ((s = Math.floor(Math.log(e) / Math.LN2)),
                e * (u = Math.pow(2, -s)) < 1 && (s--, (u *= 2)),
                (e += s + l >= 1 ? M / u : M * Math.pow(2, 1 - l)) * u >= 2 && (s++, (u /= 2)),
                s + l >= p
                  ? ((a = 0), (s = p))
                  : s + l >= 1
                  ? ((a = (e * u - 1) * Math.pow(2, r)), (s += l))
                  : ((a = e * Math.pow(2, l - 1) * Math.pow(2, r)), (s = 0)));
          r >= 8;
          t[n + y] = 255 & a, y += g, a /= 256, r -= 8
        );
        for (s = (s << r) | a, c += r; c > 0; t[n + y] = 255 & s, y += g, s /= 256, c -= 8);
        t[n + y - g] |= 128 * d;
      });
  },
  function(t, e) {
    var n = {}.toString;
    t.exports =
      Array.isArray ||
      function(t) {
        return '[object Array]' == n.call(t);
      };
  },
  function(t, e, n) {
    'use strict';
    var i,
      r = function() {
        return void 0 === i && (i = Boolean(window && document && document.all && !window.atob)), i;
      },
      o = (function() {
        var t = {};
        return function(e) {
          if (void 0 === t[e]) {
            var n = document.querySelector(e);
            if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement)
              try {
                n = n.contentDocument.head;
              } catch (t) {
                n = null;
              }
            t[e] = n;
          }
          return t[e];
        };
      })(),
      s = {};
    function a(t, e, n) {
      for (var i = 0; i < e.length; i++) {
        var r = { css: e[i][1], media: e[i][2], sourceMap: e[i][3] };
        s[t][i] ? s[t][i](r) : s[t].push(d(r, n));
      }
    }
    function u(t) {
      var e = document.createElement('style'),
        i = t.attributes || {};
      if (void 0 === i.nonce) {
        var r = n.nc;
        r && (i.nonce = r);
      }
      if (
        (Object.keys(i).forEach(function(t) {
          e.setAttribute(t, i[t]);
        }),
        'function' == typeof t.insert)
      )
        t.insert(e);
      else {
        var s = o(t.insert || 'head');
        if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        s.appendChild(e);
      }
      return e;
    }
    var c,
      p =
        ((c = []),
        function(t, e) {
          return (c[t] = e), c.filter(Boolean).join('\n');
        });
    function l(t, e, n, i) {
      var r = n ? '' : i.css;
      if (t.styleSheet) t.styleSheet.cssText = p(e, r);
      else {
        var o = document.createTextNode(r),
          s = t.childNodes;
        s[e] && t.removeChild(s[e]), s.length ? t.insertBefore(o, s[e]) : t.appendChild(o);
      }
    }
    function M(t, e, n) {
      var i = n.css,
        r = n.media,
        o = n.sourceMap;
      if (
        (r ? t.setAttribute('media', r) : t.removeAttribute('media'),
        o &&
          btoa &&
          (i += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
            btoa(unescape(encodeURIComponent(JSON.stringify(o)))),
            ' */'
          )),
        t.styleSheet)
      )
        t.styleSheet.cssText = i;
      else {
        for (; t.firstChild; ) t.removeChild(t.firstChild);
        t.appendChild(document.createTextNode(i));
      }
    }
    var y = null,
      g = 0;
    function d(t, e) {
      var n, i, r;
      if (e.singleton) {
        var o = g++;
        (n = y || (y = u(e))), (i = l.bind(null, n, o, !1)), (r = l.bind(null, n, o, !0));
      } else
        (n = u(e)),
          (i = M.bind(null, n, e)),
          (r = function() {
            !(function(t) {
              if (null === t.parentNode) return !1;
              t.parentNode.removeChild(t);
            })(n);
          });
      return (
        i(t),
        function(e) {
          if (e) {
            if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
            i((t = e));
          } else r();
        }
      );
    }
    t.exports = function(t, e, n) {
      return (
        (n = n || {}).singleton || 'boolean' == typeof n.singleton || (n.singleton = r()),
        (t = n.base ? t + n.base : t),
        (e = e || []),
        s[t] || (s[t] = []),
        a(t, e, n),
        function(e) {
          if (((e = e || []), '[object Array]' === Object.prototype.toString.call(e))) {
            s[t] || (s[t] = []), a(t, e, n);
            for (var i = e.length; i < s[t].length; i++) s[t][i]();
            (s[t].length = e.length), 0 === s[t].length && delete s[t];
          }
        }
      );
    };
  },
  function(t, e, n) {
    'use strict';
    t.exports = function(t) {
      var e = [];
      return (
        (e.toString = function() {
          return this.map(function(e) {
            var n = (function(t, e) {
              var n = t[1] || '',
                i = t[3];
              if (!i) return n;
              if (e && 'function' == typeof btoa) {
                var r =
                    ((s = i),
                    (a = btoa(unescape(encodeURIComponent(JSON.stringify(s))))),
                    (u = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(a)),
                    '/*# '.concat(u, ' */')),
                  o = i.sources.map(function(t) {
                    return '/*# sourceURL='.concat(i.sourceRoot).concat(t, ' */');
                  });
                return [n]
                  .concat(o)
                  .concat([r])
                  .join('\n');
              }
              var s, a, u;
              return [n].join('\n');
            })(e, t);
            return e[2] ? '@media '.concat(e[2], ' {').concat(n, '}') : n;
          }).join('');
        }),
        (e.i = function(t, n) {
          'string' == typeof t && (t = [[null, t, '']]);
          for (var i = 0; i < t.length; i++) {
            var r = [].concat(t[i]);
            n && (r[2] ? (r[2] = ''.concat(n, ' and ').concat(r[2])) : (r[2] = n)), e.push(r);
          }
        }),
        e
      );
    };
  },
  function(t, e, n) {
    'use strict';
    t.exports = function(t, e) {
      return (
        e || (e = {}),
        'string' != typeof (t = t && t.__esModule ? t.default : t)
          ? t
          : (/^['"].*['"]$/.test(t) && (t = t.slice(1, -1)),
            e.hash && (t += e.hash),
            /["'() \t\n]/.test(t) || e.needQuotes ? '"'.concat(t.replace(/"/g, '\\"').replace(/\n/g, '\\n'), '"') : t)
      );
    };
  },
  function(t, e) {
    t.exports =
      'data:image/svg+xml;base64,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';
  },
  function(t, e, n) {
    'use strict';
    n.r(e);
    var i = n(4),
      r = n(1),
      o = n.n(r);
    function s() {
      return (s =
        Object.assign ||
        function(t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = arguments[e];
            for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
          }
          return t;
        }).apply(this, arguments);
    }
    function a(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1), (i.configurable = !0), 'value' in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
      }
    }
    var u = (function() {
      function t() {
        var e = this;
        !(function(t, e) {
          if (!(t instanceof e)) throw new TypeError('Cannot call a class as a function');
        })(this, t),
          (this.config = null),
          (this.iframeWrapper = null),
          (this.iframe = null),
          (this.iframeLoaded = !1),
          (this.isCSSInjected = !1),
          (this.meta = void 0),
          (this.PAYLATER = 'payLater'),
          (this.INSTALLMENTS = 'installments'),
          (this.warnings = []),
          (this.onMessage = function(t) {
            try {
              var n = JSON.parse(t.data),
                i = n.type,
                r = n.data;
              switch (i) {
                case 'loaded':
                  e.initCheckout();
                  break;
                case 'close':
                  e.onClose(r);
                  break;
                case 'checkout':
                  e.onChange(r);
              }
            } catch (t) {}
          }),
          new i.TabbyPromo({});
      }
      var e, n, r;
      return (
        (e = t),
        (n = [
          {
            key: 'destroy',
            value: function() {
              this.config.lightboxLayout && this.stopBodyScrolling(!1),
                this.meta && this.removeMetaTag(),
                this.removeWindowListener(),
                this.container.hasChildNodes() &&
                  ('none' !== this.container.style.display && (this.container.style.display = 'none'),
                  this.container.removeChild(this.iframeWrapper));
            }
          },
          {
            key: 'onClose',
            value: function() {
              var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = t.redirectUrl;
              this.destroy(), this.config.onClose && this.config.onClose(), e && window.open(e, '_blank');
            }
          },
          {
            key: 'createMetaTag',
            value: function() {
              if (!this.meta) {
                var t = document.createElement('meta');
                t.setAttribute('name', 'viewport'),
                  t.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0'),
                  document.getElementsByTagName('head')[0].appendChild(t),
                  (this.meta = t);
              }
            }
          },
          {
            key: 'removeMetaTag',
            value: function() {
              document.getElementsByTagName('head')[0].removeChild(this.meta), (this.meta = null);
            }
          },
          {
            key: 'onChange',
            value: function(t) {
              this.config.onChange && this.config.onChange(t);
            }
          },
          {
            key: 'createIframe',
            value: function() {
              var t = this,
                e = document.createElement('iframe');
              return (
                (e.src = 'https://checkout.tabby.ai/checkout/'),
                e.classList.add(o.a.iframe),
                e.setAttribute('border', '0'),
                e.setAttribute('frameborder', '0'),
                e.setAttribute('cellspacing', '0'),
                (e.onload = function() {
                  return (t.iframeLoaded = !0);
                }),
                e
              );
            }
          },
          {
            key: 'createIframeWrapper',
            value: function() {
              var t = document.createElement('div');
              return (
                (t.className = '\n      '
                  .concat(o.a.tabby, '\n      ')
                  .concat(o.a.loading, '\n      ')
                  .concat(this.config.lightboxLayout ? o.a.lightbox : '', '\n    ')),
                (t.innerHTML = '\n      <div class="'.concat(o.a.paranja, '"></div>\n    ')),
                t
              );
            }
          },
          {
            key: 'init',
            value: function(t) {
              this.config = Object.assign(s({ nodeId: 'tabby-checkout', lightboxLayout: !0 }, t));
            }
          },
          {
            key: 'createWrapper',
            value: function() {
              var t = this.container;
              return (
                t
                  ? (t.innerHTML = '')
                  : ((t = document.createElement('div')).setAttribute('id', this.config.nodeId),
                    (t.style.display = 'none'),
                    document.body.appendChild(t)),
                t
              );
            }
          },
          {
            key: 'create',
            value: function() {
              (this.iframeWrapper = this.createIframeWrapper()),
                (this.iframe = this.createIframe()),
                this.iframeWrapper.appendChild(this.iframe),
                this.removeWindowListener(),
                this.addWindowListener(),
                this.createWrapper().appendChild(this.iframeWrapper);
            }
          },
          {
            key: 'initCheckout',
            value: function() {
              this.iframeWrapper.classList.remove(o.a.loading),
                this.iframe.contentWindow.postMessage(
                  JSON.stringify({
                    type: 'init',
                    data: {
                      apiKey: this.config.apiKey,
                      country: this.config.country || 'uae',
                      lang: this.config.lang || 'en',
                      merchant: location.origin,
                      merchantCode: this.config.merchantCode || 'default',
                      payment: this.config.payment,
                      sessionId: this.config.sessionId
                    }
                  }),
                  '*'
                );
            }
          },
          {
            key: 'stopBodyScrolling',
            value: function(t) {
              t ? document.body.classList.add(o.a.scrollingStop) : document.body.classList.remove(o.a.scrollingStop);
            }
          },
          {
            key: 'launch',
            value: function() {
              var t = this,
                e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = e.route,
                i = e.product,
                r = function() {
                  var e;
                  (null === (e = t.config) || void 0 === e ? void 0 : e.lightboxLayout) && t.stopBodyScrolling(!0),
                    t.iframe.contentWindow.postMessage(JSON.stringify({ type: 'launch', data: { route: n, product: i } }), '*'),
                    t.createMetaTag();
                };
              this.iframeLoaded
                ? r()
                : (this.iframe.onload = function() {
                    r();
                  });
            }
          },
          {
            key: 'addWindowListener',
            value: function() {
              window.addEventListener('message', this.onMessage, !1);
            }
          },
          {
            key: 'removeWindowListener',
            value: function() {
              window.removeEventListener('message', this.onMessage, !1);
            }
          },
          {
            key: 'container',
            get: function() {
              return document.getElementById(this.config.nodeId);
            }
          }
        ]) && a(e.prototype, n),
        r && a(e, r),
        t
      );
    })();
    window.Tabby = new u();
  },
  function(t, e, n) {
    var i = n(10),
      r = n(11),
      o = n(12);
    e = i(!1);
    var s = r(o);
    e.push([
      t.i,
      "@keyframes integration__pulse--7245f {\n  0% {\n    background-position: 0% 0%;\n  }\n  100% {\n    background-position: -135% 0%;\n  }\n}\n\n@keyframes integration__pulse-rtl--780bf {\n  0% {\n    background-position: 0% 0%;\n  }\n  100% {\n    background-position: 135% 0%;\n  }\n}\n\n.integration__tabby--94c5e {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.integration__scrollingStop--ded6f {\n  overflow: hidden;\n}\n\n.integration__paranja--bc586 {\n  display: none;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0, 0.8);\n  z-index: 99991;\n  position: absolute;\n}\n\n.integration__iframe--22fee {\n  width: 100%;\n  height: 100%;\n  z-index: 99991;\n  position: relative;\n  background: white;\n}\n\n.integration__loading--a047a:before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 35px;\n  height: 35px;\n  z-index: 999999;\n  border-radius: 50%;\n  background: url(" +
        s +
        ') no-repeat center / cover;\n  animation: integration__rotation--716bd 1.5s infinite linear;\n}\n\n.integration__lightbox--93994.integration__tabby--94c5e {\n    top: 0;\n    left: 0;\n    z-index: 9999999999999999999999999999999999999999999999999 !important;\n    position: fixed;\n  }\n\n@media (min-width: 500px) {\n    .integration__lightbox--93994 {\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-pack: center;\n          justify-content: center;\n      -ms-flex-align: center;\n          align-items: center;\n    }\n\n    .integration__lightbox--93994 .integration__iframe--22fee {\n      border-radius: 7px;\n      width: 545px;\n      height: 740px;\n    }\n\n    .integration__lightbox--93994 .integration__paranja--bc586 {\n      display: block;\n    }\n  }\n\n@keyframes integration__rotation--716bd {\n  0% {\n    transform: translate(-50%, -50%) rotate(0deg) scale(1);\n  }\n\n  50% {\n    transform: translate(-50%, -50%) rotate(180deg) scale(1.3);\n  }\n\n  100% {\n    transform: translate(-50%, -50%) rotate(359deg) scale(1);\n  }\n}\n',
      ''
    ]),
      (e.locals = {
        tabby: 'integration__tabby--94c5e',
        scrollingStop: 'integration__scrollingStop--ded6f',
        paranja: 'integration__paranja--bc586',
        iframe: 'integration__iframe--22fee',
        loading: 'integration__loading--a047a',
        rotation: 'integration__rotation--716bd',
        lightbox: 'integration__lightbox--93994',
        pulse: 'integration__pulse--7245f',
        'pulse-rtl': 'integration__pulse-rtl--780bf'
      }),
      (t.exports = e);
  }
]);
